<!-- // ┌───────────────────────────────────────────────────────────────┐ \\
// │ MAPROOM - Interactive Map Paths                                    │ \\
// ├────────────────────────────────────────────────────────────────────┤ \\
// │ Copyright © 2015 Maproom (http://maproom.net)                      │ \\
// │ Copyright © 2015 Thameside Media (http://thamesidemedia.com)       │ \\
// | All rights reserved                                                | \\
// ├────────────────────────────────────────────────────────────────────┤ \\
// │ Licensed Strictly Under Maproom Terms                              │ \\
// | See http://maproom.net/royalty-free-license                        | \\
// | The use of this work outside of these terms is prohibited          | \\
// | This copyright notice must not be removed                          | \\
// | Unauthorised use can be detected even if copyright is removed      | \\
// └────────────────────────────────────────────────────────────────────  -->

<div #buttoncontainer>
  <button class="selection-button" pButton label="Select All" (click)="selectAreas(true)"></button>
  <button
    class="selection-button"
    pButton
    label="Select None"
    (click)="selectAreas(false)"
  ></button>
</div>

<div class="key-container">
  <div class="key-text" style="">Unselected</div>
  <div class="key-text">Selected</div>
</div>
<div class="key-container">
  <div class="key-unselected" style=""></div>
  <div class="key-selected"></div>
</div>

<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="62.1 62.1 1437.9 1370.9"
  enable-background="new 62.1 62.1 1437.9 1370.9"
  xml:space="preserve"
>
  <g id="Postcode_Text">
    <text id="E1-text" transform="matrix(1 0 0 1 904.1533 799.2188)">E1</text>
    <text id="E1W-text" transform="matrix(1 0 0 1 882.6045 851.9004)">E1W</text>
    <text id="E2-text" transform="matrix(1 0 0 1 892.166 743.9165)">E2</text>
    <text id="E3-text" transform="matrix(1 0 0 1 989.6582 750.9941)">E3</text>
    <text id="E4-text" transform="matrix(1 0 0 1 1056.6377 259.7344)">E4</text>
    <text id="E5-text" transform="matrix(1 0 0 1 919.6426 595.8872)">E5</text>
    <text id="E6-text" transform="matrix(1 0 0 1 1231.9775 775.6094)">E6</text>
    <text id="E7-text" transform="matrix(1 0 0 1 1148.8486 656.5166)">E7</text>
    <text id="E8-text" transform="matrix(1 0 0 1 879.752 675.9238)">E8</text>
    <text id="E9-text" transform="matrix(1 0 0 1 959.4258 671.543)">E9</text>
    <text id="E10-text" transform="matrix(1 0 0 1 998.9014 581.1729)">E10</text>
    <text id="E11-text" transform="matrix(1 0 0 1 1109.541 552.354)">E11</text>
    <text id="E12-text" transform="matrix(1 0 0 1 1199.6475 630.7466)">E12</text>
    <text id="E13-text" transform="matrix(1 0 0 1 1133.6982 755.3047)">E13</text>
    <text id="E14-text" transform="matrix(1 0 0 1 1012.248 865.0371)">E14</text>
    <text id="E15-text" transform="matrix(1 0 0 1 1064.7109 707.9761)">E15</text>
    <text id="E16-text" transform="matrix(1 0 0 1 1149.1289 845.042)">E16</text>
    <text id="E17-text" transform="matrix(1 0 0 1 992.4512 467.2891)">E17</text>
    <text id="E18-text" transform="matrix(1 0 0 1 1124.958 449.6025)">E18</text>
    <text id="E20-text" transform="matrix(1 0 0 1 1039.0771 672.813)">E20</text>
    <text id="EC1-text" transform="matrix(1 0 0 1 765.5664 769.2002)">EC1</text>
    <text id="EC2-text" transform="matrix(1 0 0 1 807.0889 801.9999)">EC2</text>
    <text id="EC3-text" transform="matrix(1 0 0 1 832.0645 829.002)">EC3</text>
    <text id="EC4-text" transform="matrix(1 0 0 1 765.6885 821.0098)">EC4</text>
    <text id="N1-text" transform="matrix(1 0 0 1 790.0244 702.9316)">N1</text>
    <text id="N1C-text" transform="matrix(1 0 0 1 703.8057 712.082)">N1C</text>
    <text id="N2-text" transform="matrix(1 0 0 1 582.416 463.8701)">N2</text>
    <text id="N3-text" transform="matrix(1 0 0 1 512.543 413.9204)">N3</text>
    <text id="N4-text" transform="matrix(1 0 0 1 774.2871 549.5938)">N4</text>
    <text id="N5-text" transform="matrix(1 0 0 1 785.127 630.0786)">N5</text>
    <text id="N6-text" transform="matrix(1 0 0 1 635.1089 539.6167)">N6</text>
    <text id="N7-text" transform="matrix(1 0 0 1 727.1465 634.7539)">N7</text>
    <text id="N8-text" transform="matrix(1 0 0 1 727.8301 485.3555)">N8</text>
    <text id="N9-text" transform="matrix(1 0 0 1 911.6133 276.2207)">N9</text>
    <text id="N10-text" transform="matrix(1 0 0 1 648.1646 437.4771)">N10</text>
    <text id="N11-text" transform="matrix(1 0 0 1 655.436 344.4434)">N11</text>
    <text id="N12-text" transform="matrix(1 0 0 1 542.3516 343.3594)">N12</text>
    <text id="N13-text" transform="matrix(1 0 0 1 759.2734 327.959)">N13</text>
    <text id="N14-text" transform="matrix(1 0 0 1 684.0898 238.248)">N14</text>
    <text id="N15-text" transform="matrix(1 0 0 1 832.3857 492.8296)">N15</text>
    <text id="N16-text" transform="matrix(1 0 0 1 837.6475 583.6953)">N16</text>
    <text id="N17-text" transform="matrix(1 0 0 1 860.4375 423.4253)">N17</text>
    <text id="N18-text" transform="matrix(1 0 0 1 877.8096 348.1006)">N18</text>
    <text id="N19-text" transform="matrix(1 0 0 1 682.0728 575.7271)">N19</text>
    <text id="N20-text" transform="matrix(1 0 0 1 512.043 268.5522)">N20</text>
    <text id="N21-text" transform="matrix(1 0 0 1 772.6455 237.21)">N21</text>
    <text id="N22-text" transform="matrix(1 0 0 1 736.7285 413.4722)">N22</text>
    <text id="NW1-text" transform="matrix(1 0 0 1 635.1045 724.9097)">NW1</text>
    <text id="NW2-text" transform="matrix(1 0 0 1 416.2764 598.3647)">NW2</text>
    <text id="NW3-text" transform="matrix(1 0 0 1 559.8955 619.9409)">NW3</text>
    <text id="NW4-text" transform="matrix(1 0 0 1 416.5777 461.7915)">NW4</text>
    <text id="NW5-text" transform="matrix(1 0 0 1 637.311 644.0405)">NW5</text>
    <text id="NW6-text" transform="matrix(1 0 0 1 483.4283 685.7876)">NW6</text>
    <text id="NW7-text" transform="matrix(1 0 0 1 390.1421 340.7314)">NW7</text>
    <text id="NW8-text" transform="matrix(1 0 0 1 557.1152 727.2886)">NW8</text>
    <text id="NW9-text" transform="matrix(1 0 0 1 316.2027 482.688)">NW9</text>
    <text id="NW10-text" transform="matrix(1 0 0 1 325.5088 695.1929)">NW10</text>
    <text id="NW11-text" transform="matrix(1 0 0 1 482.9229 516.6987)">NW11</text>
    <text id="SE1-text" transform="matrix(1 0 0 1 787.5869 887.9639)">SE1</text>
    <text id="SE2-text" transform="matrix(1 0 0 1 1374.3242 938.5762)">SE2</text>
    <text id="SE3-text" transform="matrix(1 0 0 1 1115.0947 1029.8174)">SE3</text>
    <text id="SE4-text" transform="matrix(1 0 0 1 958.5137 1072.3359)">SE4</text>
    <text id="SE5-text" transform="matrix(1 0 0 1 796.4092 1010.8115)">SE5</text>
    <text id="SE6-text" transform="matrix(1 0 0 1 1012.457 1178.6475)">SE6</text>
    <text id="SE7-text" transform="matrix(1 0 0 1 1154.9531 950.7881)">SE7</text>
    <text id="SE8-text" transform="matrix(1 0 0 1 971.125 957.0869)">SE8</text>
    <text id="SE9-text" transform="matrix(1 0 0 1 1218.0791 1139.7373)">SE9</text>
    <text id="SE10-text" transform="matrix(1 0 0 1 1027.8232 988.7842)">SE10</text>
    <text id="SE11-text" transform="matrix(1 0 0 1 732.001 934.9404)">SE11</text>
    <text id="SE12-text" transform="matrix(1 0 0 1 1102.7734 1136.9053)">SE12</text>
    <text id="SE13-text" transform="matrix(1 0 0 1 1027.4863 1079.0322)">SE13</text>
    <text id="SE14-text" transform="matrix(1 0 0 1 929.7344 998.3818)">SE14</text>
    <text id="SE15-text" transform="matrix(1 0 0 1 864.2012 1019.6777)">SE15</text>
    <text id="SE16-text" transform="matrix(1 0 0 1 901.6465 902.498)">SE16</text>
    <text id="SE17-text" transform="matrix(1 0 0 1 790.2158 941.7012)">SE17</text>
    <text id="SE18-text" transform="matrix(1 0 0 1 1248.2168 968.1689)">SE18</text>
    <text id="SE19-text" transform="matrix(1 0 0 1 800.2119 1271.2373)">SE19</text>
    <text id="SE20-text" transform="matrix(1 0 0 1 878.4629 1299.4639)">SE20</text>
    <text id="SE21-text" transform="matrix(1 0 0 1 810.1533 1163.5098)">SE21</text>
    <text id="SE22-text" transform="matrix(1 0 0 1 853.3438 1100.6611)">SE22</text>
    <text id="SE23-text" transform="matrix(1 0 0 1 906.1406 1154.9248)">SE23</text>
    <text id="SE24-text" transform="matrix(1 0 0 1 766.0254 1098.5381)">SE24</text>
    <text id="SE25-text" transform="matrix(1 0 0 1 830.9346 1357.6689)">SE25</text>
    <text id="SE26-text" transform="matrix(1 0 0 1 888.9297 1225.4844)">SE26</text>
    <text id="SE27-text" transform="matrix(1 0 0 1 759.9541 1215.7334)">SE27</text>
    <text id="SE28-text" transform="matrix(1 0 0 1 1328.8369 872.2578)">SE28</text>
    <text id="SW1-text" transform="matrix(1 0 0 1 653.1826 903.8945)">SW1</text>
    <text id="SW2-text" transform="matrix(1 0 0 1 710.9146 1127.9453)">SW2</text>
    <text id="SW3-text" transform="matrix(1 0 0 1 586.0703 938.5762)">SW3</text>
    <text id="SW4-text" transform="matrix(1 0 0 1 654.4097 1071.7471)">SW4</text>
    <text id="SW5-text" transform="matrix(1 0 0 1 509.5357 924.2578)">SW5</text>
    <text id="SW6-text" transform="matrix(1 0 0 1 473.8438 1000.9512)">SW6</text>
    <text id="SW7-text" transform="matrix(1 0 0 1 555.2715 894.3086)">SW7</text>
    <text id="SW8-text" transform="matrix(1 0 0 1 665.3037 988.7832)">SW8</text>
    <text id="SW9-text" transform="matrix(1 0 0 1 727.2812 1028.5186)">SW9</text>
    <text id="SW10-text" transform="matrix(1 0 0 1 538.0073 963.666)">SW10</text>
    <text id="SW11-text" transform="matrix(1 0 0 1 569.5728 1036.1123)">SW11</text>
    <text id="SW12-text" transform="matrix(1 0 0 1 626.8242 1140.9199)">SW12</text>
    <text id="SW13-text" transform="matrix(1 0 0 1 369.6255 998.7832)">SW13</text>
    <text id="SW14-text" transform="matrix(1 0 0 1 290.6084 1059.0684)">SW14</text>
    <text id="SW15-text" transform="matrix(1 0 0 1 360.1729 1115.6787)">SW15</text>
    <text id="SW16-text" transform="matrix(1 0 0 1 685.2354 1259.6582)">SW16</text>
    <text id="SW17-text" transform="matrix(1 0 0 1 577.7251 1207.5586)">SW17</text>
    <text id="SW18-text" transform="matrix(1 0 0 1 500.0288 1117.6172)">SW18</text>
    <text id="SW19-text" transform="matrix(1 0 0 1 447.0933 1235.6035)">SW19</text>
    <text id="SW20-text" transform="matrix(1 0 0 1 382.9654 1299.3682)">SW20</text>
    <text id="W1-text" transform="matrix(1 0 0 1 646.2612 818.9346)">W1</text>
    <text id="WC1-text" transform="matrix(1 0 0 1 701.7422 781.5283)">WC1</text>
    <text id="WC2-text" transform="matrix(1 0 0 1 713.7422 822.29)">WC2</text>
    <text id="W2-text" transform="matrix(1 0 0 1 551.1128 818.9346)">W2</text>
    <text id="W3-text" transform="matrix(1 0 0 1 299.2437 828.1592)">W3</text>
    <text id="W4-text" transform="matrix(1 0 0 1 310.7998 939.5635)">W4</text>
    <text id="W5-text" transform="matrix(1 0 0 1 208.9522 817.4043)">W5</text>
    <text id="W6-text" transform="matrix(1 0 0 1 410.5201 919.1445)">W6</text>
    <text id="W7-text" transform="matrix(1 0 0 1 100.0322 819.1201)">W7</text>
    <text id="W8-text" transform="matrix(1 0 0 1 509.9395 874.1445)">W8</text>
    <text id="W9-text" transform="matrix(1 0 0 1 514.3506 763.5947)">W9</text>
    <text id="W10-text" transform="matrix(1 0 0 1 434.5293 775.8037)">W10</text>
    <text id="W11-text" transform="matrix(1 0 0 1 471.0703 828.7471)">W11</text>
    <text id="W12-text" transform="matrix(1 0 0 1 389.604 836.123)">W12</text>
    <text id="W13-text" transform="matrix(1 0 0 1 146.5132 797.1973)">W13</text>
    <text id="W14-text" transform="matrix(1 0 0 1 455.2613 889.459)">W14</text>
  </g>

  <g id="Postcode_Areas">
    <a (click)="SelectCode('NW10')">
      <path
        [class.selected]="IsSelected('NW10')"
        id="NW10"
        d="
		M459.2,730.2c-0.2-4.5-1.3-9.1-3.2-13.2c-0.6-1.2-1.2-2.4-0.9-3.6c0.6-2.7,4.7-3.1,5.6-5.6c1.8,0.2,3.5,0.4,5.3,0.6
		c0.4-5.5-3.4-10.3-7.1-14.5c-0.6-0.7-1.2-1.3-2-1.5c-1.1-0.3-2.3,0.2-3.4-0.1c-2.5-0.7-2.9-5.1-5.6-5.2c-0.8,0-1.7,0.5-2.5,0.6
		c-1.5,0.1-2.8-1.5-2.9-3c-0.2-1.5,0.5-3,1.2-4.4c-1.1-0.9-2.7-1.2-4-0.7l0.8-0.8c-0.3,2.6-6.1,1.8-7.6-0.3c-1.6-2.1-1.6-5-2.1-7.6
		c-0.6-3.2-2.1-6.2-4.2-8.6c-0.4-1.4,1.3-2.5,2.9-2.3c1.5,0.2,2.8,0.9,4.3,0.9c1.8,0,3.5-1.6,3.7-3.4c0.4-3.7-4.4-5.9-8-5.3
		c-0.5,1.3-2,2-3.4,2.4c-12,3.4-26-1.4-33.2-11.7c-1.7-2.4-2.9-6-0.8-8.1s5.6-0.8,8.4,0.6c8.9,4.2,18.7,6.4,28.6,6.3
		c-3.4-4.3-5.3-9.7-5.5-15c-0.1-1.8,0.1-3.7-0.8-5.2c-0.5-0.8-1.3-1.6-1.8-2.4c-1.1-2.2-0.3-5.4-2.2-6.8c-0.8-0.7-2-0.7-3.1-0.8
		c-8.8-0.5-17.5-3.1-25-7.6c-1.8-1.1-3.5-2.3-5.5-2.5c-3.3-0.5-6.4,1.4-9.2,3c-0.7,0.3-1.4,0.8-2.2,0.7c-1.8-0.1-2.9-2.1-4-3.6
		c-1.8-2.6-4.7-4.5-7.8-5.1c-2.9-0.6-6.9-0.8-7.6-3.7c4.3-4.4,4.2-11.3,3.4-17.4c-0.8-6-1.8-12.6,1.2-18l0.2,0.3
		c-1.3,0.8-2.6,1.4-3.9,2.2c-4,2.2-8.1,4.4-12.7,5.2c-1.3,0.3-2.7,0.3-3.7,1.2c-1,0.8-1.3,2.2-1.7,3.4c-1.2,4.5-2.3,9.1-3.4,13.7
		l-0.2,0.2c0.1,2.3-3.9,4.3-5.5,5.5c-1.8,1.5-3.8,2.9-5.6,4.4l-2.1,8.3l-3.6,13.3c1.6,3.1,4.4,6.9,4.7,10.5c0.3,4.5-4,6.4-5.3,10.1
		l-4.4,13.7l-4.4,10.5l-5.7,9c-4.1,0.3-8.1,0.6-12.3,0.8c-3.2,0.2-9.4-0.9-5.8,3.9c1.2,1.6,2.7,2.9,3.8,4.5l-1.6,10.8l-6.4,2.7
		c0,0-7,3.4-6.9,7.5c0.1,4-9.8,6.8-9.8,6.8l-7,7c0,0-3.1-2-3.6-2c-1.3-0.1-2.9,0.9-4,1.5l-4.3,3.3c2.9,2.4,3.4,7.1,1.1,10.1
		c-2.4,0-4.5,2.8-3.7,5.1c1.8-1.2,4.4-1.2,6.3,0c-1.9,2.1-0.8,5.6,1.5,7.3s5.2,1.9,8,2.3c5,0.7,10,1.9,14.8,3.6
		c4.1,1.4,8.1,3.3,11.8,5.6c4.5,2.9,8.8,6.6,14.1,7.2c0.9,0.1,1.8,0.1,2.7-0.3c0.8-0.3,1.4-1.1,2.2-1.4c1.3-0.5,2.7,0,3.9,0.5
		c5.5,2.1,11.2,4.3,16.7,6.4c2.7,1,5.4,2.1,7.6,3.9c2,1.8,4.4,4.4,6.8,3.4c0.2-1.2,0.3-2.3,0.4-3.5c3.4,1.9,6.7,3.9,10,5.8
		c1.8,1,3.7,2.1,5.7,2.4c2.6,0.3,5.1-0.5,7.6-1.2c18-5.1,38-2.8,54.3,6.4c-0.2-2.9,5.9-2.7,6.1-5.6c0.1-0.8-0.3-1.5-0.8-2.2
		c-2.3-3.2-5.9-5.8-6.2-9.7c-0.4-4.6,3.9-8.2,7.6-10.9c4,2.9,9.4-1.3,14.4-0.9c2.5,0.2,4.9,1.6,7.4,1.8c3.7,0.3,7-2.2,10.6-3.4
		c2.9-1,6-1.3,9-0.7c-1.7-0.9-1.9-3.3-1.6-5.1s1.1-3.8,0.6-5.7c-0.7-2.6-3.5-4.8-2.7-7.3"
      />
    </a>
    <a (click)="SelectCode('NW9')">
      <path
        [class.selected]="IsSelected('NW9')"
        id="NW9"
        d="
		M333.3,583c1.2-4.5,2.3-9.1,3.4-13.7c0.3-1.3,0.7-2.6,1.7-3.4c1-0.8,2.4-1,3.7-1.2c4.5-0.8,8.6-3,12.7-5.2s8.1-4.4,12-6.5
		c4-2.2,8.2-4.5,11-8.2c0.8-1.1,1.5-2.3,2.5-3.1c2.3-1.9,5.7-1.8,8.8-1.4c3.9,0.4,7.7,0.8,11.7,1.2c6,0.6,13.4,0.4,16-5
		c-0.6-2.9-2.5-5.1-4.4-7.3c-5-5.6-9.9-11.2-14.8-16.9c-1-1.2-2-2.3-2.3-3.8c-0.8-2.9,1.4-5.9,1-8.9c-0.3-1.8-1.4-3.4-2.1-5.1
		c-3.8-9.3,7.1-19.6,4.4-29.2c-0.6-2-1.8-4-1.1-6c0.7-2.1,3-3.1,4.4-4.8c2.9-3.4,1.6-8.4,0.6-12.8c-2.8-12.2-1.5-24.8-0.3-37.3
		l-0.4,0.1l-12.3-17l-2-7.6l-3.4-3.8l-7.2,6l-3.7-3.3l-0.8,0.8c-1.1,2.2-4.8,4.3-6.6,5.9l-9.2,3.7l-4.6,8.6l-7.1,17.2l-6.5,0.8
		l-11.6,7.5l-10.2,7c0,0-11,4.6-12.5,4.9s-13.8,1-13.8,1l-12.6,1.4c-1.4,0.2-3.1,1.3-4.4,1.8c-1.7,0.7-5.8,1.4-7,2.8
		c-2.2,2.5,0.4,9.1,0.8,12.1l3,5.4c0,0,1,16.9,2,19.9s2.5,9.1,1.7,13.8c-0.8,4.7,6.9,4.2,6.9,4.2L278,503c1.3,2.7,2.4,5.4,3.7,8.1
		c1.2,2.5,5.3,8.6,4.7,11.2c-0.3,1.7,4.7-0.9,4.9-1c1.3-0.7,2.4-1.3,3.7-1.9l5.7,13l4.9,11.4l0.4,7l0.8,6.6l4.5,2.4l7.6,6.6l7.3,9.5
		c1.8,1.6,6.8,4.9,7,7.4L333.3,583z"
      />
    </a>
    <a (click)="SelectCode('NW4')">
      <path
        [class.selected]="IsSelected('NW4')"
        id="NW4"
        d="
		M402.1,404.6c-1.3,12.4-2.5,25.1,0.3,37.3c1,4.3,2.3,9.4-0.6,12.8c-1.4,1.7-3.8,2.7-4.4,4.8c-0.6,1.9,0.5,4,1.1,6
		c2.9,9.7-8.1,19.9-4.4,29.2c0.7,1.8,1.8,3.3,2.1,5.1c0.4,3-1.8,6-1,8.9c0.3,1.4,1.4,2.7,2.3,3.8c5,5.6,9.9,11.2,14.8,16.9
		c1.9,2.2,3.9,4.5,4.4,7.3l-0.1,0.2c3.4,1.7,7.9,0.1,11.6-1.5c4-1.8,8.1-3.7,11.7-6.3c2.8-2.1,5.3-4.7,8.6-5.7
		c1.8-0.5,3.7-0.5,5.5-1.3c7.2-3,6.5-16.2,14.3-17.4c-1.9-7.9,9.1-14.4,7.6-22.3c-0.5-2.6-2.3-4.7-3.3-7s-0.8-5.8,1.4-7
		c2.1-1.2,4.7,0.2,7,0.8c2.3,0.5,5.7-1,5-3.3l-1.7-4.4c-3.5-1.8-7.1-3.7-10.7-5.5c1.2-4.7,2.1-10.4-1.5-13.6
		c-0.9-0.8-2.2-1.4-2.9-2.4s-0.8-2.8,0.3-3.4c2.4,0.4,5,0,7.2-1c0-2.4,0.6-5,1.7-7.1c1.3-2.8,3.6-5.4,3.9-8.5
		c0.1-1.4-0.2-2.8-0.3-4.2c-0.3-3,0.1-5.1,1.6-7.7l-7.6-4.4l-6.1-3.9l-7.4,3.6l-9.4-3l-5.7-11.6l-6.1-5.4l-10.8-3.1l-7.3,2.5
		l-1.2,13.4l-4.7,1.6l-6.2,0.3l-6.5,6.2L402,405L402.1,404.6z"
      />
    </a>
    <a (click)="SelectCode('NW2')">
      <path
        [class.selected]="IsSelected('NW2')"
        id="NW2"
        d="
		M517,582.8c0.6-0.3,0.9-1.3,1.6-1.3c3.2,0,5.6,2.7,7.7,5.2c0.7,0.8,1.3,1.6,1.3,2.6c0.1,1.7-1.5,2.9-3.1,3.4
		c-1.6,0.4-3.4,0.3-5,0.8c-3.7,1.2-5.7,6-3.9,9.5c1.4,2.8,1.1,6.4-0.9,8.7c-2,2.4-5.5,3.4-8.5,2.5c-2.3-0.7-4,2-4.4,4.4
		c-0.4,2.3-0.8,5.1-3,6c-1.4,0.6-1.3,2.8-0.4,4c0.8,1.3,2,2.6,1.8,4.2c-0.3,1.8-2.3,2.8-4.1,3c-1.8,0.3-3.9,0.3-5.1,1.7
		c-1.3,1.3-0.6,4.3,1.3,3.9c3.2-0.6,6.5,1.6,8.1,4.4c1.6,2.9,2,6.2,2.3,9.5c-3.6,1.3-7.4,2.3-11.1,3.1c-0.1,1.6-0.1,3.1-0.2,4.7
		c-6.7,0.7-13.4,2.1-19.8,4.3c-2.7,0.9-5.8,2.6-6,5.5c-1.3-0.4-2.5-0.8-3.8-1.3c-0.6-2.8,3.9-4.5,3.7-7.3c-0.3-2.8-4.2-3-6.9-2.3
		c-0.2,0.7-0.3,1.3-0.5,2c-3.8,0.1-7.6-0.3-11.3-1.2c-1.3,0.2-1.7,2-1.3,3.2c0.4,1.2,1.4,2.3,1.5,3.7c0.3,2.9-3.4,4.4-6.2,5.1
		c-0.2,1.3-0.3,2.5-0.5,3.8c-0.3,2.6-6.1,1.8-7.6-0.3c-1.6-2.1-1.6-5-2.1-7.6c-0.6-3.2-2.1-6.2-4.2-8.6c-0.4-1.4,1.3-2.5,2.9-2.3
		c1.5,0.2,2.8,0.9,4.3,0.9c1.8,0,3.5-1.6,3.7-3.4c0.4-3.7-4.4-5.9-8-5.3c-0.5,1.3-2,2-3.4,2.4c-12,3.4-26-1.4-33.2-11.7
		c-1.7-2.4-2.9-6-0.8-8.1s5.6-0.8,8.4,0.6c8.9,4.2,18.7,6.4,28.6,6.3c-3.4-4.3-5.3-9.7-5.5-15c-0.1-1.8,0.1-3.7-0.8-5.2
		c-0.5-0.8-1.3-1.6-1.8-2.4c-1.1-2.2-0.3-5.4-2.2-6.8c-0.8-0.7-2-0.7-3.1-0.8c-8.8-0.5-17.5-3.1-25-7.6c-1.8-1.1-3.5-2.3-5.5-2.5
		c-3.3-0.5-6.4,1.4-9.2,3c-0.7,0.3-1.4,0.8-2.2,0.7c-1.8-0.1-2.9-2.1-4-3.6c-1.8-2.6-4.7-4.5-7.8-5.1c-2.9-0.6-6.9-0.8-7.6-3.7
		c4.3-4.4,4.2-11.3,3.4-17.4c-0.8-6-1.8-12.6,1.2-18l0.2,0.3c2.7-1.5,5.4-2.9,8.1-4.4c4-2.2,8.2-4.5,11-8.2c0.8-1.1,1.5-2.3,2.5-3.1
		c2.3-1.9,5.7-1.8,8.8-1.4c3.9,0.4,7.7,0.8,11.7,1.2c6,0.6,13.4,0.4,16-5l-0.1,0.2c3.4,1.7,7.9,0.1,11.6-1.5c4-1.8,8.1-3.7,11.7-6.3
		c2.8-2.1,5.3-4.7,8.6-5.7c1.8-0.5,3.7-0.5,5.5-1.3c1.3-0.6,2.4-1.5,3.4-2.7l-0.2-0.1c1.6-2.9,5.7-4.1,8.6-2.5
		c-1.8,3.1-3.6,6.1-5.5,9.2c2.3,3.8,10,0.4,12,4.4c0.9,1.8,0,3.9-0.2,5.8c-0.4,4.6,4.2,9,8.8,8.3c0.5,2.7,0.4,5.5-0.2,8.1
		c1.8,0.3,3.9,0.1,5.6-0.6c-0.2,3.9,3.4,7.8,1.6,11.2c-0.6,1.3-1.8,2.1-2.9,2.9c-8.1,6-15.4,13-21.7,20.9c3.9,1.7,8.2-1.1,10.8-4.4
		c2.6-3.3,4.5-7.3,8.1-9.5c3.9-2.4,9.9-3.3,10.7-7.7c0.3-1.2,0-2.4,0.3-3.6c0.3-1.2,1.1-2.4,2.3-2.3c1,0.1,1.8,1,2.6,1.6
		c2.5,1.8,6.1,0,9,1.2c1.8,0.8,3,2.5,3.8,4.4c2.3,5,2.9,10.7,1.8,16.1c1.6,0.1,3.1,0.1,4.7,0.2L517,582.8z"
      />
    </a>
    <a (click)="SelectCode('NW11')">
      <path
        [class.selected]="IsSelected('NW11')"
        id="NW11"
        d="
		M536.8,449.6c0.3-0.3,0.7-0.8,1-1l-0.7,0.3c2.5,3.9,7,6.5,11.7,6.7c0.9,0,1.9,0,2.9,0.3c3.2,1,3.8,5.5,6.5,7.4
		c1.7,1.1,4.5,2.3,3.6,4c-0.4,0.8-1.5,1.1-1.8,1.9s0.2,1.7,0.5,2.5c1.4,3.4,0.3,7.6-2.8,9.7c3.9,5.8,5.5,13.1,4.5,20.1
		c-0.2,1.2-0.4,2.3-0.1,3.5c0.3,0.9,0.8,1.7,1.3,2.4c1.6,2.9,1.3,6.5,2.3,9.7c1.9,5.8,7.8,9.1,13.3,12c-0.5-0.3-2.7,7.6-2.8,8.3
		c-0.2,1.4-0.2,2.9,0.2,4.3c0.3,1.3,1.4,2.5,1.3,3.8c-0.1,1.3-1.6,2.3-2.8,2.2c-0.8-0.1-1.6-0.4-2.3-0.2c-0.7,0.3-1,1.1-1.3,1.8
		c-0.6,1.7-1.1,3.6-1.8,5c-6.5-5.3-11.5,0.3-16.4,4.2c-3.6,2.9-8.3,3.9-10.8,8.1c-5.3-1.3-10.1-4.4-13.4-8.6
		c-3.3-0.2-6.4,2.6-6.6,5.9c-0.1,1.3,0.2,2.6,0.1,3.9c-0.3,2.8-2.4,5-4,7.3s-2.7,5.6-0.9,7.7c-1.6-0.1-3.1-0.1-4.7-0.2
		c1.2-5.4,0.5-11.1-1.8-16.1c-0.8-1.8-2-3.6-3.8-4.4c-2.9-1.2-6.5,0.6-9-1.2c-0.8-0.6-1.5-1.6-2.6-1.6c-1.2-0.1-2.1,1.2-2.3,2.3
		c-0.3,1.2,0,2.4-0.3,3.6c-0.8,4.5-6.9,5.3-10.7,7.7c-3.5,2.3-5.5,6.2-8.1,9.5s-7,6-10.8,4.4c6.2-7.9,13.5-14.9,21.7-20.9
		c1.1-0.8,2.3-1.7,2.9-2.9c1.7-3.4-1.8-7.4-1.6-11.2c-1.8,0.7-3.7,0.9-5.6,0.6c0.7-2.7,0.8-5.5,0.2-8.1c-4.6,0.7-9.2-3.7-8.8-8.3
		c0.2-1.9,1.1-4,0.2-5.8c-2-4-9.7-0.6-12-4.4c1.8-3.1,3.6-6.1,5.5-9.2c-2.9-1.6-5-1.1-7.4,0.9c3-5,4.2-12.3,9.8-13.1
		c-1.9-7.9,9.1-14.4,7.6-22.3c-0.5-2.6-2.3-4.7-3.3-7s-0.8-5.8,1.4-7c2.1-1.2,4.7,0.2,7,0.8c2.3,0.5,5.7-1,5-3.3c3-1.3,5-2,8.1-3.4
		c4.5-1.9,9.2-3.9,14.1-3.5c3.5,0.3,7.4,1.9,10.6,0.3c1.7-0.8,2.9-2.4,4.6-3.1c2.9-1.1,6.3,0.6,9.1-0.8c1-0.5,5-5.9,5.2-5.8"
      />
    </a>
    <a (click)="SelectCode('NW7')">
      <path
        [class.selected]="IsSelected('NW7')"
        id="NW7"
        d="
		M372.7,378.5c0.5-2.5,0.1-6.7-1.3-8.5c-2.1-2.5-6.7-0.7-8.5-2.9c-2.7-3.3,3.1-8.9-0.9-12.7c-3-2.9-10.8-3.4-14.8-3.5
		c-1.2,0-2.3,0-3.4,0.3c-5.3,1.3-12.3,5.4-17.9,2.8l0,0c-2.3-1.1-3.4-9.1-1.7-8.6c4.4,1,5.5,2.2,8.1-0.8c1.7-1.9,2.2-6.7,5.6-6.7
		c1.3,0,2.9-1.1,2.4-2.3c-0.2-0.5-0.6-0.8-0.9-1.2c-1.3-1.3-4.1-5-3.4-7.1c0.6-1.7,3.4-1.1,3.5-2.8c0.1-0.4-0.2-0.8-0.3-1.3
		c-0.6-1.3-0.8-2.9-0.6-4.3c5.1,0.9,6,0.2,6.8-4.6c0.3-1.9,1.5-6.3-0.9-7.4c-1.2-0.5-2.6-0.8-3.3-1.8c-1.7-2.3,0.2-4.9-2.3-7
		c-2.3-2.1-4.5,0.1-4.9-4.4c-0.2-2.8-2.7-4.4-3-6.8c-0.3-2.3,1.1-4.3,1.8-6.3c1.1-3.3,0.3-7,1.6-10.2c1.1-2.8,3.7-5,3.6-8.1
		c-3.3-1.7-10.4,1.5-14,2.2l-12-8.4l-13.6-13.3l2-12.3l21.4-3.8l8.5,5.8l14.4-8.5l8.8-1.3l13,8.8l5.2,11.2l6-2.3l7.4,1.1l13.8-5.2
		l15.9,5l5.5,6.1l-15.2,11l7.8,21.9l9.1,7.7l21.7,3.7l20.9-6.8l10.3,3.6l13.6,5.5l3.4,16.4l-6.4,12.3l8,15.8l4.9,3.9l2.3,6l5.7,4.6
		l3.5,10.8l-5.1,7.6l-5.1,3.4l1.4,13.2l-1.2,4.2l-4.9-3.9l-1.3,7l-6.5,1.7l-2,7.5l-1.9,3.2l-7.6-4.4l-6.1-3.9l-7.4,3.6l-9.4-3
		l-5.7-11.6L441,383l-10.8-3.1l-7.3,2.5l-1.2,13.4l-4.7,1.6l-6.2,0.3l-6.5,6.2l-2.6,0.7l-12.3-17l-2-7.6l-3.4-3.8l-7.2,6l-3.7-3.3
		L372.7,378.5z"
      />
    </a>
    <a (click)="SelectCode('NW8')">
      <path
        [class.selected]="IsSelected('NW8')"
        id="NW8"
        d="
		M542.9,717.3c7.6,12.3,16.7,23.7,26.9,34c-2.4,1-3.1,4.3-2.1,6.7c0.9,2.2,3.4,3.4,4.3,5.3l0.8-0.5c2.4,0.2,4.6,3.6,6,5.7
		c1.5,2.2,3.4,3.6,5.3,5.5c0.6,0.7,1.2,1.3,1.8,2l2.5,0.9c3.4,0.4,7-1.2,9.1-3.9c2.1-2.8,2.6-6.7,1.3-9.9c3.1-0.4,6.1-1.8,8.6-3.7
		c-1-2.9-2-5.8-3-8.7c4-2.3,7-6.5,7.6-11.1c-2.3-0.1-4.7-0.3-6.8-1.3s-3.8-3.2-3.5-5.5c0.3-2.4,2.5-4.1,4.6-5.4
		c6-3.5,12.7-6.3,17.1-11.6c4.4-5.3,5.6-14.3,0.3-18.5l-0.7,0.6c-9.2-3.4-19.5-4.1-29.1-2.1c-1.3-7.1-7.6-13-14.9-13.7
		c-0.8-0.1-1.8-0.1-2.5-0.6l-0.4,0.6c-2.9,0.7-5.8,1.4-8.7,2.1c-2.2,0.5-4.4,1-6.5,1.6c-3.5,0.8-7,1.7-10.3,3c-5,2-9.5,5-13.2,8.9
		c-0.3,0.3-0.5,0.5-0.7,0.8c-0.5,1.3,1,2.3,2.3,2.9c2.4,1.1,5,2.1,6.9,4s2.6,5.1,1.1,7.3c-2.3-0.3-4.4,2.4-3.5,4.6L542.9,717.3z"
      />
    </a>
    <a (click)="SelectCode('NW1')">
      <path
        [class.selected]="IsSelected('NW1')"
        id="NW1"
        d="
		M640.1,666.9c13.4-7.3,30.1-8.4,44.4-2.9c2.9,1.1,6.5,2.4,8.9,0.5c1.4-1.1,1.9-2.9,2.6-4.6c1.8-4.3,5.5-7.6,10-9.1
		c5.2,2.3,8.6,7.9,8.5,13.6c0.3,3.7,0.7,7.3,0.9,11c2.8,2.5,3.4,7.1,1.4,10.3l-0.6,0.8c-1.6-0.2-3.2-0.4-4.9-0.9
		c-2-0.6-4.6-0.7-6.4-1.8c-2-1.3-2.4-3.9-5-4.4c-1.9,3.8,1.4,11.7,2.3,15.5c0.6,3,1.7,6.5,4.6,7.4c-1.3,1.8-2.5,3.5-3,5.5
		c-0.5,2.1-0.2,4.5,1.5,5.9c2.3,2,6.6,1.3,8.2,3.9c1.4,2.5-1,5.5-1.8,8.2c-1.1,3.5,0.7,7.6,3.9,9.3c3.3,1.7,7.6,0.6,9.8-2.4h0.1
		c0.8,1.5,2.2,2.7,4.1,3.2l0.5-0.3c-3,1.3-6,2.7-8.9,4.3c-9.1,4.9-17.5,10.7-26.8,15.3c-3.6,3.3-7.1,7-11.2,9.7l-0.1,0.1
		c-0.8-0.6-1.6-1.1-2.5-1.4c-2.8-0.9-5.7-0.3-8.6,0.5c-17.5,4.7-35.1,9.3-52.6,14c-4.3,1.2-8.6,2.3-12.3,4.9s-6.4,6.7-6,11.2
		l-0.1,1.1c-2.7-2.8-5.4-5.6-8-8.4c-1.8-3.7-4.1-7.1-6.8-10.2l2.1,0.4c3.4,0.4,7-1.2,9.1-3.9c2.1-2.8,2.6-6.7,1.3-9.9
		c3.1-0.4,6.1-1.8,8.6-3.7c-1-2.9-2-5.8-3-8.7c4-2.3,7-6.5,7.6-11.1c-2.3-0.1-4.7-0.3-6.8-1.3s-3.8-3.2-3.5-5.5
		c0.3-2.4,2.5-4.1,4.6-5.4c6-3.5,12.7-6.3,17.1-11.6c4.4-5.3,5.6-14.3,0.3-18.5l-0.7,0.6c-1-4.8,0.3-10,3.4-13.7
		c1.2-1.4,2.6-2.6,3.4-4.2c0.8-1.6,0.7-3.9-0.8-4.9c2.9-0.8,6,0.4,9.1,0.1c3-0.3,6-4,3.9-6.2c-0.6-0.4-1.3-0.8-1.8-1.3V666.9z"
      />
    </a>
    <a (click)="SelectCode('NW3')">
      <path
        [class.selected]="IsSelected('NW3')"
        id="NW3"
        d="
		M593.3,537.3c4-1.1,8.5,0.1,11.1,3.4c1.3,1.7,2.1,3.6,2.9,5.6c1.2,3,2.4,6.2,2.1,9.5c-0.3,3.4-2.2,6.4-4.8,8.4
		c-1.1,0.8-2.3,1.5-3.1,2.6c-1.6,2.2-0.8,5.5,0.9,7.5c1.8,2.1,4.4,3.3,6.8,4.4c8.1,4.1,16.2,10,19.1,18.6c0.5,1.6,0.9,3.3,1.8,4.7
		c1.4,2.2,3.9,3.4,6.1,4.9c3.8,2.5,6.9,6,8.8,10.2c0.4,0.9,0.8,1.9,0.4,2.9c-0.2,0.4-0.4,0.7-0.7,1c-2.7,3.1-6.9,4.3-10.7,6
		c-4.1,1.8-7.9,4.5-11.1,7.8c0.3,1.7,2.9,1.5,4,2.8c2.2,2.6-3.5,7.2-0.8,9.2c1.5-1.4,3.9-1.8,5.8-0.8c1.8,1,2.9,3.3,2.5,5.3
		c-0.3,1.2-0.8,2.2-1.3,3.3c-1.8,4.8,1.3,8.8,5.5,11.7c1.2,0.8,2.3,1.6,3.4,2.4c2.1,2.2-0.9,5.9-3.9,6.2s-6.2-0.9-9.1-0.1
		c1.5,1,1.7,3.3,0.8,4.9c-0.8,1.6-2.2,2.9-3.4,4.2c-3.2,3.7-4.4,9-3.4,13.7c-9.2-3.4-19.5-4.1-29.1-2.1c-1.3-7.1-7.6-13-14.9-13.7
		c-0.8-0.1-1.8-0.1-2.5-0.6c-2.9-1.9,0.8-7.9-2.3-9.7c-4.9-2.8-7.8-7.8-11.3-12.1c-3.6-4.3-8.8-8.1-14.3-6.9
		c-1.9,0.4-3.9,1.5-5.8,0.8c-0.2-3.2,1.8-6.4,4.8-7.6c1.3-0.5,2.7-0.8,3.8-1.6s1.8-2.5,0.9-3.5c-1.4-1.7-4.8,0.2-6-1.7
		c-5.7-8.6-18.5-10.8-23.3-20c-1.9-3.7-3.1-8.8-7.2-9.4h0.1c0.8-2.1,0.8-4.6-0.3-6.6c-1.8-3.4,0.2-8.3,3.9-9.5
		c1.6-0.5,3.4-0.4,5-0.8c1.6-0.4,3.2-1.8,3.1-3.4c-0.1-1-0.8-1.8-1.3-2.6c-2-2.4-4.5-5.1-7.7-5.2c-0.4,0-0.7,0.3-1,0.7l-0.3,0.3
		c-1.5-2.2-0.5-5.3,1.1-7.6s3.7-4.4,4-7.3c0.2-1.3-0.2-2.6-0.1-3.9c0.3-3.3,3.4-6,6.6-5.9c3.4,4.2,8.1,7.3,13.4,8.6
		c2.5-4.2,7.3-5.3,10.8-8.1c4.9-3.9,9.9-9.6,16.4-4.2c0.7-1.5,1.3-3.4,1.8-5c0.3-0.8,0.6-1.5,1.3-1.8c0.8-0.3,1.5,0.1,2.3,0.2
		c1.3,0.1,2.7-1,2.9-2.3l0.3,0.2c1.8-1.2,2.6-3.7,3.4-5.8c0.8-2.4,2.6-5.1,5.2-5c2.4,0.2,4.1,2.3,6.5,2.3
		C593.2,536.9,593.3,537.3,593.3,537.3z"
      />
    </a>
    <a (click)="SelectCode('NW5')">
      <path
        [class.selected]="IsSelected('NW5')"
        id="NW5"
        d="
		M629.2,599.4c2.7-1,5.5-2.7,8.1-3.4c2.1-0.5,5.3,0,6.9-1.9c1.2-1.5,1.4-3.5,1.6-5.5c0.7,1.3,2.4,1.9,3.9,1.7s2.9-1.1,4.1-1.9
		c1.5-1,3.2-2.4,2.9-4.2c0.9,0.9,2.5,0.4,3.5-0.4c0.9-0.9,1.6-2.1,2.8-2.8c1.9-1.1,3.7,0.9,4,2.7c3.4-0.8,7,0.9,9.1,3.7
		c2.1,2.9,2.9,6.4,3.4,9.8c1.2,7.5,1.7,15.1,4.7,22c2.5,5.9,6.9,11,12.3,14.4l0.5-0.2c2.5,2,4.9,5.8,4.5,9.1
		c-0.1,0.8-0.3,1.7-0.3,2.5c0.3,2.5,2.8,4.1,5,5.4l-0.3,0.4c-4.4,1.5-8.1,4.9-10,9.1c-0.7,1.7-1.3,3.5-2.6,4.6
		c-2.4,1.9-6,0.7-8.9-0.5c-14.3-5.5-31-4.4-44.4,2.9l-0.3,0.2c-0.3-0.3-0.7-0.4-1-0.7c-4.2-2.9-7.2-7-5.5-11.7
		c0.4-1.1,1.1-2.2,1.3-3.3c0.4-2-0.7-4.3-2.5-5.3s-4.3-0.7-5.8,0.8c-2.7-2,3-6.7,0.8-9.2c-1.1-1.3-3.7-1.1-4-2.8
		c3.2-3.3,7-5.9,11.1-7.8c3.8-1.7,8-2.9,10.7-6c0.3-0.3,0.5-0.7,0.7-1c0.3-0.9,0-1.9-0.4-2.9c-1.9-4.1-5-7.6-8.8-10.2
		c-2.2-1.4-4.7-2.6-6.1-4.9c-0.5-0.8-0.8-1.8-1.2-2.7L629.2,599.4z"
      />
    </a>
    <a (click)="SelectCode('NW6')">
      <path
        [class.selected]="IsSelected('NW6')"
        id="NW6"
        d="
		M576.2,682c-2.9,0.7-5.8,1.4-8.7,2.1c-2.2,0.5-4.4,1-6.5,1.6c-3.5,0.8-7,1.7-10.3,3c-5,2-9.5,5-13.2,8.9c-0.3,0.3-0.5,0.5-0.7,0.8
		c-0.5,1.3,1,2.3,2.3,2.9c2.4,1.1,5,2.1,6.9,4c1.8,1.9,2.6,5.1,1.1,7.3c-2.3-0.3-4.4,2.4-3.5,4.6c-0.6,0.2-1.2,0.3-1.7,0.5l0.3,0.1
		c-0.9-0.9-2-1.5-3.3-1.8c1.1-0.7,2.3-1.4,3.4-2.1c-1.4-2.4-5-3.9-7-2c-1.8,1.8-1.1,5,0.6,7c1.7,1.9,3.9,3.4,5.4,5.5
		c-2.3,1-4.2,2.9-5.3,5.1c-0.3,0.7-0.6,1.4-1.1,2.1c-1,1.3-2.7,1.7-4.1,2.3c-6.3,2.3-11,8.4-11.7,15c-3.2,0.3-5.6-3-6.5-6.1
		c-0.8-3.1-0.8-6.5-2.4-9.3c-3.4-5.8-11.7-6.2-16.5-10.9c-1.1-1-2.2-2.3-3.6-2.2c-0.9,0.1-1.7,0.8-2.5,1.2c-1.3,0.6-2.7,0.6-4.1,0.7
		c-3.9,0.3-7.7,1.6-11.4,2.9c-1.8,0.7-3.5,1.3-5.3,1.9c-2.4,0.9-5,1.8-7.1,3.3c-0.2-4.5-1.3-9.1-3.2-13.2c-0.6-1.2-1.2-2.4-0.9-3.6
		c0.6-2.7,4.7-3.1,5.6-5.6c1.8,0.2,3.5,0.4,5.3,0.6c0.4-5.5-3.4-10.3-7.1-14.5c-0.6-0.7-1.2-1.3-2-1.5c-1.1-0.3-2.3,0.2-3.4-0.1
		c-2.5-0.7-2.9-5.1-5.6-5.2c-0.8,0-1.7,0.5-2.5,0.6c-1.5,0.1-2.8-1.5-2.9-3s0.5-3,1.2-4.4c-1.1-0.9-2.7-1.2-4-0.7l0.8-0.8
		c0.2-1.3,0.3-2.5,0.5-3.8c2.9-0.6,6.5-2.2,6.2-5.1c-0.1-1.3-1.1-2.4-1.5-3.7s-0.1-3,1.3-3.2c3.7,0.9,7.6,1.3,11.3,1.2
		c0.2-0.7,0.3-1.3,0.5-2c2.7-0.7,6.7-0.4,6.9,2.3c0.3,2.9-4.3,4.5-3.7,7.3c1.3,0.4,2.5,0.8,3.8,1.3c0.1-2.9,3.2-4.5,6-5.5
		c6.4-2.2,13-3.7,19.8-4.3c0.1-1.6,0.1-3.1,0.2-4.7c3.8-0.8,7.5-1.8,11.1-3.1c-0.3-3.3-0.8-6.6-2.3-9.5c-1.6-2.9-4.9-5-8.1-4.4
		c-1.8,0.3-2.5-2.6-1.3-3.9c1.3-1.3,3.4-1.3,5.1-1.7c1.8-0.3,3.9-1.2,4.1-3c0.2-1.5-1-2.9-1.8-4.2s-1-3.4,0.4-4c2.2-0.9,2.5-3.8,3-6
		c0.4-2.3,2.2-5,4.4-4.4c2.9,0.9,6.5-0.1,8.5-2.5c0.5-0.7,0.9-1.3,1.3-2.1h-0.1c4.1,0.6,5.3,5.7,7.2,9.4c4.8,9.1,17.6,11.3,23.3,20
		c1.2,1.8,4.6,0,6,1.7c0.9,1,0.2,2.8-0.9,3.5s-2.5,1-3.8,1.6c-2.9,1.3-5,4.4-4.8,7.6c1.8,0.8,3.9-0.3,5.8-0.8
		c5.5-1.3,10.7,2.6,14.3,6.9c3.6,4.3,6.5,9.3,11.3,12.1c3,1.8-0.7,7.7,2.3,9.7"
      />
    </a>
    <a (click)="SelectCode('W13')">
      <path
        [class.selected]="IsSelected('W13')"
        id="W13"
        d="
		M168.8,894.7l-13.5-0.8c-0.2-1-0.3-1.9-0.4-2.9c1.3,0.3,2.5,0.5,3.8,0.8c2.2-2,1.2-6.4-1.7-7.2c-0.9-0.3-1.9-0.3-2.9-0.5
		c-2.2-0.7-3.4-3-4.3-5.2c-1.5-3.5-3-7.3-2.5-11.2c0.7-4.6,4.4-8.6,4.7-13.3c-1.3-0.6-2.8-1.3-4.1-1.8c2.9-4.9,0.5-12-4.7-14.3
		c1.3-3.8,0.2-8.3-2.8-10.9c-1.3-1.1-2.8-1.9-3.8-3.3c-2.5-3.7,0.5-8.6,2.8-12.4c0.9-1.6,1.8-3.6,1.1-5.3c-0.4-1.1-1.4-1.9-2.1-2.9
		c-1.8-2.5-1.4-6.2,0.7-8.4c0.6-0.7,1.4-1.2,1.8-2c1.1-2.3-1.6-5-0.9-7.4c0.3-1,1.1-1.9,0.9-3c-0.2-0.8-1-1.4-1.6-2.1
		c-4.1-4.4,1.8-11.9-0.5-17.5c-1.8-4.2-7.6-5.4-9.9-9.3c-1.7-2.6-1.6-5.6-2.3-8.6c-0.2-0.8-1.8-7.2-4.1-6.2l12.7-0.3
		c4.5-0.2,9.4-5.2,13.9-4.7c3.6,0.4,5.5,4.2,8,6.5c4.2,4,6.6,0.3,10.5-2.5c2.6-1.8,5.1-2.9,8-3.4v-0.2c-1.7,4.4-3.4,8.9-5,13.3
		c-0.4,1.2-0.9,2.4-0.8,3.8c0.1,0.9,0.4,1.8,0.8,2.5c3,6.7,6,13.4,9.1,20.1c1,2.3,2.3,4.9,4.9,5.5c1.3,0.3,2.6,0,3.9,0.3
		c3.6,0.7,5.3,4.9,6.2,8.4c0.3,1.2,0.6,2.3,0.9,3.5c0.2,0.5,0.3,1.1,0.1,1.7c-0.3,0.7-1,1.1-1.6,1.5c-6.5,4-6.8,14.7-13.8,17.5
		c-0.2,2.9,3.8,4.1,6.7,4.3c-3.8,3.7-3.4,10.7,0.8,13.9c1.2,0.9,2.5,1.5,3.7,2.4c3.4,2.9,3.6,7.9,3.5,12.3c0,1.8-0.1,3.6-0.8,5.3
		c-1.3,3.1-4.6,5.2-4.9,8.6c-0.1,1.3,0.3,2.9-0.2,4.1c-0.6,1.3-1.9,1.8-3,2.8c-2.9,2.5-2.9,6.8-4.1,10.4c-1.3,4-4,7.4-6.7,10.7
		C172.8,890,171,891.9,168.8,894.7z"
      />
    </a>
    <a (click)="SelectCode('W5')">
      <path
        [class.selected]="IsSelected('W5')"
        id="W5"
        d="
		M175.5,734.5c-1.7,4.4-3.4,8.9-5,13.3c-0.4,1.2-0.9,2.4-0.8,3.8c0.1,0.9,0.4,1.8,0.8,2.5c3,6.7,6,13.4,9.1,20.1
		c1,2.3,2.3,4.9,4.9,5.5c1.3,0.3,2.6,0,3.9,0.3c3.6,0.7,5.3,4.9,6.2,8.4c0.3,1.2,0.6,2.3,0.9,3.5c0.2,0.5,0.3,1.1,0.1,1.7
		c-0.3,0.7-1,1.1-1.6,1.5c-6.5,4-6.8,14.7-13.8,17.5c-0.2,2.9,3.8,4.1,6.7,4.3c-3.8,3.7-3.4,10.7,0.8,13.9c1.2,0.9,2.5,1.5,3.7,2.4
		c3.4,2.9,3.6,7.9,3.5,12.3c0,1.8-0.1,3.6-0.8,5.3c-1.3,3.1-4.6,5.2-4.9,8.6c-0.1,1.3,0.3,2.9-0.2,4.1c-0.6,1.3-1.9,1.8-3,2.8
		c-2.9,2.5-2.9,6.8-4.1,10.4c-1.3,4-4,7.4-6.7,10.7c-2.1,2.5-4.2,5-6.3,7.5l-0.1-0.1c0,0-0.5,7.3-0.3,10.6c0.2,3.2,8,2.2,8,2.2
		l5.5-0.3c1.3,3.3,2.9,13.3,7.6,8.3c1.2-1.2,1.8-2.8,3-3.9c1.4-1.4,3.4-2.3,5.3-3c4.4-1.8,8.8-5.2,13.6-4.5c4.4,0.6,5.5-2.6,9.2-3.3
		c1.7-0.3,3.4,0.6,5,1c2.3,0.6,4.7-0.2,4.4-2.9c-0.6-4.9-20.2-12.8-4.7-17.5c1.3-0.4,2.8-0.4,4,0.2c0.8,0.4,1.5,1.1,2.3,1.6
		c2.6,1.7,6,1.4,8.9,2.5c1.8,0.7,2.9,1.8,3.8,3l-0.1,0.1c2.7-8.3,12.3-13.8,20.7-11.7c0.3-2.6,0.3-5.4-0.8-7.8
		c-1.2-2.3-3.7-4.3-6.3-3.9c0.5-2.9-0.4-6-2.3-8.1c-1.4-1.6-3.5-3.4-2.6-5.3c0.3-0.7,1-1.2,1.7-1.5c3-1.6,6.5-2.1,9.6-3.5
		s5.9-4.4,5.3-7.8c-1.2-0.6-2.3-1.1-3.5-1.7c0.5-3.6,0.9-7.3,1.4-10.9c-1.6-0.7-2.3-2.6-2.1-4.3c0.2-1.7,1.1-3.2,2-4.7
		c1.2-2,2.4-4,3.6-6c0.5-0.8,0.9-1.6,1.1-2.4c0.4-2.4-1.8-4.6-4.3-5.2c-2.3-0.6-4.9-0.2-7.3-0.2c-1.3,0-2.6-0.2-3.6-0.8
		c-2.9-2-1.3-6.5,0.8-9.4c2.9-4,6.2-7.6,10-10.8c1.1-0.9,2.2-1.8,2.8-3c2.3-4.6,0.6-12.6,0.2-17.4c-0.3-3,2.5-4,2.4-6.7
		c0-0.8-0.6-1.5-1-2.2c-1.8-2.7-2.5-6.1-2-9.3l0.1-0.8c-4.3-1.4-8.6-2.4-13.1-3c-2.8-0.4-5.7-0.7-8-2.3c-2.3-1.7-3.4-5.2-1.5-7.3
		c-1.8-1.2-4.4-1.2-6.3,0c-0.8-2.3,1.3-5.1,3.7-5.1c2.3-2.9,1.8-7.7-1.1-10.1l-3.2,2l-4.4,3c-1.7,1.2-6.5-0.4-8.8,0.4
		c-2.9,1.1-4.8,3.9-7.2,5.9c-2,1.6-3.9,3.2-6,4.8c-2.7,1.7-5.3,3.4-8,5.1c-3.4,2.3-7.6,6.8-11.9,4.1c-1.8-1.1-3.1-2.8-4.8-3.9
		c-2.4-1.7-5.5-2.3-8.4-2.4c-1.9,0-3.7,0.1-5.4,0.4L175.5,734.5z"
      />
    </a>
    <a (click)="SelectCode('W10')">
      <path
        [class.selected]="IsSelected('W10')"
        id="W10"
        d="
		M451.2,825.1c0.4-0.3,0.9-0.3,1.3-0.1c1.3,1.9,4.5,0.1,5-2.2c0.4-2.3-0.4-4.6-0.2-6.9c0.5-3.9,5.2-6.6,8.9-5.2
		c0.8-1.8-0.2-4.1-1.9-4.8c0.4-3.7,4.2-6,7.7-6.9c3.6-0.8,7.5-0.9,10.7-2.7c3.9-2.2,6.1-6.5,8.6-10.4c2.4-3.9,5.9-7.7,10.4-7.8
		c-0.4-5.1-5.6-8.4-8.2-12.8c-2.5-4.4-2.5-9.8-1.8-14.9c0.7-5,1.9-10.1,1.7-15.1c-0.3-5-2.6-10.4-7.1-12.7c-0.4-0.2-0.9-0.4-1-0.9
		H485c-0.7,0.1-1.4,0.1-2.1,0.1c-3.9,0.3-7.7,1.6-11.4,2.9c-1.8,0.7-3.5,1.3-5.3,1.9c-2.4,0.9-5,1.8-7.1,3.3l0.3,0.7
		c0.5,1.8,2.3,3.5,2.7,5.5c0.5,1.8-0.3,3.8-0.6,5.7c-0.3,1.8-0.1,4.2,1.6,5.1c-2.9-0.6-6.1-0.3-9,0.7c-3.5,1.3-6.8,3.7-10.6,3.4
		c-2.5-0.2-4.9-1.6-7.4-1.8c-4.9-0.3-10.3,3.8-14.4,0.9c-3.9,2.7-8.1,6.2-7.6,10.9c0.4,3.9,3.9,6.5,6.2,9.7c0.5,0.7,0.9,1.4,0.8,2.2
		c-0.3,2.9-6.3,2.7-6.1,5.6h0.2c0.3,1.8,6.3,3.4,7.8,4.1c2.8,1.4,5.5,3.2,7.7,5.5c3.3,3.3,4.8,7.2,5.2,11.7c0.3,2.3-0.1,5.3,1.9,7
		c1.8,1.5,3.9,1.2,5.5,2.8c2,2.1,2.9,7.6,4,10.3c0.8,1.8,2.1,2.9,3.1,4.2L451.2,825.1z"
      />
    </a>
    <a (click)="SelectCode('W9')">
      <path
        [class.selected]="IsSelected('W9')"
        id="W9"
        d="
		M542.9,717.3c7.6,12.3,16.7,23.7,26.9,34c-2.4,1-3.1,4.3-2.1,6.7c0.9,2.2,3.4,3.4,4.3,5.3c-1.8,0.1-3.1,1.4-4.4,2.5
		c-1.5,1.3-2.8,2.9-3.9,4.6c-2.2,3.3-4.6,7-8.5,7.8c-5,1-9.2-3.3-13.8-5.6c-5.9-2.9-13.3-2.5-18.7,1.1c-2.4,1.6-4.4,3.8-6.9,5.2
		s-5.8,2.1-8.2,0.4l-0.9-1.4c-0.2-0.3-0.3-0.4-0.5-0.6c-1.4-1.1-3.7-0.5-4.8,0.9l0.3-0.1c-0.4-5.1-5.6-8.4-8.2-12.8
		c-2.5-4.4-2.5-9.8-1.8-14.9c0.7-5,1.9-10.1,1.7-15.1c-0.3-5-2.6-10.4-7.1-12.7c-0.4-0.2-0.9-0.4-1-0.9l1.9-0.5
		c0.8-0.4,1.6-1.1,2.5-1.2c1.4-0.2,2.6,1.2,3.6,2.2c4.8,4.7,13.3,5.1,16.5,10.9c1.6,2.8,1.6,6.2,2.4,9.3c0.8,3.1,3.3,6.3,6.5,6.1
		c0.8-6.6,5.5-12.7,11.7-15c1.5-0.6,3.2-1,4.1-2.3c0.5-0.6,0.8-1.3,1.1-2.1c1.1-2.3,2.9-4.1,5.3-5.1c-1.4-2.1-3.8-3.5-5.4-5.5
		c-1.7-1.9-2.4-5.2-0.6-7c2-1.9,5.6-0.4,7,2c-1.1,0.7-2.3,1.4-3.4,2.1c1.3,0.3,2.3,0.9,3.3,1.8L542.9,717.3z"
      />
    </a>
    <a (click)="SelectCode('W7')">
      <path
        [class.selected]="IsSelected('W7')"
        id="W7"
        d="
		M123.2,739.3c1-0.9,3.1,5.2,3.3,6c0.7,2.9,0.6,5.9,2.3,8.6c2.4,3.9,8.1,5,9.9,9.3c2.3,5.5-3.6,13.1,0.5,17.5
		c0.6,0.7,1.4,1.2,1.6,2.1c0.2,1-0.7,2-0.9,3c-0.7,2.4,2,5.1,0.9,7.4c-0.4,0.8-1.2,1.3-1.8,2c-2.1,2.2-2.4,6-0.7,8.4
		c0.7,1,1.7,1.8,2.1,2.9c0.7,1.8-0.2,3.7-1.1,5.3c-2.3,3.9-5.3,8.7-2.8,12.4c0.9,1.3,2.5,2.2,3.8,3.3c3,2.6,4.1,7.1,2.8,10.9
		c5.2,2.3,7.6,9.4,4.7,14.3c1.3,0.6,2.8,1.3,4.1,1.8c-0.3,4.7-3.9,8.6-4.7,13.3c-0.6,3.9,1,7.6,2.5,11.2c0.9,2.1,2,4.5,4.3,5.2
		c0.9,0.3,1.9,0.3,2.9,0.5c2.9,0.8,3.9,5.2,1.7,7.2c-1.3-0.3-2.5-0.5-3.8-0.8c0.2,1,0.3,1.9,0.4,2.9h-0.5c-0.7-0.1-2.9,2.3-3,3
		c-0.7,3.7-2.5,7-4.4,10.3c-1.8,3.1-3.9,6.5-7.3,7.5c-1.8,0.4-3.6,0.2-5.4-0.1c-0.8-0.1-1.4-0.3-2.1-0.6c-1.8-1.1-1.8-3.7-2.1-5.9
		c-1.3-9.1-8.6-10.2-16.1-10.7c-6.9-0.6-6.1-4.4-7.7-11c-0.5-2.1-1.1-4.4-2.7-5.9c-0.9-0.9-2.1-1.5-2.7-2.6
		c-1.3-2.1,0.2-4.9-0.3-7.3c-0.5-2.3-2.5-3.9-4.4-5.2c-2.6-1.8-5.2-3.7-7.8-5.5c-2.3-6.6,6.3-5.7,8.4-9.1c0.5,0,2.8-22.1,2.9-23.2
		c0.1-0.5,0.1-1.1-0.1-1.6c-0.3-0.6-0.8-1-1.4-1.3c-3.8-2.2-8.3-3.2-12.7-2.8c-0.8,0.1-1.6,0.2-2.3-0.3c-0.6-0.4-0.8-1.1-1.1-1.8
		c-0.8-2.5-1.7-5-2.6-7.5c-0.4-1.1-0.8-2.2-0.8-3.4c-0.3-5.8,5.8-7,4.2-12.4c-1.3-4.5-5.3-8.1-4.6-13.3c0.4-3,1.8-6,3.8-8.3
		c0.7-0.8,1.3-1.4,1.8-2.3c0.6-1.2,0.6-2.6,0.6-3.9c-0.1-6.3-0.6-8.6,4.2-12.7c2.5-2.1,5-4.2,7.4-6.3c1.8-1.7,3.6-3.4,5.4-5.1
		c1.3-1.3,2.9-2.5,4.1-3.9c0.8-0.9,1.1-2,1.9-2.8c3.9-3.1,10.5,1.3,14.7,1.2L123.2,739.3z"
      />
    </a>
    <a (click)="SelectCode('W11')">
      <path
        [class.selected]="IsSelected('W11')"
        id="W11"
        d="
		M501.4,778.3c1.1-1.4,3.4-2.1,4.8-0.9c1.5,1.3,1.4,5.3,2,7.2c1,3.1,3.5,6,2.3,9.5c-1.2,3.3-5.7,6-4.1,9.1c1.5,3,6.3,1.2,9.4,2.6
		c3,1.3,3.7,5.5,2.7,8.6s-3.2,5.7-4.4,8.8s-1.2,7,1.4,9c0.3,0.2,4-0.6,4.8-0.4c1,0.2,2.9,0.5,3,1.8c0.2,1.6-3.3,2.6-4.4,3.2
		c-4,1.9-8.4,3.2-12.8,3.9c-3.4,0.5-7.4,1.2-8.6,4.3c-0.7,1.8-0.2,3.9,0.5,5.7s1.4,3.8,1,5.6s-2.3,3.6-4.2,2.9
		c-0.7-0.3-1.5-0.1-1.8,0.5l-0.8-0.8c-1.1-0.7-2.4-1.2-3.6-1.6c-7.1-2.3-14.9-4.7-22.1-2.4c0.4-0.2-0.3,4-0.5,4.4
		c-0.6,1.4-1.6,2.7-2.5,3.9h-0.1c-1.4-8.9-11.3-14.6-12.7-23.5c-0.6-4,2.2-9,1.3-12.7c-0.2-0.7-0.4-1.2-0.8-1.8l0.1,0.1
		c0.4-0.3,0.9-0.3,1.3-0.1c1.3,1.9,4.5,0.1,5-2.2c0.4-2.3-0.4-4.6-0.2-6.9c0.5-3.9,5.2-6.6,8.9-5.2c0.8-1.8-0.2-4.1-1.9-4.8
		c0.4-3.7,4.2-6,7.7-6.9c3.6-0.8,7.5-0.9,10.7-2.7c3.9-2.2,6.1-6.5,8.6-10.4c2.4-3.9,5.9-7.7,10.4-7.8L501.4,778.3z"
      />
    </a>
    <a (click)="SelectCode('W12')">
      <path
        [class.selected]="IsSelected('W12')"
        id="W12"
        d="
		M354.4,868.2c2.8,0.2,5.2-3.7,6.1-6.4c0.9-2.9,2.3-6.3,5.4-6.4c2.8-0.1,5.1,3.2,7.8,2.3c2.1-0.8,2.5-3.5,2.3-5.7
		c-0.3-2.2-0.6-4.8,1-6.4c1.4-1.4,4.1-1.4,5.1-3.2c0.8-1.3,0.3-2.9-0.7-4.1c-0.8-1.2-2-2.1-2.9-3.3c-2.3-3.2-1.8-7.6-2-11.5
		c-0.3-3.9-2.4-8.6-6.4-8.6c0.8-3.2-0.3-5.5-2.1-8.3c-0.8-1.3-1.9-2.3-2.1-3.9s1-3.2,2.4-2.8c0-0.5,0.1-1,0.1-1.6
		c-1.2,0.1-2.3-1-2.5-2.2c-0.3-1.2,0.1-2.4,0.4-3.6c2.2-7.3,4.4-14.7,6.5-22v-0.3c14.6-1.5,29.6,1.5,42.5,8.6h0.2
		c0.3,1.8,6.3,3.4,7.8,4.1c2.8,1.4,5.5,3.2,7.7,5.5c3.3,3.3,4.8,7.2,5.2,11.7c0.3,2.3-0.1,5.3,1.9,7c1.8,1.5,3.9,1.2,5.5,2.8
		c2,2.1,2.9,7.6,4,10.3c1.1,2.9,3.6,3.9,4.4,6.5c0.9,3.7-1.8,8.6-1.3,12.7c1.3,8.9,11.2,14.6,12.7,23.5c-3.8,2.4-8.6,0.6-13.1,0.5
		c-3-0.1-8.1,0.4-10.7,2.3c-2.7,2-3,6.2-7.5,5.8c-1.8-0.2-3.4-1.4-5.3-1.9c-3-0.9-5.2,2.4-7.7,3.6c-4,1.8-8.1,4.1-12.4,3.9
		c-1.4,2.1-2.9,4.2-4.3,6.3c-0.4-1.3-2.2-1.6-3.4-1c-1.2,0.6-2.1,1.7-3.1,2.5c-2.5,2.2-6.1,2.9-9.2,1.8c-3.1-1-5.6-3.9-6.3-7
		c-1.8,2.2-3.5,4.4-6,6c-2.3,1.5-5.5,2.2-8.1,1.1c-2.6-1.2-4.1-4.5-2.8-7c-3.6-3.3-6.7-7.1-9-11.4L354.4,868.2z"
      />
    </a>
    <a (click)="SelectCode('W3')">
      <path
        [class.selected]="IsSelected('W3')"
        id="W3"
        d="
		M244.1,888.6c2.7-8.3,12.3-13.8,20.7-11.7c0.3-2.6,0.3-5.4-0.8-7.8c-1.2-2.3-3.7-4.3-6.3-3.9c0.5-2.9-0.4-6-2.3-8.1
		c-1.4-1.6-3.5-3.4-2.6-5.3c0.3-0.7,1-1.2,1.7-1.5c3-1.6,6.5-2.1,9.6-3.5s5.9-4.4,5.3-7.8c-1.2-0.6-2.3-1.1-3.5-1.7
		c0.5-3.6,0.9-7.3,1.4-10.9c-1.6-0.7-2.3-2.6-2.1-4.3c0.2-1.7,1.1-3.2,2-4.7c1.2-2,2.4-4,3.6-6c0.5-0.8,0.9-1.6,1.1-2.4
		c0.4-2.4-1.8-4.6-4.3-5.2c-2.3-0.6-4.9-0.2-7.3-0.2c-1.3,0-2.6-0.2-3.6-0.8c-2.9-2-1.3-6.5,0.8-9.4c2.9-4,6.2-7.6,10-10.8
		c1.1-0.9,2.2-1.8,2.8-3c2.3-4.6,0.6-12.6,0.2-17.4c-0.3-3,2.5-4,2.4-6.7c0-0.8-0.6-1.5-1-2.2c-1.8-2.7-2.5-6.1-2-9.3v-1
		c0.6,0.2,1.2,0.4,1.7,0.6c4.1,1.4,8.1,3.3,11.8,5.6c4.5,2.9,8.8,6.6,14.1,7.2c0.9,0.1,1.8,0.1,2.7-0.3c0.8-0.3,1.4-1.1,2.2-1.4
		c1.3-0.5,2.7,0,3.9,0.5c5.5,2.1,11.2,4.3,16.7,6.4c2.7,1,5.4,2.1,7.6,3.9c2,1.8,4.4,4.4,6.8,3.4c0.2-1.2,0.3-2.3,0.4-3.5
		c3.4,1.9,6.7,3.9,10,5.8c1.8,1,3.7,2.1,5.7,2.4c2.6,0.3,5.1-0.5,7.6-1.2c3.9-1.1,7.8-1.8,11.8-2.3v0.3c-2.2,7.3-4.4,14.7-6.5,22
		c-0.3,1.2-0.7,2.3-0.4,3.6c0.3,1.3,1.3,2.3,2.5,2.2c0,0.5-0.1,1-0.1,1.6c-1.4-0.4-2.7,1.3-2.4,2.8c0.3,1.4,1.3,2.6,2.1,3.9
		c1.8,2.8,2.9,5,2.1,8.3c3.9,0.1,6.1,4.7,6.4,8.6c0.3,3.9-0.3,8.3,2,11.5c0.8,1.2,2,2.1,2.9,3.3c0.8,1.2,1.3,2.9,0.7,4.1
		c-1,1.8-3.6,1.8-5.1,3.2c-1.6,1.6-1.3,4.1-1,6.4c0.3,2.2-0.2,5-2.3,5.7c-2.6,0.9-5-2.3-7.8-2.3c-3,0.1-4.4,3.5-5.4,6.4
		c-0.9,2.9-3.6,7-6.5,6.4c-3.4-8.9-15.2-13.3-23.6-8.9c0.7-2.4-2.7-4.4-5-3.4c-2.3,0.9-3.6,3.4-4.8,5.5c-1.2,2.3-2.5,4.6-5,5.4
		c-2.5,10.9-10.8,20.2-21.2,24.1c-2.5,0.9-5.1,1.6-7.5,2.9c-5,2.8-7.7,8.2-10.2,13.3c-3-3.4-8.8-3.6-12.1-0.5l-0.3-0.6l-1.3-6.8
		l-5.7-5c-2.5,0.1-6.5,0.5-8.8-0.6C246.5,892.6,245.5,890.5,244.1,888.6L244.1,888.6z"
      />
    </a>
    <a (click)="SelectCode('W4')">
      <path
        [class.selected]="IsSelected('W4')"
        id="W4"
        d="
		M366.8,887.2c-1.3,3.7,1.3,7.7,4.1,10.4c2.9,2.7,6.4,5.1,7.7,8.8c2.2,5.8-1.8,12.8,0.8,18.4c1.7,3.6,5.8,5,7,9.1l0.8-0.3
		c-9.7,5.9-15.2,16.6-19.1,27.2s-6.5,21.8-12.5,31.4c-6,9.6-16.3,17.5-27.5,16.7c-9.7-0.7-17.6-7.4-24.8-13.8l-0.9-1
		c-1-1.7-2.2-3.3-3-4.8c-1.8-3.2-3.5-6.4-4.8-9.8c-1.3-3.6-1.8-7.5-3-11.1c-2.6-8.1-8.3-12.8-14.1-18.7c-2.9-2.4-5.8-4.9-8.7-7.2
		c-2-1.6-11-4.7-11.8-6.2c-0.8-1.4,0.3-3.2,1.7-4.2c1.3-1,2.9-1.9,3.3-3.4c0.4-1.7-0.8-3.7,0.3-5.1c1.1-1.6,3.9-0.8,4.8-2.2
		c1.7-2.3-0.6-2.5-1.1-4.7c-0.8-3.4-0.8-7.2-1.3-10.7l0.3,0.6c3.3-3,9.1-2.9,12.1,0.5c2.5-5.1,5.3-10.5,10.2-13.3
		c2.3-1.3,5-1.9,7.5-2.9c10.5-3.9,18.7-13.3,21.2-24.1c2.3-0.8,3.8-3.2,5-5.4c1.2-2.3,2.4-4.7,4.8-5.5s5.7,1,5,3.4
		c8.4-4.4,20.2,0.1,23.6,8.9l0.2-0.4c2.3,4.6,5.5,8.7,9.3,12.2c-1.3,2.4,0.3,5.7,2.8,7L366.8,887.2z"
      />
    </a>
    <a (click)="SelectCode('W6')">
      <path
        [class.selected]="IsSelected('W6')"
        id="W6"
        d="
		M444.7,863.8c-2,0.3-3.9,0.9-5.2,1.9c-2.7,2-3,6.2-7.5,5.8c-1.8-0.2-3.4-1.4-5.3-1.9c-3-0.9-5.2,2.4-7.7,3.6
		c-4,1.8-8.1,4.1-12.4,3.9c-1.4,2.1-2.9,4.2-4.3,6.3c-0.4-1.3-2.2-1.6-3.4-1c-1.2,0.6-2.1,1.7-3.1,2.5c-2.5,2.2-6.1,2.9-9.2,1.8
		c-3.1-1-5.6-3.9-6.3-7c-1.8,2.2-3.5,4.4-6,6c-2.3,1.5-5.5,2.2-8.1,1.1l0.5,0.3c-1.3,3.7,1.3,7.7,4.1,10.4c2.9,2.7,6.4,5.1,7.7,8.8
		c2.2,5.8-1.8,12.8,0.8,18.4c1.7,3.6,5.8,5,7,9.1c5.2-3.9,14.9-4.7,21.2-4.6c7.4,0.2,14.4,4.4,18.5,10.5c1.3,2,7.9,21.1,4.7,21.7
		c3.7-0.6,9-0.3,12.4-1.8c3.1-1.3,5.6-4.4,8.8-5.8c3.4-1.5,8-1.3,9.8,1.8c3.9,6.8,17.2,2.6,20.6-4.5c-1.7-0.4-3.3-0.8-5-1.3
		c-5.5-12.9-12.2-25.4-19.9-37.2c2-1.2,4.1-2.4,5.1-4.4c1.1-2,0.6-5-1.5-5.9c0.7-1.7,1.3-3.4,2-5c-7.3,0-14.5-3.1-19.4-8.5
		c2.6-3.4,2.3-8.6-0.4-11.7c3.3-2.7,4.2-7.8,2.1-11.5L444.7,863.8z"
      />
    </a>
    <a (click)="SelectCode('W14')">
      <path
        [class.selected]="IsSelected('W14')"
        id="W14"
        d="
		M482.1,950.2c3.3-1.5,7-0.9,10.7-1.5c3.5-0.6,7.5-3.4,6.8-6.9c2.4,1,6,1.7,7.1-0.7c1.6-3.2-3.7-6.9-1.8-9.9
		c-3.1-2.9-4.8-7.2-4.4-11.4c0.3-4.2,2.7-8.2,6.2-10.6c-3.4-1.3-6.6-2.7-10-4c0.4-1.8,2.1-3,3.9-3.4s3.6-0.3,5.5,0
		c-3.5-3.1-7.1-6.2-10.7-9.3c0-2.3,2.6-4.4,5-3.9c2.7-2,4.7-4.4,6-7.6c1.3-3.1,0.3-7.5-2.9-8.6c-1.7-0.6-3.4-0.3-5.2-0.1
		s-3.8-0.3-4.7-1.8c-1.6-2.6,1.5-6,0.8-9c-0.5-2.5-3.4-3.7-5.8-4.5c-7.1-2.3-14.9-4.7-22.1-2.4c0.4-0.2-0.3,4-0.5,4.4
		c-0.6,1.4-1.6,2.7-2.5,3.9h-0.1c-3.8,2.4-8.6,0.6-13.1,0.5c-1.5,0-3.5,0.1-5.5,0.4l0.9,1.8c2.1,3.7,1.1,8.7-2.1,11.5
		c2.8,3.2,3,8.4,0.4,11.7c5,5.4,12.2,8.5,19.4,8.5c-0.7,1.7-1.3,3.4-2,5c2.1,0.8,2.6,3.9,1.5,5.9s-3.2,3.3-5.1,4.4
		c7.7,11.7,14.4,24.3,19.9,37.2c1.7,0.4,3.3,0.8,5,1.3L482.1,950.2z"
      />
    </a>
    <a (click)="SelectCode('W8')">
      <path
        [class.selected]="IsSelected('W8')"
        id="W8"
        d="
		M523.7,833.5c13.1,2.9,27.2,6.3,36.3,15.8l-0.1,0.1c-0.2,0.6-0.4,0.6-0.6,1.2c-8.7,4.4-12.3,16.8-7,25.1c0.7,1.1,1.5,2.3,1.7,3.5
		c0.1,1.3-1,2.8-2.3,2.5c0.4,3.2-2.3,6.2-5.4,7.2c-3.1,1-6.5,0.6-9.7,0.1c1.5,1.8,3,3.8,3.5,6.1s-0.3,5.1-2.5,6.1
		c-3.7,1.7-7.5-2.9-11.5-2.9c-3.4,0-5.9,2.9-9,4.3c-4.1,1.8-7.6-0.5-11.6-0.8l0.3-0.2c-3.5-3.1-7.1-6.2-10.7-9.3
		c0-2.3,2.6-4.4,5-3.9c2.7-2,4.7-4.4,6-7.6c1.3-3.1,0.3-7.5-2.9-8.6c-1.7-0.6-3.4-0.3-5.2-0.1s-3.8-0.3-4.7-1.8
		c-1.6-2.6,1.3-5.9,0.8-9c-0.1-1-0.5-1.8-1.2-2.3l-0.2,0.3c0.3-0.6,1.2-0.8,1.8-0.5c1.8,0.8,3.8-1,4.2-2.9c0.4-1.8-0.3-3.9-1-5.6
		c-0.7-1.8-1.2-3.9-0.5-5.7c1.3-3.2,5.3-3.8,8.6-4.3c4.4-0.7,8.7-2,12.8-3.9c1.2-0.6,4.6-1.6,4.4-3.2"
      />
    </a>
    <a (click)="SelectCode('W2')">
      <path
        [class.selected]="IsSelected('W2')"
        id="W2"
        d="
		M572.1,763.3c-1.8,0.1-3.1,1.4-4.4,2.5c-1.5,1.3-2.8,2.9-3.9,4.6c-2.2,3.3-4.6,7-8.5,7.8c-5,1-9.2-3.3-13.8-5.6
		c-5.9-2.9-13.3-2.5-18.7,1.1c-2.4,1.6-4.4,3.8-6.9,5.2s-5.8,2.1-8.2,0.4l-0.3,0.5c0.3,1.6,0.4,3.5,0.8,4.6c1,3.1,3.5,6,2.3,9.5
		c-1.2,3.3-5.7,6-4.1,9.1c1.5,3,6.3,1.2,9.4,2.6c3,1.3,3.7,5.5,2.7,8.6s-3.2,5.7-4.4,8.8s-1.2,7,1.4,9c0.3,0.2,4-0.6,4.8-0.4
		c1,0.2,2.9,0.5,3,1.8l0.3,0.3c14.1,3,29.3,6.8,38.3,18c2.6,3.3,4.5,7,7.6,9.7s8,4.1,11.4,1.7c2.3-1.7,3.4-4.7,5.5-6.7
		c4-3.7,10.2-2.3,15.5-1.1c5.3,1.3,11.8,1.9,15.1-2.3c2.3-2.9,2-7,1.1-10.6c-0.9-3.5-2.5-7-2.5-10.7c0-5.4,3.2-10.6,2.3-15.9
		c-0.7-3.9-3.5-7-6.3-9.8c-6.1-6.5-12.3-12.8-18.5-19.3c-2.3-4.6-5.4-8.9-9-12.7c-1.8-1.9-3.8-3.4-5.3-5.5c-1.4-2.1-3.6-5.5-6-5.7
		L572.1,763.3z"
      />
    </a>
    <a (click)="SelectCode('W1')">
      <path
        [class.selected]="IsSelected('W1')"
        id="W1"
        d="
		M700.1,831.8c-16.4,2.4-31.1,14.4-36.8,30c-0.8,2.3-1.8,5.1-4,6.2c-9,4.5-23.1-7.3-27.3-14.2c-1.3-2.2-3.4-3.6-5.9-4.3
		c-2.2-0.6-5.5,0.1-7.4-0.9c0.1-0.5,0.8,1,0.2,0.4l-0.1-0.4c0.3-2.1,0-4.4-0.6-6.5c-0.9-3.5-2.5-7-2.5-10.7c0-5.4,3.2-10.6,2.3-15.9
		c-0.7-3.9-3.5-7-6.3-9.8c-3.4-3.6-7-7.3-10.4-10.9l0.1-1.1c-0.4-4.4,2.3-8.6,6-11.2c3.6-2.5,8-3.7,12.3-4.9
		c17.5-4.7,35.1-9.3,52.6-14c2.8-0.8,5.8-1.5,8.6-0.5c2.8,0.9,4.6,3.4,6.3,5.8c8.6,12.6,14.9,26.8,18.3,41.6
		c0.6,2.5,1.1,5.2,0.3,7.6c-0.8,2.4-2.9,4.3-4.4,6.4s-2.3,5.1-0.8,7.1"
      />
    </a>
    <a (click)="SelectCode('N8')">
      <path
        [class.selected]="IsSelected('N8')"
        id="N8"
        d="M790,494
		c1.4-4.4,2.9-8.7,3.1-13.3c0.3-4.5-0.9-9.4-4.1-12.7c-1.9-2-4.5-3.4-6.3-5.5c-2.5-2.9-3.3-6.9-5.1-10.2c-1.8-3.4-5.9-6.3-9.3-4.6
		c0.9-1.6,0.1-3.7-1.3-4.8c-1.3-1.1-3.3-1.6-5-1.9c-2.5-0.6-6.1-0.5-6.7,2c-0.4,1.7,0.9,3.3,0.9,5c-0.1,2.5-3.3,4-5.7,3.4
		c-2.4-0.7-4.3-2.7-6-4.6c-3.3-3.7-6.7-7.4-11.1-9.7c-4.4-2.3-9.8-3.1-14.2-0.8c-2.9,1.5-5,4.2-7.5,6.4c-2.4,2.3-5.6,4.1-8.8,3.6
		c-5.7,6.5-7.8,15.3-9.2,24.1c-1.6,9.5-3.8,18.9-5.7,28.3l-0.3,0.7c4.3-2,9.1,1.5,12.5,4.8c-2.3,3.6-4.6,7.6-4.2,11.7
		c0.5,4.2,5.4,8.1,9,5.7c0.8-0.6,1.8-1.4,2.8-0.8c0.8,0.5,0.5,1.8,0.3,2.9c-0.7,3.5,2.4,7.3,6,7.3l1.8,0.8
		c4.8-0.5,13.8,1.8,13.8,1.8c2.8-5.2,8.2-9,14.2-9.6c0.8-0.8,0.6-2.3-0.3-2.9c3.9-0.6,7.5-3,9.4-6.5c6.8,0.8,13.8-1.2,19.1-5.5
		c-2.5-2.2-5.3-5.5-3.8-8.5c0.9-1.9,3.3-2.7,5.3-3.2c5.3-1.4,10.8-2.9,16.3-2.7"
      />
    </a>
    <a (click)="SelectCode('N6')">
      <path
        [class.selected]="IsSelected('N6')"
        id="N6"
        d="
		M634.6,468.9c5.7,4.7,9.1,12,9,19.3c0,2.3-0.3,4.8,0.6,6.9c1.8,4,7.2,5,11.5,4.2s8.6-2.7,13-2.1c1.9,5.8,10,8.5,15,5
		c1.3-0.9,2.4-2.2,3.9-2.9c4.3-2,9.1,1.5,12.5,4.8c-2.3,3.6-4.6,7.6-4.2,11.7c0.5,4.2,5.4,8.1,9,5.7c0.8-0.6,1.8-1.4,2.8-0.8
		c0.8,0.5,0.5,1.8,0.3,2.9c-0.7,3.5,2.4,7.3,6,7.3l1.8,0.8c-3.9,0.4-7.6,1.5-11,3.3c-0.8-2.4-4.4-2.5-6.5-1c-2,1.5-3.1,3.9-4.7,5.9
		c-2.4,3-6,4.9-8.9,7.4s-5.4,6.5-4.2,10.2c-2.3-0.3-4.5-0.4-6.8-0.7c-0.8-2.4-4.4-2.7-6.5-1.1c-2,1.6-2.8,4.2-3.4,6.7
		c-1.6,6-3.2,11.9-4.8,17.9c0.4,0.9,0.8,1.8,1.3,2.7l-0.3,0.9c-0.9,0.9-2.6,1.4-3.5,0.4c0.2,1.8-1.4,3.2-2.9,4.2
		c-1.3,0.8-2.6,1.8-4.1,1.9c-1.5,0.3-3.3-0.3-3.9-1.7c-0.2,1.9-0.4,3.9-1.6,5.5c-1.5,1.9-4.7,1.3-6.9,1.9c-2.8,0.7-5.5,2.3-8.1,3.4
		l-0.3,0.1c-0.3-0.7-0.4-1.3-0.6-2c-2.9-8.6-10.9-14.5-19.1-18.6c-2.4-1.3-5-2.4-6.8-4.4c-1.8-2.1-2.5-5.3-0.9-7.5
		c0.8-1.1,2-1.8,3.1-2.6c2.7-2,4.5-5.1,4.8-8.4c0.3-3.3-0.9-6.5-2.1-9.5c-0.8-1.9-1.5-3.9-2.9-5.6c-2.6-3.2-7.2-4.6-11.1-3.4
		l0.3-0.8c2.1-2.1,1.8-5.5,1-8.4s-2.2-5.7-1.9-8.6c3.5-0.3,7-1,10.4-2c1.4-0.4,2.9-0.9,3.7-2.2c0.7-1,0.7-2.3,0.9-3.6
		c1.2-5.9,7.4-9.1,12.9-11.5c1.8-0.8,3.7-1.5,5.6-1.3c0.6,0.1,1.2,0.3,1.8,0.2c1.4-0.3,2.1-2.1,1.7-3.5c-0.4-1.4-1.7-2.4-2.8-3.4
		c-2.9-2.3-5.7-4.6-8.6-7c-0.5-0.4-1.1-0.9-1.3-1.5c-0.3-1.1,0.3-2.2,1-3.1c2.3-2.9,4.7-7.6,8.6-9c2-0.8,3.9-0.2,5.8-1.1
		C633.2,470.3,633.9,469.6,634.6,468.9L634.6,468.9z"
      />
    </a>
    <a (click)="SelectCode('N19')">
      <path
        [class.selected]="IsSelected('N19')"
        id="N19"
        d="
		M729.8,533.3c-9.1-2.9-17.3-2.4-24.8,1.5c-0.8-2.4-4.4-2.5-6.5-1c-2,1.5-3.1,3.9-4.7,5.9c-2.4,3-6,4.9-8.9,7.4s-5.4,6.5-4.2,10.2
		c-2.3-0.3-4.5-0.4-6.8-0.7c-0.8-2.4-4.4-2.7-6.5-1.1c-2,1.6-2.8,4.2-3.4,6.7c-1.6,6-3.2,11.9-4.8,17.9c0.4,0.9,0.8,1.8,1.3,2.7
		l0.3,0.4c0.7-0.8,1.3-1.7,2.3-2.2c1.9-1.1,3.7,0.9,4,2.7c3.4-0.8,7,0.9,9.1,3.7c2.1,2.9,2.9,6.4,3.4,9.8c1.2,7.5,1.7,15.1,4.7,22
		c2.5,5.9,6.9,11,12.3,14.4l0.5-0.2c0.6-1.9,1.7-4.4,3-5.8c-1.8-1-3.2-2.9-3.4-5.1c-0.8,0-1.5,0-2.3,0c0,2.1-3.8,2.6-4.4,0.6
		c-0.6-2,2.9-3.6,3.9-1.8c2.5-1.8,1.1-5.9-1-8.1s-5-4.6-4.6-7.7c0.3-2.2,2.1-3.9,4.2-4.7c2.1-0.8,4.4-0.7,6.5-0.6
		c-0.1,2.3-0.3,4.6-0.3,6.9c1,1.1,3,1.1,4,0s0.9-3.1-0.3-4c2-1.5,5.3,1.4,4,3.6c6.1-0.2,12.3-2,17.4-5.3c0.4-1.8-1.2-3.9-3-3.9
		c0.3-6,6-10.2,11.1-13.3c1.9-1.2,3.9-2.3,5.9-3.6v-0.1c-0.5-0.4-1.1-0.8-1.6-1.2c0-2.7,0-5.4,0-8.1c-1.4-0.3-2.9-0.6-4.3-0.9
		c0.1-2.8-2-5.5-4.7-6.1c0.7-2.2,1.3-4.4,1.9-6.6c2.8,2.1,7.4-1.1,6.5-4.4c2.1-0.7,4.4-1.5,5.3-3.5c0.8-2-1.4-5-3.3-3.7
		c-3-3.4-6-6.6-9-10C729,535,729.4,534.1,729.8,533.3L729.8,533.3z"
      />
    </a>
    <a (click)="SelectCode('N7')">
      <path
        [class.selected]="IsSelected('N7')"
        id="N7"
        d="
		M706.2,650.5c-0.1-0.1-0.3-0.3-0.3-0.3c-0.6-0.5-1.4-0.8-2-1.3c-1.3-0.9-2.3-2.2-2.5-3.8c-0.1-0.8,0.2-1.7,0.3-2.5
		c0.3-3.4-2-7-4.5-9.1c0.6-1.9,1.7-4.4,3-5.8c-1.8-1-3.2-2.9-3.4-5.1c-0.8,0-1.5,0-2.3,0c0,2.1-3.8,2.6-4.4,0.6
		c-0.6-2,2.9-3.6,3.9-1.8c2.5-1.8,1.1-5.9-1-8.1s-5-4.6-4.6-7.7c0.3-2.2,2.1-3.9,4.2-4.7c2.1-0.8,4.4-0.7,6.5-0.6
		c-0.1,2.3-0.3,4.6-0.3,6.9c1,1.1,3,1.1,4,0s0.9-3.1-0.3-4c2-1.5,5.3,1.4,4,3.6c6.1-0.2,12.3-2,17.4-5.3c0.4-1.8-1.2-3.9-3-3.9
		c0.3-6,6-10.2,11.1-13.3c6.7-4.1,13.5-8.3,20.2-12.4c4.5,6.3,7.7,13.5,9.1,21.1c3.3-2.3,6.5-4.4,9.8-6.7c-0.6,2.2-3.1,6.8-2.2,8.9
		c0.4,0.9,1.2,1.7,1.5,2.7c0.7,2.1-0.8,4.2-2.4,5.8c-3.4,3.5-5.5,9.1-4,14c1.6,5.7,8.6,10.1,7,15.9c-2.3-1.2-5.3,0.4-6.3,2.8
		c-0.9,2.4-0.3,5.2,1.1,7.4c1.3,2.2,3.2,4,4.9,6c3,3.5,5.4,7.7,6.9,12.1l-0.6,0.6c-8.1,3.9-15.8,8.6-24.3,11.2
		c-7.1,2.3-14.8,3.3-21.5,6.7c-2.6,1.3-5.1,3.3-7.1,5.5l-1.3,0.2l-2.6,0.3l-2.6,0.1l-1.8-0.1l0.6-0.8c2-3.2,1.3-7.7-1.4-10.3
		c-0.3-3.7-0.7-7.3-0.9-11c-0.3-3.1-0.7-5.8-2.4-8.4c-0.8-1.3-1.8-2.3-3-3.4c-0.6-0.4-1.2-0.8-1.8-1.2
		C706.7,651.1,706.4,650.8,706.2,650.5z"
      />
    </a>
    <a (click)="SelectCode('N12')">
      <path
        [class.selected]="IsSelected('N12')"
        id="N12"
        d="
		M615.1,326.2l5.5,4.2l-0.9,5.1l-0.5,4.9l0.7,5.7l5.8,6l2.3,7.2l0.8,10l8.3,7.5l-0.5,3.5l-4.5,3.9l-8.1-4.6l-1,6.6l-4.7,7.6
		l-5.5,4.3l-2.4-3.8l-5.6-4.7l-8.4-3.4l-4.5,1.5l-5.3,9.7l-5.6,6.7l-3.4-3.7l-1.8-3.2l-5.1-2.8l-5.3-5l-7-5.3l2.5-3.6l-3-6.7
		l-2.8-7.7l-5.1-1.8l-4.3-8l-4.2-0.3l-6.8,0.3l-5.6-4.7l-6,0.9l-1.7,6.5l-11,4.5l-3.5-10.8l-5.7-4.6l-2.3-6l-4.9-3.9l-8-15.8
		l6.4-12.3l-3.4-16.4l18.3,2.6l10.1,3.9l10.5-4.4l13.3,3.7l5,4.6l8.9-8l9.7,1.6l8.6,4.5l10.3,2.3h9.1l11.1,10.6l10.5,10.2
		L615.1,326.2z"
      />
    </a>
    <a (click)="SelectCode('N20')">
      <path
        [class.selected]="IsSelected('N20')"
        id="N20"
        d="
		M420.3,247.1l-15.2,11l7.8,21.9l9.1,7.7l21.7,3.7l20.9-6.8l10.3,3.6l13.6,5.5l18.3,2.6l10.1,3.9l10.5-4.4l13.3,3.7l5,4.6l8.9-8
		l9.7,1.6l8.6,4.5l10.3,2.3h9.1l11.1,10.6l10.5,10.2l9.7,1l10.7-4.4l2.8-3.9l-5-8.8l7.6-3.5l5.5,0.2l-2.1-9.2l-6.2-3.9l3.4-14.3
		l-1.1-11.2l7.6-0.6l0.3-6.3l0,0l-5.6-1.8l-6.2,4.5l-8.5,4.5c0,0-6.7-5.5-6.8-5.5c-7.4-6-7.1-19.4-14.9-25c-2-1.4-2.3-0.8-4.4-1.3
		c-2.1-0.4-5.5-0.4-4.6-3.5c0.3-1.3,0.9-2.9,0-3.9c-1.4-1.5-5.9,0.5-7.5,0.3c-2.8-0.3-5.3-2.1-8.1-2.8c-0.3-0.1-3.4,2.9-4.9,2.8
		c-2.1-0.2-2.6-2.1-4.2-3.3c-3.2-2.4-5.1-2.1-9-1.4c-3.3,0.6-6.7,0.6-10.1,0.9c-3.4,5.6-5.8,13.8-13.2,14c-1.8,0.1-3.6,0.1-5.4-0.4
		c-4.6-1.3-6.9-11-9-15.1l-11.9-4.8l-9.4-0.9l-12.6,8.3l-11.2-0.5l-10.6,4.8l-5-0.2l-12.6,7.8l-9.5,1.8l-3.6,3.5L420.3,247.1"
      />
    </a>
    <a (click)="SelectCode('N10')">
      <path
        [class.selected]="IsSelected('N10')"
        id="N10"
        d="
		M702.5,446.5c-4.7-3.9-0.8-11.8-3-17.6c-1.5-4.2-6-6.5-9.8-8.8c-6-3.5-11.8-8.6-12.9-15.5c-0.9-6,1.8-11.8,3.7-17.7
		c1.8-5.8,2.2-13-2.3-17c-3.9-3.4-9.7-3-14.4-1.1s-8.6,5.3-13.2,7.7c-4.3,2.3-9.5,3.6-13.8,1.8l0,0l-0.3,1.8L632,384l-8.1-4.6
		l-1,6.6l-4.7,7.6l-5.5,4.3l0.4,0.4c-0.8,3.5-1.7,7.1-2.5,10.7c-0.3,1.5-0.8,3.1-0.6,4.7c0.4,4.5,4.9,7.7,9.2,9.1
		c2.7,0.8,5.5,1.2,8.1,2.3c2.6,1.1,5,3.2,5.5,6c2.1,6.4,6.6,11.8,12.6,15c-0.3,1.3-0.8,2.6-1.1,3.9c-1.3,0-2.5,0-3.8,0
		c0.4,1.9-0.9,4.1-2.9,4.5c-1.2,0,2.6,4,2.6,3.9c1.1,1.8,3.2,3.7,0.9,6c-0.9,0.9-2.2,1.2-3.3,1.9c-1,0.7-1.9,1.7-2.9,2.6l-0.1-0.1
		c5.7,4.7,9.1,12,9,19.3c0,2.3-0.3,4.8,0.6,6.9c1.8,4,7.2,5,11.5,4.2s8.6-2.7,13-2.1c1.9,5.8,10,8.5,15,5c1.3-0.9,2.4-2.2,3.9-2.9
		l0.3-0.7c1.9-9.4,3.8-18.9,5.7-28.3c1.7-8.2,3.4-16.8,8.6-23.3L702.5,446.5z"
      />
    </a>
    <a (click)="SelectCode('N11')">
      <path
        [class.selected]="IsSelected('N11')"
        id="N11"
        d="
		M738.4,364.2c0.4-2.3-2.8-3.3-5-3c-2.3,0.3-5.1,0.6-6.1-1.4c-0.9-1.9,0.8-3.9,1.6-5.9c1.5-3.2,0.7-7.6-1.7-10.2
		c-2.6-2.9-5.7-2.7-9.5-3.3c-2.4-0.4-6.8-1.3-7.3-4.2c-0.5-2.4,2.9-4.4,2.4-7c-0.8-3.8-3.2-2.9-6.2-3.8c-3.9-1.1-12.9-5.1-15.1-8.6
		c-3.1-4.8,0-11.9-4.5-16c-4.6-4.3-13.1,0.1-18-3.9c-3.5-2.9-3.2-8.1-2.6-12.6c0.6-4.4,0.8-9.8-2.8-12.5c-2.4-1.8-5.9-1.7-8.7-2.7
		c-2.9-1.1-5.3-5.2-3.1-7.3l-5-1.5l-0.3,6.3l-7.6,0.6l1.1,11.2l-3.4,14.3l6.2,3.9l2.1,9.2l-5.5-0.2l-7.6,3.5l5,8.8l-2.8,3.9
		l-10.7,4.4l-9.7-1l1.4,1l5.5,4.2l-0.9,5.1l-0.5,4.9l0.7,5.7l5.8,6l2.3,7.2l0.8,10l8.3,7.5l-0.3,1.7c4.4,1.8,9.7,0.4,13.8-1.8
		c4.4-2.3,8.5-5.7,13.2-7.7s10.6-2.3,14.4,1.1c4.5,4,4.2,11.2,2.3,17c-1.3,4-2.9,8-3.6,12.1l0.4,0.8c1.3,3,5,4.5,8.3,4.4
		c3.3-0.2,6.4-1.6,9.4-3c3.2-1.5,6.5-3.1,9.7-4.6c2-0.9,4.1-1.9,6.3-1.7c2.2,0.3,4.4,2.2,3.9,4.4c1.3,2.5,5.3,2.3,7.3,0.3
		s2.6-5,3.3-7.8c2.3-9.4,6.6-18.3,12.6-25.9L738.4,364.2z"
      />
    </a>
    <a (click)="SelectCode('N4')">
      <path
        [class.selected]="IsSelected('N4')"
        id="N4"
        d="
		M828.4,524.8c-1-0.7-2-1.3-3-1.9c-1.1-2.9,0.1-6,0.8-8.9c0.8-2.9,0.9-6.5-1.4-8.5c-1.7-1.3-4-1.3-6.2-1.1c-2.1,0.3-4.4,0.6-6.4-0.3
		s-3.3-3.5-2-5.2c-5.5,0.8-10.8-2.6-16.3-3.8c-6.7-1.5-13.7,0.3-20.3,2.2c-2.1,0.6-4.4,1.3-5.3,3.2c-1.5,3,1.3,6.3,3.8,8.5
		c-5.3,4.3-12.4,6.3-19.1,5.5c-2,3.4-5.5,5.9-9.4,6.5c1,0.6,1.2,2.1,0.3,2.9c-6.8,0.7-13.1,5.6-15.3,12.1c3,3.4,6,6.6,9,10
		c1.8-1.3,4.1,1.7,3.3,3.7s-3.2,2.9-5.3,3.5c0.9,3.3-3.7,6.5-6.5,4.4c-0.7,2.2-1.3,4.4-1.9,6.6c2.7,0.6,4.8,3.3,4.7,6.1
		c1.4,0.3,2.9,0.6,4.3,0.9c0,2.7,0,5.4,0,8.1c0.5,0.4,1.1,0.8,1.6,1.2v0.1c4.8-2.9,9.6-5.9,14.4-8.8c4.5,6.3,7.7,13.5,9.1,21.1
		c3.3-2.3,6.5-4.4,9.8-6.7c-0.6,2.2-3.1,6.8-2.2,8.9c0.4,0.9,1.2,1.7,1.5,2.7c0.3,0.7,0.2,1.3,0,2l0.8-0.7c1.6-3.2,6.6-5.4,9.8-2.4
		c-2.1,1.5-1.8,5.3,0.5,6.5s5.5-0.7,5.5-3.3c0-0.8-0.3-1.6-0.1-2.4c0.2-1.5,1.4-2.6,2.7-3.4c6.9-4.5,16.6-3.6,22.9,1.6l0.6-0.2
		c2.6-2.3,5.4-4.7,6.5-8s-0.3-7.6-3.6-8.5c-0.8-0.3-1.7-0.3-2.3-0.8c-1.1-0.8-1-2.4-0.8-3.8c1.7-10.8,4-22.7,12.8-29.2
		c2.1-1.6,4.5-2.8,6.5-4.5c1.9-1.8,3.4-4.4,2.9-7s-3.9-4.5-6-2.9C828.9,528.9,828.5,526.8,828.4,524.8L828.4,524.8z"
      />
    </a>
    <a (click)="SelectCode('N3')">
      <path
        [class.selected]="IsSelected('N3')"
        id="N3"
        d="
		M483.8,406.7c-1.5,2.6-2.2,5.6-1.9,8.6c0.1,1.4,0.4,2.8,0.3,4.2c-0.3,3.1-2.4,5.6-3.9,8.5c-1.1,2.2-1.7,4.7-1.7,7.1
		c-2.3,1-4.8,1.4-7.2,1c-1.2,0.5-1.2,2.3-0.3,3.4c0.8,1,2,1.6,2.9,2.4c3.6,3.2,2.7,9,1.5,13.6c3.5,1.8,7.1,3.7,10.7,5.5
		c0.6,1.5,1.2,3.2,1.2,4.8l0,0c3-1.3,5.5-2.4,8.6-3.8c4.5-1.9,9.2-3.9,14.1-3.5c3.5,0.3,7.4,1.9,10.6,0.3c1.7-0.8,2.9-2.4,4.6-3.1
		c2.9-1.1,6.3,0.6,9.1-0.8c2.5-1.3,3.3-4.5,5.5-6.3c1.6-1.3,3.8-1.6,5.7-2.3s3.9-2.2,4-4.2c0.1-1.1-0.4-2.1-0.6-3.1
		c-0.4-3.5,4.1-6.6,7.2-4.8c0.9-1.3,1.3-2.9,1.3-4.4c1.3,0.3,2.6-0.8,3.2-2c0.6-1.3,0.9-2.6,1.8-3.7c1.3-1.4,3.4-1.7,5.2-2.4
		c7-3.2,7.4-14.9,14.4-17.3l0.3-0.3l-3.4-3.7l-1.8-3.2l-5.1-2.8l-5.3-5l-7-5.3l2.5-3.6l-3-6.7l-2.8-7.7l-5.1-1.8l-4.3-8l-4.2-0.3
		l-6.8,0.3l-5.6-4.7l-6,0.9l-1.7,6.5l-11,4.5l-5.1,7.6l-5.1,3.4l1.4,13.2l-1.2,4.2l-4.9-3.9l-1.3,7l-6.5,1.7l-2,7.5l-1.9,3.2
		L483.8,406.7z"
      />
    </a>
    <a (click)="SelectCode('N22')">
      <path
        [class.selected]="IsSelected('N22')"
        id="N22"
        d="
		M778.5,454.3c5-2.1,9.5-4,14.5-6.2c1.7,2.4,3.4,5,5.5,7.2c2.4-3.5,5.8-6,8.9-8.9c3.2-2.9,6.1-6.4,6.9-10.6s-1.6-9.2-5.8-10.1
		c0.7-3.7,2.9-7.1,6-9.3c-1.7-2-3.4-3.9-5.2-5.9c2.5-0.3,3.9-3.4,3.1-5.8c-0.7-2.4-2.7-4.2-4.4-6c-1.8-1.7-3.7-3.7-4-6.1
		c-0.3-2.3,0.7-4.6,0.4-6.9c-0.4-3.2-3.5-5.5-6.7-6.2s-6.5,0-9.7,0.7c-0.1-2.3-0.3-4.6-1.3-6.6s-3-3.8-5.3-3.6
		c-1,0.1-1.9,0.5-2.9,0.5c-1.9,0.1-3.8-1.5-3.9-3.4c-1.1,1.8-2.6,3.5-4.4,4.7c-1.4-2.4-4.9-2.5-7.6-2c-2.8,0.5-5.9,1.2-8.1-0.4
		c-2.9-2.1-2.4-6.5-1.3-10s2.3-7.5,0.1-10.4c-3.4,0.6-6.3,3-7.5,6.2c1.9,2.5,2.1,6.2,0.4,8.8c-0.6-1.6-2.7-2.1-4.2-1.6
		c-1.6,0.6-2.7,1.8-3.8,3.2c-6,7.6-10.3,16.5-12.6,25.9c-0.7,2.8-1.3,5.8-3.3,7.8s-6,2.3-7.3-0.3c0.4-2.2-1.8-4.1-3.9-4.4
		c-2.2-0.3-4.3,0.8-6.3,1.7c-3.2,1.5-6.5,3.1-9.7,4.6c-3,1.4-6,2.9-9.4,3c-3.3,0.2-6.9-1.3-8.3-4.4l-0.4-0.9
		c-0.3,1.8-0.4,3.8-0.1,5.7c1.1,6.9,7,12,12.9,15.5c3.9,2.3,8.3,4.6,9.8,8.8c2.1,5.8-1.8,13.7,3,17.6l0.3-0.5
		c3.3,0.6,6.4-1.3,8.8-3.6s4.5-4.9,7.5-6.4c4.4-2.3,9.8-1.5,14.2,0.8s7.8,6,11.1,9.7c1.7,1.9,3.5,3.9,6,4.6c2.4,0.7,5.6-0.8,5.7-3.4
		c0-1.7-1.3-3.4-0.9-5c0.6-2.5,4.2-2.6,6.7-2c1.8,0.4,3.6,0.8,5,1.9s2.2,3.3,1.3,4.8c3.4-1.6,7.5,1.3,9.3,4.6
		C777.9,452.9,778.2,453.6,778.5,454.3L778.5,454.3z"
      />
    </a>
    <a (click)="SelectCode('N2')">
      <path
        [class.selected]="IsSelected('N2')"
        id="N2"
        d="
		M578,545.4c1.8-1.2,2.6-3.7,3.4-5.8c0.8-2.4,2.6-5.1,5.2-5c2.4,0.2,4.6,3,6.9,2c2.1-2.1,1.8-5.5,1-8.4s-2.2-5.7-1.9-8.6
		c3.5-0.3,7-1,10.4-2c1.4-0.4,2.9-0.9,3.7-2.2c0.7-1,0.7-2.3,0.9-3.6c1.2-5.9,7.4-9.1,12.9-11.5c1.8-0.8,3.7-1.5,5.6-1.3
		c0.6,0.1,1.2,0.3,1.8,0.2c1.4-0.3,2.1-2.1,1.7-3.5c-0.4-1.4-1.7-2.4-2.8-3.4c-2.9-2.3-5.7-4.6-8.6-7c-0.5-0.4-1.1-0.9-1.3-1.5
		c-0.3-1.1,0.3-2.2,1-3.1c2.3-2.9,4.7-7.6,8.6-9c2-0.8,3.9-0.2,5.8-1.1c1.9-0.9,3.5-3.2,5.3-4.4c1.1-0.7,2.3-1,3.3-1.9
		c2.3-2.3,0.2-4.1-0.9-6c0.1,0.1-3.8-3.9-2.6-3.9c1.9-0.4,3.3-2.6,2.9-4.5c1.3,0,2.5,0,3.8,0c0.3-1.3,0.8-2.6,1.1-3.9
		c-5.9-3.2-10.5-8.7-12.6-15c-0.5-2.8-2.9-4.9-5.5-6s-5.5-1.5-8.1-2.3c-4.4-1.3-8.8-4.5-9.2-9.1c-0.2-1.6,0.3-3.2,0.6-4.7
		c0.8-3.5,1.7-7.1,2.5-10.7l-0.4-0.4l-2.4-3.8l-5.6-4.7l-8.4-3.4l-4.5,1.5l-5.3,9.7l-5.6,6.7l0.3,0.1c-7.7,1.9-7.9,14.3-15.1,17.5
		c-1.8,0.8-3.9,1-5.2,2.4c-0.9,1-1.2,2.4-1.8,3.7c-0.6,1.3-1.8,2.3-3.2,2c0,1.6-0.5,3.2-1.3,4.4c-3.1-1.8-7.7,1.3-7.2,4.8
		c0.2,1.1,0.6,2.1,0.6,3.1c-0.1,2.1-2.1,3.5-4,4.2s-4.1,1-5.7,2.3l-0.7,0.3c2.5,3.9,7,6.5,11.7,6.7c0.9,0,1.9,0,2.9,0.3
		c3.2,1,3.8,5.5,6.5,7.4c1.7,1.1,4.5,2.3,3.6,4c-0.4,0.8-1.5,1.1-1.8,1.9s0.2,1.7,0.5,2.5c1.4,3.4,0.3,7.6-2.8,9.7
		c3.9,5.8,5.5,13.1,4.5,20.1c-0.2,1.2-0.4,2.3-0.1,3.5c0.3,0.9,0.8,1.7,1.3,2.4c1.6,2.9,1.3,6.5,2.3,9.7c1.9,5.8,7.8,9.1,13.3,12
		c-2.7,5-4.4,11.7-1,16.2L578,545.4"
      />
    </a>
    <a (click)="SelectCode('N1C')">
      <path
        [class.selected]="IsSelected('N1C')"
        id="N1C"
        d="
		M723.1,686c-4.3,0.7-7.9,0.6-11.8-0.6c-2-0.6-4.6-0.7-6.4-1.8c-2-1.3-2.4-3.9-5-4.4c-1.9,3.8,1.4,11.7,2.3,15.5
		c0.6,3,1.7,6.5,4.6,7.4c-1.3,1.8-2.5,3.5-3,5.5c-0.5,2.1-0.2,4.5,1.5,5.9c2.3,2,6.6,1.3,8.2,3.9c1.4,2.5-1,5.5-1.8,8.2
		c-1.1,3.5,0.7,7.6,3.9,9.3c3.3,1.7,7.6,0.6,9.8-2.4l-0.1-0.8c-1-2.2-1.5-4.9-1.3-7.2c0.3-4.9,1.8-9.7,0.8-14.4
		c-0.9-4.1-3.6-7.7-4.4-11.8c-0.8-4.4,1-8.8,4-12.3L723.1,686z"
      />
    </a>
    <a (click)="SelectCode('N1')">
      <path
        [class.selected]="IsSelected('N1')"
        id="N1"
        d="
		M850.3,748.4c0.4-1.3,0.8-2.5,1.3-3.8c-2.1,0.9-4-2.3-3.1-4.4c0.9-2.2,3.2-3.4,4.9-5s2.7-4.6,0.8-6.2c1-1.6-1-4-2.8-3.3
		c1-3,1.1-6.2,0.4-9.3c0.9-0.3,1.8-0.8,2.7-1.1c-2.3-1.8-2.1-5.8,0.3-7.3l-0.3,0.1c-3.8-3.5-2.8-9.7-1-14.6c1.8-4.9,4-10.2,2-15
		c-0.8-2-2.5-4-2-6.1c0.6-2.7,4.3-4.5,3.5-7.1c-0.6-1.8-3.3-3.2-2.5-5H854c-0.4-6.9-1.7-13.7-8.1-16.4c-2.1-0.8-4.4-0.9-6.5-1.8
		c-2-0.8-3.9-3.1-3.2-5.2c-5.9-0.4-10.1,5.3-14.6,9.1c-9.1,7.6-22,8.1-33.3,11.7c-12.3,3.9-23.2,11.9-35.5,15.9
		c-7.1,2.3-14.8,3.3-21.5,6.7s-12.4,10.5-11.2,17.9c0.7,4.2,3.4,7.7,4.4,11.8c1,4.7-0.5,9.6-0.8,14.4c-0.3,4.9,0.9,10.1,5.6,11.3
		l0.5-0.3c6.5-2.7,13.3-4.5,20.3-4.7c2.3,1.5,4.6,3,6.7,4.8l1.3,0.3c5.6-3.7,11.7-7.6,18.4-7.6c5.2,0,10.2,2.3,14.8,4.7
		c7.8,4.2,15.3,9,23.4,12.5c8.1,3.5,17.1,5.7,25.8,4.2c2.3-0.4,4.8-1.1,7.1-0.9c0.8,0.1,1.6,0.2,2.3,0.5L850.3,748.4z"
      />
    </a>
    <a (click)="SelectCode('N5')">
      <path
        [class.selected]="IsSelected('N5')"
        id="N5"
        d="
		M831.2,637.2c-11.2-6-17.5-20.1-14.5-32.6c0.6-2.4,0.9-6-1.5-6.5c-5.9-7.3-17.5-9.2-25.3-4c-1.3,0.8-2.4,1.9-2.7,3.4
		c-0.1,0.8,0.2,1.6,0.1,2.4c-0.1,2.6-3.3,4.4-5.5,3.3c-2.3-1.2-2.6-5-0.5-6.5c-3.2-2.9-7.2-1.3-10.7,3.1l-0.3,1
		c-0.5,1-1.3,2-2.1,2.8c-3.4,3.5-5.5,9.1-4,14c1.6,5.7,8.6,10.1,7,15.9c-2.3-1.2-5.3,0.4-6.3,2.8c-0.9,2.4-0.3,5.2,1.1,7.4
		c1.3,2.2,3.2,4,4.9,6c3,3.5,5.4,7.7,6.9,12.1l0.8-0.1c3.2-1.5,6.5-2.9,9.8-3.9c11.3-3.6,24.3-4,33.3-11.7c3.4-2.8,6.5-6.6,10.2-8.3
		L831.2,637.2z"
      />
    </a>
    <a (click)="SelectCode('N14')">
      <path
        [class.selected]="IsSelected('N14')"
        id="N14"
        d="
		M736.5,194.9c2.2,3.9,5.2,7.5,8.8,10.2c-4-0.1-7.6,3.6-8,7.6s1.8,8,5.1,10.3c2.4,1.8,5.5,2.8,8.6,2.3c-5.4,5.3-10.9,10.9-12.8,18.1
		c3.9,2.8,7.7,5.6,11.6,8.4c1.1,0.8,2.3,1.8,2.3,3.1s-1.2,2.3-2.1,3.2c-1.9,1.9-3,4.4-3.4,7l-0.9,0.9c-2.5,0.8-5,1.4-7.6,2.2
		c0.3,11.6,5.5,23,14.1,30.7c-2.2,4.1-4.4,8.3-6.5,12.4c-0.4,0.8-0.8,1.5-1.5,2c-2,1.5-5-0.1-6.7-1.8s-3.9-4-6.4-3.6
		c-2.8,0.4-4.1,4-3.2,6.7c0.9,2.7,3.3,4.5,5.5,6.2c-3.9,0.8-7,4.2-8.7,7.9c-1.7,3.7-2.2,7.8-2.6,11.8l-2.2,0.1
		c-0.7-0.1-1.3-0.2-2-0.3c-2.4-0.4-6.8-1.3-7.3-4.2c-0.5-2.4,2.9-4.4,2.4-7c-0.8-3.8-3.2-2.9-6.2-3.8c-3.9-1.1-12.9-5.1-15.1-8.6
		c-3.1-4.8,0-11.9-4.5-16c-4.6-4.3-13.1,0.1-18-3.9c-3.5-2.9-3.2-8.1-2.6-12.6c0.6-4.4,0.8-9.8-2.8-12.5c-2.4-1.8-5.9-1.7-8.7-2.7
		c-2.9-1.1-5.3-5.2-3.1-7.3l0,0c3.1,0.8,4.4,1.3,6.7,3.9c0.2,0.2,0.3,0.3,0.5,0.3s0.3,0,0.4-0.1c1.6-0.7,2.4-2.5,2.9-4.2
		c1-3.9,2.7-4.2,4.6-6.9c1.7-2.4,1.6-1.7,0-4.7c-1.2-2.2-4.3-7.9-6.7-8.7c-5.7-1.8-2.2-6.8-4.6-11c-1.7-2.9-7.5-2.6-8-5.3
		c-0.2-0.8,0.3-1.8,0.7-2.5c2.3-3.9,6.7-5.9,7.2-10.8c0.1-1,0-2.1,0.2-3.1c0.4-3.9,4.5-8.5,6.5-11.8h13.3l13.3-6.1l4.1-11.4
		c0,0-7-16.6-7-16.7c-0.6-1.3,12.8-3.8,10.8-9.1c3,0.3,5.8,2.1,7.8,4.4c2.6,2.9,4.5,6.3,6.4,9.7c2.4,4.6,3.4,5.7,1.1,9.8
		c-0.6,1.1-0.7,2.5,0.2,3.4c0.7,0.8,1.8,0.8,2.7,1.2c1.9,0.8,3.4,2.4,3.9,4.4c-1.3,0.5-1.7,2.4-0.9,3.6c1.3,2.2,3.7,1.8,4.7,4.4
		l6.8,11.6l7.7-11.6L736.5,194.9z"
      />
    </a>
    <a (click)="SelectCode('N21')">
      <path
        [class.selected]="IsSelected('N21')"
        id="N21"
        d="
		M736.5,194.9c2.2,3.9,5.2,7.5,8.8,10.2c-4-0.1-7.6,3.6-8,7.6s1.8,8,5.1,10.3c2.4,1.8,5.5,2.8,8.6,2.3c-5.4,5.3-10.9,10.9-12.8,18.1
		c3.9,2.8,7.7,5.6,11.6,8.4c1.1,0.8,2.3,1.8,2.3,3.1s-1.2,2.3-2.1,3.2c-4.1,4.1-4.4,11-1.8,16.2c2.6,5.2,7.7,8.8,13.2,10.8
		s11.2,2.7,17,3.3c1.7-1.1,2.5-2.9,3.5-4.6s2.4-3.4,4.4-3.6c2.4-0.3,2.3,2.5,4.3,3c1.9,0.5,3.3-1.2,4.5,1.3c1.2,2.3,0.5,5.1,0.1,7.6
		c-0.5,2.6-0.6,5.5,1.3,7.4c4.1-0.8,6.7-5.8,5.2-9.7c3.5,1.2,7.5,1.4,11.2,0.5c0.4,3.7,5.5,5.9,8.5,3.5c2.2-1.8,2.6-4.8,3.9-7.1
		c1.3-2.3,5.1-4,6.7-1.8l1.1-1.3c4.4-2.4,8.9-4.9,13.3-7.3c-2.9-6.5-3.5-13.9-1.8-20.9c-4-3.7-6.3-9.1-6-14.5
		c1.8-1.7,3.6-3.4,5.4-5.1l-1.6-3.3l-6.3-9.3l3.4-11.4l1.6-10.2l-8.6-0.6l-8.1-3.5c-0.5-0.3-0.8-6-0.8-6.5c-0.3-3-0.3-6.5-1.3-9.4
		c-1.7,0.8-2.9,2.9-4.1,4.4c-1,1.1-1.9,2.2-2.9,3.4l-11.9,5.4l-7.5-9.4l-15.6-9.6l-12.8,1.7l-3.1,9.7l-11.4-1.6l-15.9,9.1
		L736.5,194.9z"
      />
    </a>
    <a (click)="SelectCode('N13')">
      <path
        [class.selected]="IsSelected('N13')"
        id="N13"
        d="
		M745.6,266.1c-2.5,0.8-5,1.4-7.6,2.2c0.3,11.6,5.5,23,14.1,30.7c-2.2,4.1-4.4,8.3-6.5,12.4c-0.4,0.8-0.8,1.5-1.5,2
		c-2,1.5-5-0.1-6.7-1.8s-3.9-4-6.4-3.6c-2.8,0.4-4.1,4-3.2,6.7c0.9,2.7,3.3,4.5,5.5,6.2c-3.9,0.8-7,4.2-8.7,7.9
		c-1.7,3.7-2.2,7.8-2.6,11.8l0.9,0.6c1.6,0.4,3,1.1,4.3,2.4c2.3,2.6,3.2,7,1.7,10.2c-0.9,1.9-2.6,4-1.6,5.9c1,2,3.9,1.7,6.1,1.4
		c2.3-0.3,5.4,0.8,5,3l0.3,0.8c0.9-1.1,1.8-2,3.2-2.4c1.6-0.6,3.7,0,4.2,1.6c1.7-2.7,1.5-6.4-0.4-8.8c1.2-3.2,4.1-5.6,7.5-6.2
		c2.2,2.9,0.9,7-0.1,10.4c-1.1,3.4-1.6,7.9,1.3,10c2.3,1.6,5.4,0.9,8.1,0.4c2.8-0.5,6.1-0.4,7.6,2c1.8-1.3,3.3-2.9,4.4-4.7
		c0.3,1.9,2.1,3.5,3.9,3.4c1,0,1.9-0.4,2.9-0.5c2.3-0.2,4.4,1.6,5.3,3.6c1,2,1.1,4.4,1.3,6.6c3.2-0.7,6.5-1.3,9.7-0.7
		c0.5,0.1,1.1,0.3,1.6,0.4l0.1-0.2c-0.1-2.9,2-5.6,4.8-6.2c0.8-3.4,1.7-6.7,2.5-10.2l0.5-0.3c-5.5-1.1-9.5-7.5-7.9-12.8
		c3.3-1.8,7.4-1.9,10.7-0.3c0.3-2.1,0.4-4.2,0.7-6.3c1.3,1.5,3.5,1.7,5.3,0.9s3.2-2.2,4.4-3.7c5.9-7.2,9.3-16.8,7.6-26
		c2.5,0.8,4.8-1.8,6.8-3.5c1.3-1.1,2.7-1.8,4.2-2.4l-0.6-0.6c-2-0.9-1.8-4-0.6-6c1.2-1.9,2.9-3.8,2.9-6c-0.1-2.8-2.9-4.4-5-6.1
		c-1.6-1.2-3.2-3.1-3.4-5l-0.6-0.5c-1.6-2.3-5.3-0.6-6.7,1.8c-1.4,2.3-1.8,5.5-3.9,7.1c-2.9,2.3-8.1,0.2-8.5-3.5
		c-3.7,0.8-7.6,0.7-11.2-0.5c1.5,3.9-1.1,8.8-5.2,9.7c-1.8-1.8-1.8-4.8-1.3-7.4s1.2-5.4-0.1-7.6c-1.3-2.5-2.6-0.8-4.5-1.3
		c-1.9-0.4-1.8-3.2-4.3-3c-1.9,0.2-3.4,1.9-4.4,3.6s-1.8,3.6-3.5,4.6c-5.8-0.6-11.6-1.3-17-3.3s-10.5-5.6-13.2-10.8
		c-1.3-2.6-1.8-5.6-1.6-8.5L745.6,266.1z"
      />
    </a>
    <a (click)="SelectCode('N9')">
      <path
        [class.selected]="IsSelected('N9')"
        id="N9"
        d="
		M1002.9,251.8c-4.7,4.5-5.8,25.8-9.7,39.4c-2.7,9.4-9.4,17-14.5,25.3c-1.9,3-3.7,6.3-5.2,9.7h0.1c-6.2-1.7-12.4-3.3-18.6-5
		c2.4-4.1-1.9-9.4-6.6-10.2c-4.7-0.8-9.4,1.3-14,2.3c-4.7,1-10.5,0.5-12.9-3.6c1.8,5.4,0.3,11.7-3.8,15.6
		c-5.1,1.3-10.8,0.1-14.9-3.2c-3.4,4-9.8,5.1-14.5,2.5c-0.4-0.3-0.8-0.7-1.2-1c-12.8-2.3-25.3-7-36.4-13.6c-3.5-2-7.9-2.2-11.7-0.8
		l-0.6-0.6c-2-0.9-1.8-4-0.6-6c1.2-1.9,2.9-3.8,2.9-6c-0.1-2.8-2.9-4.4-5-6.1c-2.2-1.6-4.3-4.6-2.9-6.9c4.4-2.4,8.9-4.9,13.3-7.3
		c-2.9-6.5-3.5-13.9-1.8-20.9c-4-3.7-6.3-9.1-6-14.5c1.8-1.7,3.6-3.4,5.4-5.1l0.8,0.7l1.5,2.4l5.9,7l9.6,6.1l13.2-2.8l13.3-2.5
		l12.8-18.9c4.1-4.4,10.3-9.1,12.6-14.9c0.6-1.5,0.3-5.2,1.8-6.1c0.9-0.6,5.8,0.8,5.2,2.1c-4.8,10.2,5.5,10.1,12.6,13.1l15.1,3.7
		l3.3-1.2c2.3,0.8,4.6,1.8,7,2.5c3.8,1.3,8.1-0.8,11.5,0.9c6.9,3.5,2.1,12.5,7.1,16.2C978.3,245.3,1002.9,252,1002.9,251.8"
      />
    </a>
    <a (click)="SelectCode('N18')">
      <path
        [class.selected]="IsSelected('N18')"
        id="N18"
        d="
		M958.9,387.6c0.8-0.4,1.8-0.8,2.6-1.2c3.1-1.2,6.5-1.8,9.9-1.4l0.9-0.3c3.3-7.9,4-16.8,2.1-25c-1.3-5.3-3.5-10.4-4.2-15.8
		c-0.7-5.9,0.7-11.7,2.9-17.1l0.3-0.7c-6.2-1.7-12.4-3.3-18.6-5c2.4-4.1-1.9-9.4-6.6-10.2s-9.4,1.3-14,2.3c-4.7,1-10.5,0.5-12.9-3.6
		c1.8,5.4,0.3,11.7-3.8,15.6c-5.1,1.3-10.8,0.1-14.9-3.2c-3.4,4-9.8,5.1-14.5,2.5c-0.4-0.3-0.8-0.7-1.2-1
		c-12.8-2.3-25.3-7-36.4-13.6c-5-2.8-11.6-2.1-15.9,1.6c-2,1.8-4.3,4.3-6.8,3.5c1.7,9.1-1.8,18.7-7.6,26c-1.2,1.5-2.6,2.9-4.4,3.7
		c-1.8,0.8-4,0.5-5.3-0.9c-0.3,2.1-0.4,4.2-0.7,6.3c-3.4-1.6-7.5-1.5-10.7,0.3c-1.6,5.5,2.3,11.8,7.9,12.8l-0.5,0.3
		c12.5,5.7,26.4,8.2,40.2,7.3c6.6-0.4,13.1-1.7,19.7-1.9c3.1-0.2,6.3-0.1,9.4-0.1c5,0.1,10,0.3,14.9,0.1c0.1,0,0,2,0.3,2.3
		c0.8,1,2.4,0.6,3.4,0.3c8.9-2.3,18.1-3.7,27.4-3.9c2-0.1,4.1-0.1,5.8,1c1.3,0.8,2.2,2.3,3.3,3.4c2.6,2.8,6.5,3.8,10.3,4.3
		s7.6,0.8,11.1,2.4c3.4,1.7,6.3,5.2,5.8,9"
      />
    </a>
    <a (click)="SelectCode('N17')">
      <path
        [class.selected]="IsSelected('N17')"
        id="N17"
        d="
		M799.3,456.1c2.9,2.9,6.1,5.2,10.1,5.8c2.2,0.3,4.5,0.2,6.6,1.1c1.8,0.8,3.1,2.2,4.7,3.3c4.7,3.1,11.8,1.8,15.1-2.9
		c5-3.8,11.3-5.6,17.5-5.1c2.4,0.2,5,0.8,7.3-0.1c2.3-0.8,4-3.8,2.7-5.8c2.5-0.2,5-0.3,7.6-0.4c-2,1.4-2.8,4.4-1.6,6.5
		c1.1,2.2,3.9,3.3,6.2,2.4c0.3,1.2,0.8,2.3,1.1,3.5c6.1-0.4,12.3,0.1,18.3,1.6c1.8,0.4,3.5,1,4.7,2.3c1.3,1.6,1.6,3.9,1.6,6
		c0.2,7-0.4,14.3,1.8,21s8.1,12.8,15.2,12.4l1-1.4c1.2-5.2,4.1-10,8.6-13c3.9-2.7,9.1-4.4,11-8.8c1.4-3.2,0.6-6.9-0.3-10.3
		c-1.6-6.1-3.3-12.3-5-18.4c-1.3-4.4-2.7-9-1.6-13.4c1.8-7.7,10.3-12.6,11.7-20.4c0.9-5.3-1.7-10.7-0.8-16.1
		c0.6-3.6,2.9-6.8,5.3-9.6c2.7-3,5.8-5.8,9.2-7.8l0.8-0.8c0.5-3.8-2.3-7.3-5.8-9c-3.4-1.7-7.3-1.8-11.1-2.4s-7.7-1.6-10.3-4.3
		c-1.1-1.2-1.9-2.5-3.3-3.4c-1.7-1.1-3.8-1.1-5.8-1c-9.2,0.3-18.4,1.6-27.4,3.9c-1,0.3-2.6,0.7-3.4-0.3c-0.3-0.3-0.2-2.3-0.3-2.3
		c-5,0.3-10-0.1-14.9-0.1c-3.1,0-6.3-0.1-9.4,0.1c-6.6,0.3-13.1,1.5-19.7,1.9c-13.7,0.9-27.7-1.7-40.2-7.3
		c-0.8,3.4-1.7,6.7-2.5,10.2c-2.8,0.6-4.9,3.4-4.8,6.2l1.3,0.8c1.9,1.1,3.5,2.9,3.9,5.1c0.3,2.3-0.8,4.6-0.4,6.9
		c0.3,2.5,2.3,4.4,4,6.1c1.8,1.7,3.8,3.5,4.4,6c0.7,2.4-0.7,5.5-3.1,5.8c1.8,1.9,3.5,3.9,5.2,5.9c-3.1,2.2-5.3,5.6-6,9.3
		c4.2,0.8,6.5,5.8,5.8,10.1c-0.8,4.2-3.7,7.7-6.9,10.6s-6.6,5.5-9.1,9.1L799.3,456.1z"
      />
    </a>
    <a (click)="SelectCode('N15')">
      <path
        [class.selected]="IsSelected('N15')"
        id="N15"
        d="
		M919.3,516.5c-0.8-2.8-0.9-5.7-0.5-8.6l-0.7-0.3c-7,0.4-13-5.8-15.2-12.4c-2.2-6.7-1.6-13.9-1.8-21c-0.1-2.1-0.3-4.4-1.6-6
		c-1.2-1.3-2.9-1.9-4.7-2.3c-6-1.5-12.2-2.1-18.3-1.6c-0.3-1.2-0.8-2.3-1.1-3.5c-2.3,0.8-5.1-0.3-6.2-2.4c-1.1-2.2-0.4-5.1,1.6-6.5
		c-2.5,0.2-5,0.3-7.6,0.4c1.4,2-0.3,5-2.7,5.8c-2.3,0.8-4.9,0.3-7.3,0.1c-6.2-0.5-12.6,1.3-17.5,5.1c-3.3,4.6-10.3,5.9-15.1,2.9
		c-1.6-1-2.9-2.5-4.7-3.3c-2-0.9-4.4-0.7-6.6-1.1c-7.2-1.2-12.3-7.7-16.4-13.8c-5,2.1-9.3,3.9-14.3,6.1l0.3,1.2c1,2.5,1.9,5,3.7,7.1
		s4.4,3.4,6.3,5.5c3.2,3.3,4.3,8.1,4.1,12.7c-0.3,4.5-1.7,9-3.1,13.3v0.6c1.3,0.1,2.7,0.3,4,0.5c5.5,1.2,10.7,4.6,16.3,3.8
		c-1.3,1.7,0,4.4,2,5.2c2,0.8,4.2,0.5,6.4,0.3c2.1-0.3,4.5-0.3,6.2,1.1c2.3,1.9,2.3,5.5,1.4,8.5c-0.8,2.9-1.9,6-0.8,8.9
		c1.3,0.8,1.8,0.8,3,1.7c9.1,0.8,18.3,1.4,27.4,2.2c2.1,0.2,4.2,0.3,6.2-0.3c2.3-0.7,4.2-2.2,6.5-3c2.2-0.8,5.1-0.8,6.5,1.1
		c1.3-1.2,2.8-2.3,4.1-3.6c12.1-3.9,25.3-4.8,37.8-2.3c1.1,0.3,1.2-0.8,2.3-1.1L919.3,516.5z"
      />
    </a>
    <a (click)="SelectCode('N16')">
      <path
        [class.selected]="IsSelected('N16')"
        id="N16"
        d="
		M813.3,595.3c2.6-2.3,5.4-4.7,6.5-8s-0.3-7.6-3.6-8.5c-0.8-0.3-1.7-0.3-2.3-0.8c-1.1-0.8-1-2.4-0.8-3.8c1.7-10.8,4-22.7,12.8-29.2
		c2.1-1.6,4.5-2.8,6.5-4.5c1.9-1.8,3.4-4.4,2.9-7s-3.9-4.5-6-2.9c-0.3-2-0.6-4.1-0.8-6.1c9.1,0.8,18.3,1.4,27.4,2.2
		c2.1,0.2,4.2,0.3,6.2-0.3c2.3-0.7,4.2-2.2,6.5-3c2.2-0.8,5.1-0.8,6.5,1.1c1.3-1.2,2.8-2.3,4.1-3.6c12.1-3.9,25.3-4.8,37.8-2.3
		c1.1,0.3,1.2-0.8,2.3-1.1l0.8,1.8c-1.9-0.7-3.9,0.8-6.9,3c-4.4,3.3-9,6.6-13.4,9.9c-4.4,3.3-9.8,6.8-15.1,5.4
		c-3.4-0.9-6-3.6-9.4-4.8c-3.4-1.1-8.2,0.9-7.6,4.4c0.7,3.4,4,4.6,7,5.2c4.7,1,4.9-1.6,8.6-2.5c4.3-1,2.9,6.6,4.9,8.4
		c1.4,1.3,3.6,1,5.1,2.9c1,1.3,1.1,3.1,2,4.4c0.9,1.3,1.8,2.7,2.9,4c1.8,2.6,3.8,5.5,3.2,8.6s-5.2,5.2-7,2.6c-1.6,3.4-4.5,6.2-8,7.7
		c0.7,7.5,4.6,14.6,10.6,19.2c-3.4,5.2-9.1,8.8-15.3,9.6c1.1,4.5,2.1,9,3.2,13.5l0.3,0.8c-0.9-0.1-1.8-0.1-2.8,0
		c-5,0.5-9.3,3-13.6,5.5c-2.6,1.5-5.4,3.2-7,5.8s-1.5,6.5,1,8.2c-2.2-1-4.7,1.1-5.1,3.4c-0.5,2.3,0.3,4.7,0.8,7s0.2,5.1-1.8,6.5
		c-0.8,0.5-1.8,0.8-2.2,1.8c-0.3,0.5-0.2,1,0.1,1.4l-0.5,0.1c-0.4-6.9-1.8-15.3-8.1-17.9c-2.1-0.8-4.4-0.9-6.5-1.8
		c-2-0.8-3.9-3.1-3.2-5.2c-1.7-0.2-3.3,0.3-4.7,0.9L831,637c-11.2-6-17.5-20.1-14.5-32.6c0.6-2.4,0.9-6-1.5-6.5
		c-0.8-0.9-1.6-1.8-2.4-2.5L813.3,595.3z"
      />
    </a>
    <a (click)="SelectCode('WC2')">
      <path
        [class.selected]="IsSelected('WC2')"
        id="WC2"
        d="
		M700.2,832c-1.5-2.1-0.7-5,0.8-7.1s3.5-3.9,4.4-6.4c0.8-2.4,0.3-5.1-0.3-7.6c-0.6-2.7-1.3-5.4-2.1-8l0,0c2.4-0.3,5-0.4,7.1-1.4
		c1.6-0.8,2.4-2.4,4.3-2.9c1.6-0.4,3.5,0.4,3.8,2c0.2,0.9-0.3,1.8-0.3,2.8c0.3,2.9,3.6-0.2,4.4-0.8c9.8-6.9,22.7-9.2,34.2-6.2
		l-0.6,0.8c-1.2,2-0.7,5.1,1.3,6.4c0.6,0.4,1.3,0.7,1.8,1.1c1.4,1.3,1,3.8-0.2,5.4c-1.2,1.6-2.9,2.7-3.9,4.4
		c-1.9,2.9-1.5,6.8,0.2,9.9c1.6,3,4.3,5.4,6.9,7.7v0.2c-1.8,0.3-3.7,0.5-5.5,0.9c-9.8,2.2-19.3,7.5-24.5,16h0.6
		c-1.8-0.6-3.5-1.2-5.3-1.8c-6.3,1.4-13.1,0.3-18.7-2.9c-1.3-1.4-0.5-4.2,1.4-4.7c-2.9-2.3-6.2-3.8-10.2-4
		C700.1,834.5,700.1,833.2,700.2,832L700.2,832z"
      />
    </a>
    <a (click)="SelectCode('WC1')">
      <path
        [class.selected]="IsSelected('WC1')"
        id="WC1"
        d="
		M683.3,764.7c4-2.8,7.6-6.5,11.2-9.7c9.2-4.5,17.7-10.4,26.8-15.3c9.1-4.9,18.9-8.8,29.2-8.9c3.7,2.4,7.5,4.9,10.2,8.4
		s4.1,8.3,2.6,12.4c-1.6,4.1-6.8,6.9-10.7,4.8c4.2,2.9,5.5,9.2,2.7,13.4c-1.3,2.1-3.5,3.9-3.5,6.3c0,2.7,2.5,4.4,4.2,6.5
		c3.1,3.8,3.4,9.5,0.9,13.6c-11.6-2.9-24.4-0.6-34.2,6.2c-0.9,0.6-4.2,3.7-4.4,0.8c-0.1-0.9,0.3-1.8,0.3-2.8c-0.3-1.6-2.2-2.4-3.8-2
		c-1.8,0.5-2.7,2.1-4.3,2.9c-2.3,1-4.8,1.2-7.1,1.4h0.1c-3.6-11.9-9.1-23.3-16.1-33.7C686.1,767.5,684.9,765.9,683.3,764.7
		L683.3,764.7z"
      />
    </a>
    <a (click)="SelectCode('EC4')">
      <path
        [class.selected]="IsSelected('EC4')"
        id="EC4"
        d="
		M827.2,839.9c0.1-3.4,0.2-6,0.3-9.7c3.5-2,2.1-7.8-1.3-10c-3.4-2.2-7.7-2-11.7-2.8c-9.5-1.8-17.2-8.3-25.7-12.8
		c-5.2-2.8-10.7-4.9-16.4-6c-4.9-1.1-10.6-0.6-15.2-2.4c-2.3,1.8-2.1,6,0.3,7.5c0.6,0.4,1.3,0.7,1.8,1.1c1.4,1.3,1,3.8-0.2,5.4
		c-1.2,1.6-2.9,2.7-3.9,4.4c-1.9,2.9-1.5,6.8,0.2,9.9c1.6,3,4.3,5.4,6.9,7.7v0.2c8.1-0.9,16.4-0.3,24.4,0.7
		c13.7,1.6,27.4,4.2,40.5,8L827.2,839.9z"
      />
    </a>
    <a (click)="SelectCode('EC3')">
      <path
        [class.selected]="IsSelected('EC3')"
        id="EC3"
        d="
		M855.4,851c2.7-5.1,5-10.6,6.6-16.1c3.4-1.1,5.5,5.5,8.9,4.4c1.3-0.5,1.9-2.3,1.6-3.7c-0.3-1.4-1.3-2.6-2.3-3.7
		c-4.2-1.6-7.2-5.9-7.5-10.3c-0.1-2.6,0.6-5.1,0.7-7.7s-0.8-5.5-3.1-6.6c-2.3-1.2-5.5-0.6-6.8-2.8c-3.7-1.5-8.5-2.9-11.2,0.2
		c-1.5,1.8-1.7,4.4-3.1,6.2c-1.7,2-4.5,2.4-7.1,2.3c-2.6-0.2-5.2-0.8-7.8-0.3c-2.6,0.4-5.1,2.5-5,5.1v0.1c2.4,0.3,4.8,0.8,6.9,2.1
		c3.4,2.2,4.8,8,1.3,10c-0.1,3.6-0.2,6.5-0.3,10.1l0.1,0.4C836.9,843.4,846.3,846.8,855.4,851L855.4,851z"
      />
    </a>
    <a (click)="SelectCode('EC2')">
      <path
        [class.selected]="IsSelected('EC2')"
        id="EC2"
        d="
		M853.7,752.3c-6.5,1.4-13,2.8-19.6,4.2c-2.3,0.5-4.9,1.1-6.3,3c-1.9,2.7-0.8,6.4-0.5,9.7s-1.8,7.6-5,6.8c2.6,1.6,2.3,6-0.3,7.7
		c-2.5,1.8-6,1.2-8.6-0.6s-4.3-4.4-5.9-7c-3.3,2.3-7.8,2.9-11.5,1.3c3.7,10,3.9,21.1,0.8,31.3l0.8,0.9c5.3,3.4,10.7,6.5,16.8,7.6
		c1.2,0.3,2.3,0.3,3.5,0.5l1.3,0.1c-0.1-2.6,2.4-4.6,5-5.1s5.2,0.2,7.8,0.3s5.5-0.3,7.1-2.3c1.5-1.8,1.6-4.4,3.1-6.2
		c2.1-2.3,5.5-2,8.6-1.1l1.4-0.4c1.9-1.2,2.7-3.9,1.8-6s-3.5-3.3-5.7-2.6c-0.7-3,0.9-6.4,3.8-7.7c-1.4-2.2-2.9-4.4-3.4-7
		s0.3-5.6,2.4-7c1.7-1.1,4.4-1.6,4.6-3.6c0.2-1.5-1.3-2.6-2.4-3.7c-3.4-3.4-3.3-9.7,0.3-13L853.7,752.3z"
      />
    </a>
    <a (click)="SelectCode('EC1')">
      <path
        [class.selected]="IsSelected('EC1')"
        id="EC1"
        d="
		M758.4,735.9c5.6-3.7,11.7-7.6,18.4-7.6c5.2,0,10.2,2.3,14.8,4.7c7.8,4.2,15.3,9,23.4,12.5c8.1,3.5,17.1,5.7,25.8,4.2
		c2.3-0.4,4.8-1.1,7.1-0.9c2.3,0.2,5,1.3,5.9,3.5c-6.5,1.4-13,2.8-19.6,4.2c-2.3,0.5-4.9,1.1-6.3,3c-1.9,2.7-0.8,6.4-0.5,9.7
		s-1.8,7.6-5,6.8c2.6,1.6,2.3,6-0.3,7.7c-2.5,1.8-6,1.2-8.6-0.6s-4.3-4.4-5.9-7c-3.3,2.3-7.8,2.9-11.5,1.3c3.7,10,3.9,21.1,0.8,31.3
		l-1.2-0.3c-2.3-1.4-4.4-2.8-6.8-4c-5.2-2.8-10.7-4.9-16.4-6c-4.9-1.1-10.6-0.6-15.2-2.4l-0.4,0.3c2.5-4.1,2.2-9.8-0.9-13.6
		c-1.7-2-4.3-3.9-4.2-6.5c0-2.4,2.2-4.3,3.5-6.3c2.8-4.2,1.5-10.6-2.7-13.4c3.9,2,9.1-0.7,10.7-4.8c1.6-4.1,0.1-8.9-2.6-12.4
		c-0.8-1.1-1.8-2.1-2.9-3L758.4,735.9z"
      />
    </a>
    <a (click)="SelectCode('E2')">
      <path
        [class.selected]="IsSelected('E2')"
        id="E2"
        d="
		M955.8,750.9c-1,0.2-2,0.4-2.9,0.7c-5,1.7-10.1,4.5-15,2.9c-2.3,5.5-10.1,7.6-14.9,4.2c0.9,1.8-0.1,4-1.7,5.1
		c-1.6,1.1-3.6,1.4-5.6,1.7c-11.9,1.7-23.8,3.3-35.8,5c-2.5,0.3-5.6,0.3-6.7-1.9c-0.4-0.8-0.4-1.8-0.8-2.6c-1.2-2.2-4.3-1.8-6.7-1.8
		c-3-0.1-5.8-1.6-7.8-3.8c-2.3-2.4-2-5.9-4.1-8.4l-1.5-1.8l-1.8-0.9l0.1-0.8c0.4-1.3,0.8-2.5,1.3-3.8c-2.1,0.9-4-2.3-3.1-4.4
		c0.9-2.2,3.2-3.4,4.9-5c1.7-1.7,2.7-4.6,0.8-6.2c1-1.6-1-4-2.8-3.3c1-3,1.1-6.2,0.4-9.3c0.9-0.3,1.8-0.8,2.7-1.1
		c-2.3-1.8-2.1-5.8,0.3-7.3c14.6-0.1,29.8,0,42.8,6.6c4.7,2.4,10.3,5.6,14.8,2.8c0.3-1,0.5-2.1,0.8-3.1c9.1-1.6,18.5-0.9,27.3,2
		c1.6,0.5,3.4,1.4,3.8,3.1c0.3,1.6-1,3-1.1,4.6c-0.2,3.2,3.7,4.6,6.5,6c6.9,3.5,10,12.8,6.5,19.8L955.8,750.9z"
      />
    </a>
    <a (click)="SelectCode('E1')">
      <path
        [class.selected]="IsSelected('E1')"
        id="E1"
        d="
		M970.5,790.7c-1.9-2.1-3-5.3-2.3-7.6s2.3-4.3,3.7-6.3c1.3-2,2.4-4.6,1.6-6.9c-1-2.8-4.4-4.1-5.6-6.7c-1.2-2.4-0.4-5.5-1.3-8
		c-1.8-4.9-8.7-5.2-13.7-3.5s-10.1,4.5-15,2.9c-2.3,5.5-10.1,7.6-14.9,4.2c0.9,1.8-0.1,4-1.7,5.1c-1.6,1.1-3.6,1.4-5.6,1.7
		c-11.9,1.7-23.8,3.3-35.8,5c-2.5,0.3-5.6,0.3-6.7-1.9c-0.4-0.8-0.4-1.8-0.8-2.6c-1.2-2.2-4.3-1.8-6.7-1.8c-3-0.1-5.8-1.6-7.8-3.8
		c-2.3-2.4-2-5.9-4.1-8.4l0.1,0.3c-3.5,3.3-3.7,9.6-0.3,13c1.1,1.1,2.6,2.2,2.4,3.7c-0.2,2-2.9,2.5-4.6,3.6c-2.2,1.4-2.9,4.4-2.4,7
		s2,4.9,3.4,7c-2.8,1.3-4.4,4.7-3.8,7.7c2.2-0.7,4.8,0.5,5.7,2.6s0.2,4.8-1.8,6l-1.8,0.3c1,0.3,2.1,0.7,3,1.1
		c1.3,2.2,4.5,1.7,6.8,2.8c2.3,1.2,3.1,4.1,3.1,6.6s-0.8,5.1-0.7,7.7c0.3,4.4,3.3,8.7,7.5,10.3c1,1.1,2,2.3,2.3,3.7l0.1,1.4l1.8-0.5
		c12.4-3.4,22.8-4.3,35.7-3.6c4.3,0.3,8.8,0.6,12.8-1.2c3.2-1.5,5.5-4.3,8.7-5.9c7.2-3.6,16.8-0.1,23.4-4.8l-0.7,1
		c3.7-4.2,3.9-10.3,4.4-15.9c0.5-5.5,2.1-11.8,7-14.5c1.1-0.6,2.3-0.9,3.4-1.1L970.5,790.7z"
      />
    </a>
    <a (click)="SelectCode('E1W')">
      <path
        [class.selected]="IsSelected('E1W')"
        id="E1W"
        d="
		M875.7,862.4c6.4,3.4,13.2,6.2,20.3,7.3s14.7,0.3,21.1-3.3c10.3-5.8,15.9-17.8,25.8-24c3.3-2.1,7-3.4,10.8-4
		c-1.5-5.8-0.8-11.5,1.1-17.1c-6.5,4.7-16.2,1.2-23.4,4.8c-3.1,1.6-5.5,4.4-8.7,5.9c-3.9,1.8-8.4,1.4-12.8,1.2
		c-12.8-0.7-25.3,0.6-37.7,4.1v0.8c-0.3,0.7-0.8,1.3-1.4,1.5c-3.4,1.2-5.5-5.5-8.9-4.4c-1.7,5.5-3.9,11-6.6,16.1v0.1
		c7.2,3.4,14.2,7.2,20.8,11.7L875.7,862.4z"
      />
    </a>
    <a (click)="SelectCode('E8')">
      <path
        [class.selected]="IsSelected('E8')"
        id="E8"
        d="
		M915.2,713.8c-0.3-0.2-0.6-0.3-0.8-0.4c-2.3-1.3-4.2-3.3-6.3-5c2.5-0.7,5-1.4,7.6-2.1c0-1.8-1.4-3.4-3.1-3.7
		c-0.1-2.9-0.1-5.7-0.2-8.6c1.5-0.6,3-1.2,4.5-1.8c-0.5-2.3,0.4-4.8,2.3-6.2c-3.1-8.7-2.3-18.7,2.2-26.9c1.1-2,2.4-4,2.7-6.3
		c0.3-2.2-0.6-4.4-0.9-6.6c-0.2-0.8-0.2-1.7-0.1-2.5h0.2c-6.7-0.1-13.3-0.3-20.1-0.3c-0.2-2.1-0.3-4.2-0.5-6.3
		c-2,1.1-4.6-0.6-5.5-2.7c-1-2.1-1.1-4.5-2-6.6c-2-4.5-7.6-6.5-12.4-6c-5,0.5-9.3,3-13.6,5.5c-2.6,1.5-5.4,3.2-7,5.8s-1.5,6.5,1,8.2
		c-2.2-1-4.7,1.1-5.1,3.4c-0.5,2.3,0.3,4.7,0.8,7c0.4,2.3,0.2,5.1-1.8,6.5c-0.8,0.5-1.8,0.8-2.2,1.8c-0.8,1.8,2,3.1,2.5,5
		c0.8,2.6-2.9,4.4-3.5,7.1c-0.5,2.2,1.2,4.1,2,6.1c2,4.8-0.3,10.2-2,15c-1.8,4.9-2.8,11.1,1,14.6l0.3-0.1c14.6-0.1,29.8,0,42.8,6.6
		c4.7,2.4,10.3,5.6,14.8,2.8c0.3-1,0.5-2.1,0.8-3.1c0.7-0.1,1.3-0.3,2.1-0.3L915.2,713.8z"
      />
    </a>
    <a (click)="SelectCode('E14')">
      <path
        [class.selected]="IsSelected('E14')"
        id="E14"
        d="
		M1026.9,948.1c-0.1,0.2,10.1,0.8,11.4,0.7c4.8-0.4,9.7-1.2,14.3-2.5c5.7-1.7,11.2-4.7,14.7-9.4c5.3-7.1,5.4-16.9,3.4-25.5
		c-1.9-8.6-5.5-17-6.7-25.7s0.3-18.7,7-24.5c5.5-4.8,13.3-5.9,20.5-4.9c0.3,0,0.6,0.1,0.8,0.1l1.3-0.3c0.6-5,4.9-6.1,6.6-9.9
		c1.6-3.4,0.7-8.6-2.3-11c-1.2-0.9-2.6-1.4-3.7-2.5c-1.5-1.5-2-3.8-2.3-6c-0.8-4.7-1.6-9.4-2.4-14.1c-0.7-3.8-1.5-7.9-4.5-10.2
		c-4.4-3.4-10.9-1.3-16.4-2.3c-6.6-1.3-11.2-7-16-11.9c-4.7-4.9-11.4-9.4-17.8-7.1c-6.8,2.3-9.3,10.7-15.3,14.7
		c-5.7,3.8-14.3,2.2-18.2-3.4c-0.4,3.4-6,4.7-7.7,1.8c-0.6,1.5-1.3,3.1-1.8,4.6c-3.8-1.6-8.6-0.1-10.8,3.4c0.2-3.7-1.6-7.5-4.6-9.7
		s-7.2-2.5-10.5-0.8c-5,2.7-6.5,8.9-7,14.5c-0.5,5.5-1.1,10.5-3.8,14.9c-1.8,5.2-2.2,11-1,16.4l0.2,0.8c4.4-0.7,8.9-0.3,13.2,1.1
		c8,2.6,14.7,8.9,17.9,16.7c6.2,15.4-1.5,34.1,5.4,49.2l0.5-0.4c0.8,9.9,4.7,19.4,10.7,27.2c6.8,9,15.4,12.3,25.8,16.4L1026.9,948.1
		z"
      />
    </a>
    <a (click)="SelectCode('E3')">
      <path
        [class.selected]="IsSelected('E3')"
        id="E3"
        d="
		M970.5,790.7c2,0.1,3.9,0.7,5.6,1.8c3,2.2,4.7,6,4.6,9.7c2.3-3.4,7-5,10.8-3.4c0.6-1.5,1.3-3.1,1.8-4.6c1.8,2.9,7.4,1.8,7.7-1.8
		c3.9,5.5,12.5,7.1,18.2,3.4c6-3.9,8.5-12.4,15.3-14.7c6.4-2.2,13.1,2.3,17.8,7.1c0.3,0.3,0.6,0.7,0.9,1l0.6,0.1
		c6-0.8,11.4-5.3,13.1-11.2c1.7-5.8-0.4-12.6-5.2-16.4c4.8-1.8,9.9-1.5,14.9-0.6l0.5-1.5c0.8-3.9,1.2-5.6,2.2-10.5
		c-8.7-5.6-19.9-7.5-30-5c-2,0.5-4,1.2-6.1,0.9c-2.8-0.3-5-2.3-7-4.2c-5.3-4.8-10.8-9.9-12.9-16.7c-2.1-6.9-0.4-14.4,2.3-21.1
		c0.9-2.3,1.9-5.2,0.3-7c-1.4-1.5-3.9-1.3-6-2c-4.4-1.8-4.7-8.1-2.5-12.3s6-7.5,7.7-11.9c-4.2-1.3-8.7,1.3-11.5,4.8
		c-2.8,3.4-4.4,7.6-7.1,11.1s-7.2,6.2-11.4,5c1.6,1.4,0.1,4.4-2.1,4.9s-4.2-0.9-6-2.3c-1.8-1.3-3.4-2.9-5.5-3.4
		c-2.8-0.5-5.5,1.3-7.2,3.5c-4,5.3-3.5,13.3-8.4,17.9c-2.1,1.9-4.9,2.9-7,4.7c-2.2,1.8-3.8,5-2.4,7.4c-3.8-0.8-7.1-3.5-8.7-7
		c-1.6-0.4-3.4,0.3-4.4,1.6l-0.1,0.1c0.3,0.4,0.6,0.8,0.7,1.3c0.3,1.6-1,3-1.1,4.6c-0.2,3.2,3.7,4.6,6.5,6c6.9,3.5,10,12.8,6.5,19.8
		l-0.4,1c4.4-0.7,9.2,0.3,10.7,4.2c1,2.5,0.2,5.5,1.3,8c1.3,2.7,4.6,3.9,5.6,6.7c0.8,2.3-0.3,4.9-1.6,6.9s-3,3.9-3.7,6.3
		S968.5,788.6,970.5,790.7L970.5,790.7z"
      />
    </a>
    <a (click)="SelectCode('E16')">
      <path
        [class.selected]="IsSelected('E16')"
        id="E16"
        d="
		M1315.3,843.4c-7.6,7.8-14.1,17.3-20.1,26.4c-2.8,4.2-5.6,8.6-7,13.3v0.4c-5.4,1.9-11.2,2.4-16.9,2.9c-31.8,2.4-63.6,4.9-95.4,7.4
		l-0.2-0.4c-10.5,1.9-21.4,1.3-31.6-1.9c-1.4-0.4-3-0.9-4.4-0.8l-1.3,0.1c-4.5-0.3-8.5-3.4-11.4-6.9s-5-7.6-7.8-11.2
		c-6-7.9-14.8-13.5-24.4-15.7l-1.3-0.8c0.6-5,4.9-6.1,6.6-9.9c1.6-3.4,0.7-8.6-2.3-11c-1.2-0.9-2.6-1.4-3.7-2.5
		c-1.5-1.5-2-3.8-2.3-6c-0.8-4.7-1.6-9.4-2.4-14.1c-0.7-3.8-1.5-7.9-4.5-10.2c-4.4-3.4-10.9-1.3-16.4-2.3c-6-1.2-10.4-6-14.8-10.6
		l0.3-0.3c6-0.8,11.4-5.3,13.1-11.2c1.7-5.8-0.4-12.6-5.2-16.4c8.6-3.2,18,0.1,26.9,2.2c8.9,2,19.8,2.2,25.3-5.1
		c1.3,2.3,1.3,5.5-0.1,7.8c3.1-0.9,6.1,2.7,5.6,5.9s-3.4,5.5-6.4,6.9c-2.3,1-5.4,2.7-4.4,5c0.7,1.8,3,1.9,4.9,1.8
		c4.8-0.4,9.6-1.3,14.2-2.8c0.2,1.2,0.4,2.3,0.6,3.4c1.4-1.9,3.3-4.1,5.7-4c2.8,0,4.7,2.9,5.2,5.5s0.3,5.5,1.1,8.1
		c0.8,2.6,3.5,5,6.1,4.1c0.8-2.8,1.5-5.5,2.3-8.3c2,0.3,3.6,2.3,3.4,4.3c1.5-1.3,4-1.3,5.5,0.2c1.4,1.4,1.5,3.9,0.2,5.5
		c7.7-1.2,14.3-7.6,15.6-15.4c7.3,1.5,15,0.3,21.6-3.3l-0.1-0.1c2,4.9,1.6,10.9,1.1,16.4c-0.7,7.3-0.5,15.8,5.2,20.2
		c2.3,1.8,5.3,2.7,7.7,4.4c2.6,1.9,4.2,4.8,5.9,7.6c2.9,5.1,6,10.2,8.9,15.3c5.8,3.5,13.3,3.9,19.4,0.8c5-2.5,6.7-9.9,12.3-10.1
		c2.4-0.1,4.8,0.8,7.1,1.4c8,2.1,16.7,1.2,24.1-2.5c3-1.5,5.8-3.5,9.1-4.2c7.6-1.5,14.5,4.2,20.1,9.6L1315.3,843.4z"
      />
    </a>
    <a (click)="SelectCode('E15')">
      <path
        [class.selected]="IsSelected('E15')"
        id="E15"
        d="
		M1135.3,704.1c-3.4-5.2-8.9-8.7-11.7-14.2c-1.8-3.5-2.3-7.6-3.3-11.4c-1.8-7.8-5.5-15.1-10.6-21.3c2.6-0.8,5.3-1.6,7.3-3.4
		s3.1-5,1.7-7.4c-1.8-3-7.1-3.9-7.1-7.4c0-1.6,1.2-2.9,1.5-4.4c0.7-2.9-1.7-5.8-4.5-6.8c-2.9-0.9-5.9-0.5-8.8,0
		c-1.7-0.5-2-0.6-3.9-1.2c-0.1,1.9-0.2,3.9-0.3,5.9c-4.1,0.7-7.5-2.8-11.1-5c-6.2-3.8-14.6-3.5-20.6,0.5c0.4,2-3.2,2.7-4.3,0.9
		c-1.1-1.8-0.3-4,0.3-6c0.7-1.9,1.3-4.3,0.2-6c-1.3-1.8-4.2-1.8-6.2-0.7c-1.9,1.2-3.3,3.1-4.8,4.8c-3.5,3.9-8.6,6.4-13.8,7
		c-2.7,0.3-5.4,0-8.1,0.6c-6.7,1.5-11.2,7.7-15,13.5c-2.6,3.9-5.3,8.5-4.2,13c0.8,3.5,3.7,6.2,7,7.6c3.3,1.4,6.9,1.9,10.4,2.3
		c-0.3,1.5-0.6,3-0.8,4.5l0.7,0.1c-1.7,4.4-5.5,7.7-7.7,11.9s-1.9,10.7,2.5,12.3c2,0.8,4.4,0.5,6,2c1.7,1.8,0.8,4.7-0.3,7
		c-2.8,6.6-4.4,14.2-2.3,21.1c2.1,6.8,7.6,11.9,12.9,16.7c2.1,1.8,4.3,3.8,7,4.2c2,0.3,4.1-0.4,6.1-0.9c10.2-2.5,21.2-0.7,30,5
		c-1,4.9-1.4,6.6-2.2,10.5v1.6c3.8,0.8,7.6,1.8,11.4,2.7c4.8,1.1,10.2,1.7,15,0.8l1-1.1c-2.2-3.2-4.5-6.8-3.8-10.6
		c0.4-2.1,1.7-3.9,2.9-5.5c3.1-4.2,6.2-8.4,9.3-12.7c1.5-2,3.1-4.3,3-6.9c-0.1-2.3-1.6-4.6-1.3-7c0.5-3.6,4.9-5.2,8.6-5.6
		c3.7-0.3,7.9-0.6,10.1-3.6c1.3-1.9,1.4-4.4,2.1-6.7L1135.3,704.1z"
      />
    </a>
    <a (click)="SelectCode('E20')">
      <path
        [class.selected]="IsSelected('E20')"
        id="E20"
        d="
		M1048.8,682.6c-0.6-0.2-1-0.7-1.4-1.2c-2.3-2.9-17.7-18.6-14.8-21.1c1.1-0.9,4.6-0.4,6.1-0.7c2.8-0.3,5.4-1.3,8.1-1.4
		c4.8-0.3,10,1,13.2,4.5c3.2,3.6,3.6,9.8,0,12.9c-2.2,1.9-5.4,2.4-7.5,4.5C1051.4,681.4,1050.3,683,1048.8,682.6z"
      />
    </a>
    <a (click)="SelectCode('E13')">
      <path
        [class.selected]="IsSelected('E13')"
        id="E13"
        d="
		M1104.7,763.7c-2.2-3.2-4.5-6.8-3.8-10.6c0.4-2.1,1.7-3.9,2.9-5.5c3.1-4.2,6.2-8.4,9.3-12.7c1.5-2,3.1-4.3,3-6.9
		c-0.1-2.3-1.6-4.6-1.3-7c0.5-3.6,4.9-5.2,8.6-5.6c3.7-0.3,7.9-0.6,10.1-3.6c1.3-1.9,1.4-4.4,2.1-6.7s2.5-4.6,4.9-4.2
		c4.6,0.5,9.1,0.9,13.8,1.4c2,0.2,4.1,0.4,6-0.3c1.7-0.7,3-2.1,4.6-2.9c1.6-0.8,3.9-1,5,0.5l-0.7-0.8c3.9,8.3,7.8,16.6,11.7,24.9
		c1,2.2,2,4.4,2.3,6.7c0.3,3.6-1.1,7.1-1.2,10.7c-0.2,7.4,5.5,14.1,4.7,21.4c-0.3,3.5-2.1,7.1-0.8,10.4c1.1,2.7,4,4.2,6,6.2
		c1.3,1.3,2.2,2.8,2.9,4.4l0.1,0.1c-6.5,3.6-14.3,4.8-21.6,3.3c-1.3,7.6-7.9,14.1-15.6,15.4c1.3-1.5,1.3-4-0.2-5.5
		c-1.4-1.4-3.9-1.5-5.5-0.2c0.3-2-1.3-4-3.4-4.3c-0.8,2.8-1.5,5.5-2.3,8.3c-2.6,0.9-5.3-1.5-6.1-4.1c-0.8-2.6-0.5-5.5-1.1-8.1
		c-0.5-2.7-2.4-5.5-5.2-5.5c-2.4,0-4.3,2.1-5.7,4c-0.2-1.2-0.4-2.3-0.6-3.4c-4.6,1.4-9.4,2.3-14.2,2.8c-1.8,0.2-4.2,0-4.9-1.8
		c-0.8-2.3,2.2-4,4.4-5c3-1.3,5.8-3.6,6.4-6.9c0.5-3.2-2.5-6.9-5.6-5.9c1.4-2.3,1.4-5.5,0.1-7.8c-2.2,2.9-5.3,4.6-8.7,5.5
		L1104.7,763.7z"
      />
    </a>
    <a (click)="SelectCode('E6')">
      <path
        [class.selected]="IsSelected('E6')"
        id="E6"
        d="
		M1261.2,673.4c-2.3-2.4-6.2-2.7-9.3-1.5c-3.1,1.2-5.6,3.5-8.1,5.7c-4.4,4.1-8.9,8.2-13.3,12.3c-2.3,2.2-5.4,4.4-8.3,3.4
		c-1.8-0.6-2.9-2.3-4.3-3.5c-2.9-2.6-7-3.7-10.7-2.8c-3.8,0.9-7,3.8-8.3,7.4c-2.9-1.2-5-2.1-7.2-2.9c-1.2,2.3-0.9,5.1,0.4,7.2
		c-0.1,0.9-1.5,1.1-2.2,0.5c-0.8-0.6-1-1.5-1.6-2.3c-2.1-2.8-6.4-1.8-9.5-0.2s-6.6,3.6-9.7,2c3.9,8.3,7.8,16.6,11.7,24.9
		c1,2.2,2,4.4,2.3,6.7c0.3,3.6-1.1,7.1-1.2,10.7c-0.2,7.4,5.5,14.1,4.7,21.4c-0.3,3.5-2.1,7.1-0.8,10.4c1.1,2.7,4,4.2,6,6.2
		c5.1,5.2,4.6,13.5,4,20.7c-0.7,7.3-0.5,15.8,5.2,20.2c2.3,1.8,5.3,2.7,7.7,4.4c2.6,1.9,4.2,4.8,5.9,7.6c2.9,5.1,6,10.2,8.9,15.3
		c5.8,3.5,13.3,3.9,19.4,0.8c5-2.5,6.7-9.9,12.3-10.1c2.4-0.1,4.8,0.8,7.1,1.4c8,2.1,16.7,1.2,24.1-2.5c3-1.5,5.8-3.5,9.1-4.2
		c7.6-1.5,14.5,4.2,20.1,9.6l1.3-0.8c6-5.8,12.7-10.6,20.5-13.5l-0.3,0.2c-1-2.4,1.4-6,1.8-8.6c0.7-3.9-0.6-8.1-1.1-11.9
		c-6.8-9.5-13.6-19-20.1-28.6c-0.3-0.4-0.6-0.8-0.9-1.1c-0.4-0.3-1-0.6-1.6-0.8c-3.7-0.9-7.6,0.3-11.2,1
		c-10.8,2.3-13.6-4.9-18.7-12.5l-2-13l-13.6-18.1l-1.3-12.2l1.3-6l-2.1-8.6l-6.2-9.7l-2.6-13.8l2.7-11.6L1261.2,673.4z"
      />
    </a>
    <a (click)="SelectCode('E9')">
      <path
        [class.selected]="IsSelected('E9')"
        id="E9"
        d="
		M1022.2,631c-1.9-5.1-7.2-8.1-12.3-10.1c-5.1-1.9-10.7-3.5-14.5-7.5c-3.1-3.2-5.4-8.1-9.7-8.6c-2.8-0.3-5.5,1.2-7.2,3.4
		c-1.8,2.2-2.7,4.9-3.6,7.5c-1.1,3.3-2.3,6.5-2.3,10c-0.2,6.2,3,12.8,0.2,18.3c-1.3,2.7-4.1,4.6-7,4.8s-6-1.6-7.2-4.4
		c-1.3-3.1-0.6-7.4-3.5-9.1c-4.2-2.3-8.6,4.4-13.3,3.7c-2.6-0.4-4.7-3.1-7.2-2.6c-1.8,0.3-3,2.2-4.4,3.5c-1.3,1.3-3.9,2.2-5,0.6
		c-1.8,1.3-2.2,3.9-1.8,6c0.3,2.2,1.2,4.4,0.9,6.6c-0.3,2.3-1.6,4.3-2.7,6.3c-4.4,8.1-5.3,18.1-2.2,26.9c-1.8,1.4-2.8,3.9-2.3,6.2
		c-1.5,0.6-3,1.2-4.5,1.8c0.1,2.9,0.1,5.7,0.2,8.6c1.8,0.3,3.2,1.9,3.1,3.7c-2.5,0.7-5,1.4-7.6,2.1c2.1,1.7,3.9,3.7,6.3,5
		c0.3,0.2,0.6,0.3,0.8,0.4v0.2c8.5-1.2,17.2-0.3,25.3,2.3c1.1,0.3,2.3,0.9,3.1,1.8l0.1-0.1c0.9-1.3,2.8-2,4.4-1.6
		c1.6,3.5,5,6.2,8.7,7c-1.4-2.4,0.2-5.6,2.4-7.4c2.2-1.8,5-2.8,7-4.7c4.9-4.5,4.4-12.6,8.4-17.9c1.7-2.3,4.4-3.9,7.2-3.5
		c2.2,0.4,3.9,1.9,5.5,3.4c1.7,1.4,3.8,2.7,6,2.3s3.7-3.4,2.1-4.9c4.2,1.3,8.7-1.5,11.4-5c2.7-3.4,4.4-7.6,7.1-11.1
		c2.8-3.4,7.3-6.1,11.5-4.8l-0.7-0.1c0.3-1.5,0.6-3,0.8-4.5c-3.5-0.4-7.2-0.8-10.4-2.3s-6.2-4.2-7-7.6c-1.1-4.6,1.6-9.1,4.2-13
		c2.6-3.9,5.5-8.2,9.3-10.9L1022.2,631z"
      />
    </a>
    <a (click)="SelectCode('E5')">
      <path
        [class.selected]="IsSelected('E5')"
        id="E5"
        d="
		M923,643.3c0.3-1.2,0.8-2.3,1.8-2.9c1.1,1.6,3.6,0.8,5-0.6c1.3-1.3,2.5-3.2,4.4-3.5c2.6-0.4,4.7,2.2,7.2,2.6
		c4.8,0.8,9.1-6,13.3-3.7c2.9,1.7,2.2,6,3.5,9.1c1.2,2.8,4.2,4.5,7.2,4.4c2.9-0.2,5.7-2.1,7-4.8c2.8-5.5-0.3-12.1-0.2-18.3
		c0.1-3.4,1.3-6.7,2.3-10c0.9-2.6,1.8-5.3,3.6-7.5c1.2-1.5,2.9-2.7,4.7-3.2l0.7-0.4c-4.2-9.8-18.3-10.2-25.8-17.8
		c-5-5.1-6.4-12.7-9.7-19c-3.3-6.1-8.4-11-12.2-16.7c-3.9-5.7-6.4-13.2-3.8-19.6l0.9-0.3c-2.1,1-4.6-0.1-6.2-1.8
		c-1.5-1.7-2.3-3.9-3.4-6c-3.1-6.3-5.5-4.5-10.3-1c-4.4,3.3-9,6.6-13.4,9.9c-4.4,3.3-9.8,6.8-15.1,5.4c-3.4-0.9-6-3.6-9.4-4.8
		c-3.4-1.1-8.2,0.9-7.6,4.4c0.7,3.4,4,4.6,7,5.2c4.7,1,4.9-1.6,8.6-2.5c4.3-1,2.9,6.6,4.9,8.4c1.4,1.3,3.6,1,5.1,2.9
		c1,1.3,1.1,3.1,2,4.4c0.9,1.3,1.8,2.7,2.9,4c1.8,2.6,3.8,5.5,3.2,8.6s-5.2,5.2-7,2.6c-1.6,3.4-4.5,6.2-8,7.7
		c0.7,7.5,4.6,14.6,10.6,19.2c-3.4,5.2-9.1,8.8-15.3,9.6c1.1,4.5,2.1,9,3.2,13.5l0.8,0.8c3.9,0.5,7.6,2.5,9.1,6c0.9,2.1,1,4.5,2,6.6
		s3.5,3.9,5.5,2.7c0.2,2.1,0.3,4.2,0.5,6.3c6.7,0.1,13.3,0.3,20.1,0.3L923,643.3z"
      />
    </a>
    <a (click)="SelectCode('E4')">
      <path
        [class.selected]="IsSelected('E4')"
        id="E4"
        d="
		M1002.9,250.7c-7,12-5.2,27.2-9.7,40.4c-3.2,9.2-9.4,17-14.5,25.3s-9.6,17.8-8.4,27.4c0.6,5.4,2.9,10.5,4.2,15.8
		c1.9,8.3,1.2,17.2-2.1,25l0.3,0.5c1.8,0.3,3.6,0.8,5.3,1.6c6.1,3,10.7,9.6,17.4,10.1c3.7,0.3,7.4-1.5,11.1-1.3
		c3.3,0.3,6.2,1.9,8.9,3.9c2.7,1.9,5.2,4.1,8.2,5.5c3,1.4,6.7,1.6,9.5-0.2c2.8-1.8,3.8-6.1,1.5-8.5c1.5-3.4,5.3-5.8,9.1-5.5
		c3.8,0.3,7.1,3.2,8.1,6.9c2.2,3.4,4.6,7,8.2,9s8.8,1.5,10.9-2h-1l6.5-9.4l1.8-11.4l6.5-2.6l5.2-6.7l10.1-5.6l6.5-14.4l-3.6-2.9
		l-3.4-10.7l4.4-9l8.5-5.7l8.6-10.7l-0.4-15.5l1.4-5l11.2-10.7l3.1-11l-0.8-13.7l6.6-10.2l1.6-12.6c-2.2-10.1-7-19.3-1.6-29.1
		c2.4-4.4,5.8-8.5,7.7-13.3c1.2-2.9,1.8-6.1,3.8-8.6c0.9-1.2,2.2-2.5,1.8-3.9c-0.3-1.1-1.3-1.8-2.3-2.3c-6.5-3.4-13.4-5.6-20.5-8
		c-5.6-1.8-11.2-3.7-16.9-5.6l-2.9-31.4l-6.5-8.4l4.2-16.7l-5.8-18l-16.9,4.4l-11.2,7.2l-6.6-6.9l2.5-6.7l-0.5-16.6l-8.6-1.8
		l-7.8,4.5l-2.1,24.7c-2,8.6-3,19.4-9.7,25.7c-2.6,2.4-6.1,4.4-7.1,7.9c-0.6,2-0.3,4.2-0.3,6.3c-0.3,5.8-3.7,10.8-5.7,16.3
		c-1.9,5.1-0.9,10.7-2.6,15.6c-1.1,3.4-4.8,5.7-5.9,9.1c-1.3,4-0.3,9.9-0.5,14.2l-8.4,22.1l-3.4,12.3l-6.5,22.2"
      />
    </a>
    <a (click)="SelectCode('E10')">
      <path
        [class.selected]="IsSelected('E10')"
        id="E10"
        d="
		M1022.2,631c1.5-1,3.3-1.8,5.1-2.2c2.6-0.6,5.4-0.3,8.1-0.6c5.3-0.5,10.2-3,13.8-7c1.5-1.7,2.9-3.6,4.8-4.8c1-0.6,2.2-0.9,3.4-0.8
		l0.2-0.7c-0.2-1.5-0.3-3.1-0.4-4.6c1.7-0.7,3.4-1.4,5-2.1c-1.8-2.3-3.5-4.7-5.4-7c3.6-0.5,7.6-1.2,9.9-4c2.3-2.9,1-8.4-2.7-8.4
		c-3.5-2.8-2.2-9.6,2.3-10.7c-0.3-1.5,0.8-3,2.3-3.4c-0.5-1.5-1.1-3-1.6-4.5c2.9-1.1,5.1-4.1,5.2-7.2c-1.3-0.3-2.7-0.6-3.9-0.8
		c0.2-2.9-3.5-4.4-6.4-4c-2.9,0.5-5.5,2.1-8.3,2.3c-2.9,0.2-6.2-2.4-5.1-5.1c0.8-1.9,3.3-2.4,5.4-2.3s4.4,0.5,6.1-0.6
		c1.8-1.1,2.4-3.4,2.8-5.5s0.6-4.4,1.8-6c1.3-1.7,4.3-2.2,5.5-0.4c3.4-3.4,6-7.6,7.7-12.2c2.7,0.7,5.5-2.3,4.8-4.9
		c-0.4-1.6-1.8-2.8-2.9-4c-3-3.8-3.5-9.5-1-13.7c1.8-3.1,5.2-5.3,8.8-5.8l0.8-0.5c-5.5-1.6-11.4-2-17.1-1.4
		c-2.9,5.5-7.8,9.9-13.5,12.3c-6.1,1.8-12.3,3.6-18.4,5.5c-0.8,3.9-4.2,6.6-7.4,9c-10.8,8.1-21.6,16.2-32.4,24.3
		c-2.9,2.3-6.7,4.6-10.2,3.2c-3.4-1.3-4.4-5.5-6.6-8.4c-4.9-6.4-14.9-6.1-21-11.3c-1.9-1.6-3.4-3.8-5.5-5.2
		c-3.5-2.4-8.2-2.6-12.3-1.4c-4.1,1.2-7.8,3.5-11.4,5.8c-2.7,6.4-0.1,13.8,3.8,19.6c3.9,5.7,9,10.7,12.2,16.7
		c3.4,6.3,4.7,13.8,9.7,19c7.5,7.6,21.6,8.1,25.8,17.8l1.9,0.2c4.4,0.6,6.6,5.5,9.7,8.6c3.8,3.9,9.4,5.5,14.5,7.5
		C1014.9,622.9,1020.2,625.9,1022.2,631"
      />
    </a>
    <a (click)="SelectCode('E17')">
      <path
        [class.selected]="IsSelected('E17')"
        id="E17"
        d="
		M919.9,518.7c-3.6-8.9-0.3-20.1,7.6-25.5c3.9-2.7,9.1-4.4,11-8.8c1.4-3.2,0.6-6.9-0.3-10.3c-1.6-6.1-3.3-12.3-5-18.4
		c-1.3-4.4-2.7-9-1.6-13.4c1.8-7.7,10.3-12.6,11.7-20.4c0.9-5.3-1.7-10.7-0.8-16.1c0.6-3.6,2.9-6.8,5.3-9.6
		c3.8-4.2,8.2-7.9,13.5-9.9s11.4-2.2,16.4,0.3c6.1,3,10.7,9.6,17.4,10.1c3.7,0.3,7.4-1.5,11.1-1.3c3.3,0.3,6.2,1.9,8.9,3.9
		c2.7,1.9,5.2,4.1,8.2,5.5c3,1.3,6.7,1.6,9.5-0.2c2.8-1.8,3.8-6.1,1.5-8.5c1.5-3.4,5.3-5.8,9.1-5.5c3.8,0.3,7.1,3.2,8.1,6.9
		c2.2,3.4,4.6,7,8.2,9c3.6,1.9,8.4,2.1,10.5-1.4l6.3,6l9.6,2.6l6.3-0.5l6.8,8.7c-2.5-0.2-3.3,1.9-2.3,4.2c1,2.3,3.3,3.8,5,5.7
		c3.1,3.4,4.3,8.6,2.9,13.1c-1.4,4.4-5.4,8.1-9.9,9.1c4.8,7.6,9.6,15.3,14.4,22.9l-0.8-0.1c-7.2,0-13.7,6.8-13.4,14.1
		c0.1,2.1,0.7,4.2,0.1,6.2s-2.3,3.2-4.4,2.9l-2.8-0.5c-5.5-1.6-11.4-2-17.1-1.4c-2.9,5.5-7.8,9.9-13.5,12.3
		c-6.1,1.8-12.3,3.6-18.4,5.5c-0.8,3.9-4.2,6.6-7.4,9c-10.8,8.1-21.6,16.2-32.4,24.3c-2.9,2.3-6.7,4.6-10.2,3.2
		c-3.4-1.3-4.4-5.5-6.6-8.4c-4.9-6.4-14.9-6.1-21-11.3c-1.9-1.6-3.4-3.8-5.5-5.2c-3.5-2.4-8.2-2.6-12.3-1.4
		c-4.1,1.2-7.8,3.5-11.4,5.8l0.9-0.3c-2.1,1-4.6-0.1-6.2-1.8c-1.5-1.7-2.3-3.9-3.4-6c-1.1-2.2-2.1-3.4-3.2-3.9L919.9,518.7z"
      />
    </a>
    <a (click)="SelectCode('E18')">
      <path
        [class.selected]="IsSelected('E18')"
        id="E18"
        d="
		M1099.2,421.9c-2.5-0.2-3.3,1.9-2.3,4.2c1,2.3,3.3,3.8,5,5.7c3.1,3.4,4.3,8.6,2.9,13.1c-1.4,4.4-5.4,8.1-9.9,9.1
		c4.8,7.6,9.6,15.3,14.4,22.9l-0.8-0.1c0.2,3.4-1.2,18.8,2.5,20.1c2.2,0.8,4.6-0.8,5.5-2.9c0.7-1.8,0.6-3.7,1-5.5
		c1.3-5.5,8.7-5.8,12.3-2.5c0.8,0.7,1.7,1.3,2.6,1.2c0.9-0.1,1.6-1,2.1-1.8c3.7-5.9,7.5-11.7,11.2-17.6c1.5-1.1,3.1,1.6,2.6,3.4
		s-1.6,3.9-0.5,5.4c1.8,2.4,6.4-0.8,8.8,1.1c1.8,1.5,0.8,4.9,2.6,6.5c1.3,1.2,3.5,0.6,5.2-0.2c7.1-3.1,13.9-7.1,20.1-11.8h0.6
		l-3.5-13.2l-7.5-13.3l14.6-14.9l-3-6.5l-12-7.3l-5.4,3.7l-4.4-2.9l-4.8-8.8l-3.3,3.9l-7.4,2.9l-12.9-3l-8.7-0.9l-5.4-5.5l-10.7,2.2
		l-5.3,8.9L1099.2,421.9"
      />
    </a>
    <a (click)="SelectCode('E11')">
      <path
        [class.selected]="IsSelected('E11')"
        id="E11"
        d="
		M1184.6,471.8c-6.2,4.7-13,8.7-20.1,11.8c-1.7,0.8-3.8,1.3-5.2,0.2c-1.8-1.6-0.8-5-2.6-6.5c-2.3-1.9-6.9,1.3-8.8-1.1
		c-1.1-1.5,0-3.5,0.5-5.4c0.5-1.8-1.1-4.4-2.6-3.4c-3.7,5.9-7.5,11.7-11.2,17.6c-0.5,0.8-1.2,1.7-2.1,1.8c-1,0.1-1.9-0.5-2.6-1.2
		c-3.5-3.3-11-3-12.3,2.5c-0.4,1.8-0.3,3.8-1,5.5c-0.8,2.1-3.4,3.7-5.5,2.9c-3.7-1.3-2.3-16.6-2.5-20.1c-7.2,0-13.7,6.8-13.4,14.1
		c0.1,2.1,0.7,4.2,0.1,6.2s-2.3,3.2-4.4,2.9c-4.8-0.8-10,1.6-12.4,5.8s-2,9.9,1,13.7c1,1.3,2.4,2.4,2.9,4c0.7,2.6-2.1,5.5-4.8,4.9
		c-1.7,4.5-4.3,8.7-7.7,12.2c-1.2-1.8-4.1-1.2-5.5,0.4c-1.3,1.7-1.5,3.9-1.8,6s-1,4.4-2.8,5.5s-4,0.7-6.1,0.6
		c-2.1-0.1-4.6,0.4-5.4,2.3c-1.1,2.7,2.3,5.2,5.1,5.1c2.9-0.2,5.5-1.8,8.3-2.3c2.9-0.5,6.5,1.1,6.4,4c1.3,0.3,2.7,0.6,3.9,0.8
		c-0.1,3.2-2.3,6.2-5.2,7.2c0.5,1.5,1.1,3,1.6,4.5c-1.4,0.3-2.5,1.8-2.3,3.4c-4.4,1.2-5.8,8-2.3,10.7c3.7,0,5,5.5,2.7,8.4
		s-6.3,3.5-9.9,4c1.8,2.3,3.5,4.7,5.4,7c-1.7,0.7-3.4,1.4-5,2.1c0.2,1.5,0.3,3.1,0.4,4.6l0.3,0.8c1,0.2,1.8,0.6,2.4,1.4
		c1.2,1.7,0.6,4-0.2,6c-0.8,1.9-1.4,4.2-0.3,6s4.7,1.2,4.3-0.9c6-4,14.4-4.3,20.6-0.5c3.5,2.1,7,5.5,11.1,5c0.1-1.9,0.2-3.9,0.3-5.9
		c1.8,0.6,2.2,0.6,3.9,1.2c2.1-5.5,6.6-10.2,12.2-12.3c6.2-2.4,11.1-7.4,16.6-11.1c3.1-2,6.3-4.1,9.9-5c4.4-0.9,9.1,0.2,13.5,1.3
		c1,0.3,2,0.5,2.9,0.8l0.1-0.2c-0.6-3.5,1.8-6.8,4.2-9.4c2.4-2.6,5.3-5,6.3-8.5c0.7-2.4,0.3-5,0.1-7.6c-0.6-5.5-0.4-11.9,4-15
		c3.7-2.6,8.8-1.8,12.8,0.2c4,1.9,7.7,4.8,11.9,6.2c4.3,1.4,9.7,0.9,12.3-2.9l1.6-1.3l-1.8-9.1l-9.6-6.7l-6.2-7l-8.1-12.6l4.9-14
		l-2.1-19.1l0.8-19.8l-0.8-3.2"
      />
    </a>
    <a (click)="SelectCode('E7')">
      <path
        [class.selected]="IsSelected('E7')"
        id="E7"
        d="
		M1135.3,704.1c-3.4-5.2-8.9-8.7-11.7-14.2c-1.8-3.5-2.3-7.6-3.3-11.4c-1.8-7.8-5.5-15.1-10.6-21.3c2.6-0.8,5.3-1.6,7.3-3.4
		s3.1-5,1.7-7.4c-1.8-3-7.1-3.9-7.1-7.4c0-1.6,1.2-2.9,1.5-4.4c0.7-2.9-1.7-5.8-4.5-6.8c-2.9-0.9-5.9-0.5-8.8,0
		c2.1-5.5,6.6-10.2,12.2-12.3c6.2-2.4,11.1-7.4,16.6-11.1c3.1-2,6.3-4.1,9.9-5c4.4-0.9,9.1,0.2,13.5,1.3c7.8,2,15.7,4,23.5,6
		c3.8,1,7.7,2,10.8,4.4c3.1,2.3,5.4,6.4,4.4,10.2c-1,3.9-4.9,6.3-7.8,9.1c-2.9,2.9-5,7.8-2.3,10.7c2.2,2.3,5.7,1.8,8.8,2.1
		c4.7,0.5,9.1,3.1,11.7,7.1c-4.2,2.6-8.6,5.5-10.5,10s0.3,11,5.1,11.6c2.9,0.4,6.5-1.3,8.6,0.9c1.8,1.9,0.5,5.1-0.7,7.6
		c-1.2,2.4-1.9,6,0.4,7.3l-0.3,0.7c-2.3,1.3-4,3.5-5,6c-2.9-1.2-5-2.1-7.2-2.9c-1.2,2.3-0.9,5.1,0.4,7.2c-0.1,0.9-1.5,1.1-2.2,0.5
		c-0.8-0.6-1-1.5-1.6-2.3c-2.1-2.8-6.4-1.8-9.5-0.2s-6.6,3.6-9.7,2l-1.8-0.3l-2.5,0.6c-1.6,0.8-2.9,2.3-4.6,2.9
		c-1.8,0.8-3.9,0.6-6,0.3c-4.6-0.5-9.1-0.9-13.8-1.4c-2.3-0.4-4.2,1.9-4.9,4.2V704.1z"
      />
    </a>
    <a (click)="SelectCode('E12')">
      <path
        [class.selected]="IsSelected('E12')"
        id="E12"
        d="
		M1208.2,563.7l0.3,1.6l4.5,9.4l9.1,11.5l2.1,16.5l10.9,2.2l14.4,2.3l11.6,10.6l3.1,15.5l-1.5,15.7l3.6,11.2l-4.9,13l-0.3,0.3
		c-2.3-2.4-6.2-2.7-9.3-1.5c-3.1,1.2-5.6,3.5-8.1,5.7c-4.4,4.1-8.9,8.2-13.3,12.3c-2.3,2.2-5.4,4.4-8.3,3.4
		c-1.8-0.6-2.9-2.3-4.3-3.5c-2.9-2.6-7-3.7-10.7-2.8c-0.3,0.1-0.5,0.2-0.8,0.3l-2.3,0.5c-2.3-1.3-1.7-4.9-0.4-7.3
		c1.3-2.4,2.5-5.5,0.7-7.6c-2-2.2-5.6-0.5-8.6-0.9c-4.9-0.6-7-7.1-5.1-11.6c1.8-4.4,6.3-7.4,10.5-10c-2.6-3.9-7-6.6-11.7-7.1
		c-3.1-0.3-6.6,0.2-8.8-2.1c-2.9-2.9-0.7-7.9,2.3-10.7c2.9-2.9,6.8-5.2,7.8-9.1c0.9-3.8-1.3-7.8-4.4-10.2c-3.2-2.3-7-3.4-10.8-4.4
		c-6.5-1.7-13.1-3.4-19.7-5l-0.8-0.4c-0.6-3.5,1.8-6.8,4.2-9.4c2.4-2.6,5.3-5,6.3-8.5c0.7-2.4,0.3-5,0.1-7.6c-0.6-5.5-0.4-11.9,4-15
		c3.7-2.6,8.8-1.8,12.8,0.2c4,1.9,7.7,4.8,11.9,6.2c4.3,1.4,9.7,0.9,12.3-2.9L1208.2,563.7z"
      />
    </a>
    <a (click)="SelectCode('SE1')">
      <path
        [class.selected]="IsSelected('SE1')"
        id="SE1"
        d="
		M732.1,849c5.2-8.6,14.7-13.9,24.5-16s20.1-1.4,30-0.3c31.6,3.7,63.1,12.5,89.5,30.1c-0.4,5.5-0.8,10.8-1.2,16.3
		c1.3,1.6,0.7,3.9-0.7,5.5c-1.3,1.5-3.2,2.3-4.9,3.4c-4.4,2.4-8.1,6-11.6,9.5c-0.9,0.9-1.8,2-1.6,3.3c0.4,2.1,3.4,2.2,5.4,1.6
		c2-0.6,4.7-1.2,5.9,0.6s-0.5,3.9-1.8,5.5s-2.6,4.2-0.9,5.5c0.7,0.5,1.6,0.6,2.5,0.6c7.5,0.3,15,0.5,22.5,0.8c2.2,2.2,2.6,5.9,1,8.5
		c2.3,3.4,8.2-2.2,11.5,0.3c1.8,1.3,1.3,4.4-0.5,5.9c-1.8,1.4-4.3,1.5-6.5,1.3c-2.3-0.2-4.6-0.5-6.8,0.2c1.8,3-0.6,6.7-2.3,9.7
		c-1.8,3-2.5,7.8,0.7,9.3l-0.5-1.4c0.1,5.1-4.5,9.8-9.7,9.8c-2.6-1.3-3.9-4.2-5-7c-1-2.8-2-5.7-4.1-7.7s-5.9-2.7-7.9-0.6l-0.3,1.2
		c-1.5-0.1-3.1-0.2-4.6-0.3c0.3-2,1.8-3.9,3.7-4.7c0.3-2.3-1.7-4.7-4-4.8c-1.3,3.4-4,6.1-7.3,7.6l0.6-0.9c-0.3-1.4-0.6-2.9-0.8-4.3
		c3.2-0.9,5.6-4.1,5.6-7.5c-8.9-6.2-16.4-14.2-22.2-23.4c-1.7,0.5-3,1.9-3.5,3.6c-3.7-0.1-7.3-2.2-9.3-5.3
		c-2.9,3.7-9.4,3.9-12.4,0.3c-2.9-0.3-5.7-0.4-8.6-0.7c0.8-1.4-1.9-2.6-2.9-1.3s-0.6,3.1,0.1,4.5c0.7,1.4,1.7,2.9,1.6,4.4
		c-0.3,2.6-3.3,4-5.9,4.3c-0.8,0.1-1.7,0.1-2.6,0.2l-0.7-0.8c-3.4-4.9-0.8-12.8-5.4-16.7c-4.9-4.1-12.9,0.8-18.6-2.2
		c-1.7-0.8-3-2.3-4.9-2.6c-1.7-0.3-3.2,0.6-4.6,1.4c-3.9,2.3-7.8,4.4-11.7,6.7c0.6,1.4,1.2,2.9,1.8,4.4c-3.3-0.5-6.5-1.1-9.8-1.6
		c1.3,2.9,2.7,6,2.3,9.1s-3.5,6-6.5,5c0,7-2.3,14.2-6.3,20l-5.8-4c4.5-6.8,7.3-14.8,7.6-22.9c1.1-21.7,3.4-42.3,8.6-63.4L732.1,849z
		"
      />
    </a>
    <a (click)="SelectCode('SE11')">
      <path
        [class.selected]="IsSelected('SE11')"
        id="SE11"
        d="
		M722.2,939.3c4-5.8,6.3-12.9,6.3-20c3,1,6.1-1.9,6.5-5s-0.9-6.2-2.3-9.1c3.3,0.5,6.5,1.1,9.8,1.6c-0.6-1.4-1.2-2.9-1.8-4.4
		c3.9-2.3,7.8-4.4,11.7-6.7c1.4-0.8,2.9-1.7,4.6-1.4c1.8,0.3,3.2,1.8,4.9,2.6c5.7,3,13.8-1.9,18.6,2.2c4.5,3.9,1.9,11.8,5.4,16.7
		l0.7,0.8c-1.8,0.1-3.6,0.4-5,1.4c-2.1,1.5-1.9,5.9,0.7,6c-0.8,5-6.4,7.3-9.4,11.2c-3.6,4.7-3,12.1,1.3,16.2
		c0.5,0.7,0.9,1.4,1.4,2.1c-2.1,0.8-3.4,3.1-3.6,5.4c-0.2,2.3,0.4,4.5,1,6.7l-0.1,1.3c-3.8-1.3-7.4-3.9-10.6-6.4
		c-0.5,1.9-1,4.3-1.4,4.5l-2.7-0.3l-2,0.5l-3.2-0.5l-3-2.1c-0.9-1.1-2.7-1.1-3.7-2c-1.1-0.9-1.2-2.6-1.8-3.9
		c-0.8-1.8-2.4-3.1-4.1-4.3C734.4,948.1,728.3,943.7,722.2,939.3L722.2,939.3z"
      />
    </a>
    <a (click)="SelectCode('SE17')">
      <path
        [class.selected]="IsSelected('SE17')"
        id="SE17"
        d="
		M847.6,941.8c-0.3-1.4-0.6-2.9-0.8-4.3c3.2-0.9,5.6-4.1,5.6-7.5c-8.9-6.2-16.4-14.2-22.2-23.4c-1.7,0.5-3,1.9-3.5,3.6
		c-3.7-0.1-7.3-2.2-9.3-5.3c-2.9,3.7-9.4,3.9-12.4,0.3c-2.9-0.3-5.7-0.4-8.6-0.7c0.8-1.4-1.9-2.6-2.9-1.3s-0.6,3.1,0.1,4.5
		c0.7,1.4,1.7,2.9,1.6,4.4c-0.3,2.6-3.3,4-5.9,4.3c-2.6,0.3-5.5,0.1-7.6,1.6s-1.9,5.9,0.7,6c-0.8,5-6.4,7.3-9.4,11.2
		c-3.6,4.7-3,12.1,1.3,16.2c0.5,0.7,0.9,1.4,1.4,2.1c-2.1,0.8-3.4,3.1-3.6,5.4c-0.2,2.3,0.4,4.5,1,6.7l0.2,1.4
		c2.2,0.7,4.5,1,6.9,0.6c3.3-0.6,6.2-2.4,9-4.3c6-3.9,11.9-8,17.9-11.9c-0.4,1.8-0.8,3.7-0.4,5.5c0.4,1.8,1.9,3.5,3.9,3.5
		c0.8,2.2,3.1,3.7,5.5,3.6c0.6-2.1,0.3-4.4-0.7-6.5c2.7,0.8,5,3,5.7,5.7c1-2.8,1.9-5.5,2.9-8.2c0.8,2.1,4.2,2.7,5.6,0.9
		c1-1.3,1.1-2.9,1.1-4.5s0.1-3.4,1.3-4.4s3.6-0.8,3.8,0.8c1.5-1.1,3.6-1.4,5.4-0.9c-0.3-1,0.7-2.2,1.8-2c-0.5,2.3,2.4,4.5,4.5,3.4
		s1.9-4.7-0.3-5.7L847.6,941.8z"
      />
    </a>
    <a (click)="SelectCode('SE16')">
      <path
        [class.selected]="IsSelected('SE16')"
        id="SE16"
        d="
		M875.7,862.4c6.4,3.4,13.2,6.2,20.3,7.3s14.7,0.3,21.1-3.3c10.3-5.8,15.9-17.8,25.8-24c7.1-4.4,16.3-5.6,24.3-3s14.7,8.9,17.9,16.7
		c6.2,15.4-1.5,34.1,5.4,49.2l0.4-0.5c-5.6,0.4-10.9,3.9-13.5,9c-0.2-1.6-2.5-2-3.8-1s-1.7,2.7-2.3,4.2s-1.8,3-3.4,3
		c-2.9,0-3.4-4.5-5.7-6.2c-3.6-2.6-7.9,2.7-12.3,2.9c-2.2,0.2-4.7-0.9-6.2,0.6c-1.1,1.1-1,2.8-0.8,4.3c0.4,4.4,0.9,8.8,1.3,13.3
		l0.1,1.3c-0.7,0.1-1.4,0.3-1.3,1.1c0.2,2.6-2.9,4.2-5.4,4.9s-5.6,1.5-6.4,4h0.3c-0.4,0-0.8,0-1.2,0.1c-0.2,0.2-0.4,0.3-0.5,0.5
		c0,3-1.8,5.8-5.4,5c-2.8-0.7-4.7-3-6.4-5.2c-0.1,2.9-2.7,5.3-5.5,6c-2.8,0.8-5.8,0.3-8.6-0.3c-2.9-0.5-5.8-1.2-8.7-1.6
		c-1.8-0.3-7.2-1.7-8.7-0.5l0.4,0.4c-3.2-1.5-2.4-6.3-0.7-9.3s4-6.7,2.3-9.7c2.2-0.7,4.5-0.3,6.8-0.2c2.3,0.2,4.7,0.1,6.5-1.3
		c1.8-1.4,2.3-4.5,0.5-5.9c-3.3-2.4-9.2,3.2-11.5-0.3c1.6-2.6,1.2-6.3-1-8.5c-7.5-0.3-15-0.5-22.5-0.8c-0.9,0-1.8-0.1-2.5-0.6
		c-1.7-1.3-0.4-3.9,0.9-5.5c1.3-1.6,3-3.8,1.8-5.5c-1.2-1.8-3.9-1.2-5.9-0.6c-2,0.6-5,0.5-5.4-1.6c-0.3-1.3,0.7-2.3,1.6-3.3
		c3.5-3.5,7.2-7,11.6-9.5c1.7-1,3.5-1.8,4.9-3.4c1.3-1.5,1.9-3.9,0.7-5.5c0.4-5.5,0.8-10.8,1.2-16.3"
      />
    </a>
    <a (click)="SelectCode('SE8')">
      <path
        [class.selected]="IsSelected('SE8')"
        id="SE8"
        d="
		M1027.3,948.3c-10.3-4.1-19-7.4-25.8-16.4c-6-7.8-9.8-17.3-10.7-27.2c-5.6,0.4-10.9,3.9-13.5,9c-0.2-1.6-2.5-2-3.8-1
		s-1.7,2.7-2.3,4.2s-1.8,3-3.4,3c-2.9,0-3.4-4.5-5.7-6.2c-3.6-2.6-7.9,2.7-12.3,2.9c-2.2,0.2-4.7-0.9-6.2,0.6
		c-1.1,1.1-1,2.8-0.8,4.3c0.4,4.4,0.9,8.8,1.3,13.3c0.4,4.8,0.9,9.7,3.1,13.9c6.5,13.1,19.9,11.7,31.5,15.5
		c6.5,2.2,3.9,7.9,3.6,13.6c-0.1,1.7-0.7,4.1-0.3,5.8c0.3,1.3,1.8,2,1.7,3.4c-0.1,1.3-3.1,3.2-2.9,4.3c0.8,3.5,6.4-1.4,8.4-1.5
		c2.9-0.2,6,1,8.1,2.8c4.6,3.6-1.1,4.8-3.1,6.6c-1.5,1.4-2.6,4.1-3.5,6c-0.3,0.7-3.3,8.6-3.5,8.6c7.5-1.8,14.9,12.3,19,17.2l1.5-0.9
		c3.3-0.8,6.6-1.5,10-1s6.7,2.3,8,5.5c0.5,1.3,0.7,2.8,1.6,3.8c1.3,1.5,3.9,1.3,5.5,0.2c1.7-1.2,2.7-3,3.7-4.8
		c-2.4,0.6-5-0.8-6.6-2.6c-1.7-1.8-2.8-4.1-4.2-6.1c-5.4-7.5-15.9-11.4-17.9-20.4c-0.3-1.7-0.3-3.5,0.8-4.9c1.1-1.3,3.5-1.5,4.4,0
		l-0.9-0.8c1-2.3-0.8-5.3-3.3-5.4c4-4.4,7-9.8,9.8-15.1c1.7-3.1,3.4-6.2,5-9.3c1.2-2.1,2.3-4.3,2.3-6.7c-0.1-5.9-2.3-8.6,0.7-14.4
		L1027.3,948.3z"
      />
    </a>
    <a (click)="SelectCode('SE10')">
      <path
        [class.selected]="IsSelected('SE10')"
        id="SE10"
        d="
		M1052,1020.5c-2.5-2.8-5-5.6-7.5-8.4c-4.2,0.3-8.4,0.6-12.6,0.9c-1.3-2.2-2.1-4.8-2-7.4c-2.6,0.3-5.3,0.7-7.9,1
		c0.7,1.8-2,3.1-3.6,2.2c-1.6-1-2.2-2.9-2.7-4.7s-0.8-3.9-2.6-4.3l-0.9-0.8c1-2.3-0.8-5.3-3.3-5.4c4-4.4,7-9.8,9.8-15.1
		c1.7-3.1,3.4-6.2,5-9.3c1.2-2.1,2.3-4.3,2.3-6.7c-0.1-5.9-2.3-8.6,0.7-14.4c-0.1,0.3,10.1,0.8,11.4,0.7c4.8-0.3,9.7-1.2,14.3-2.5
		c5.7-1.7,11.2-4.6,14.7-9.4c5.3-7,5.3-16.9,3.4-25.5c-1.8-8.6-5.5-17-6.7-25.7c-1.3-8.8,0.3-18.7,7-24.5c5.5-4.8,13.3-5.9,20.5-4.9
		c11,1.5,21.2,7.6,27.9,16.4c2.8,3.6,4.9,7.6,7.8,11.2c2.9,3.5,6.9,6.5,11.4,6.9l0.2,0.1c-0.6,0.2-1.1,0.4-1.5,0.9
		c-0.8,0.8-1.1,1.8-1.3,2.9c-1.9,7-3.9,13.9-5.8,20.9c-0.6,2.2-1.3,4.5-1.1,6.8c0.1,2.1,0.8,4,1,6.1c0.4,3.8-0.8,7.6-1.5,11.3
		c-0.7,3.8-0.5,8.1,2.1,10.8l-0.1,0.2c-2-0.3-4.4-0.1-6.4,0.3c-8.8,1.8-17.7,3.6-26.5,5.4c-3.4,0.7-7.3,1.7-9,4.7
		c-1,1.8-1,3.9-1.7,5.9c-1.2,3.4-4.1,6-6,9.1c-1.8,3.2-2.3,7.9,0.8,9.9c5.5-2.3,13-2.3,16.3,2.8c3.4,5.4,0,12.3-3.4,17.6
		c-3.7,5-12.4,5-16.1-0.1c-1.1-1.4-2-3.4-3.9-3.5c-2.9-0.2-3.4,4.3-5.7,6.1c-1.5,1.3-3.8,1.3-5.8,1.6c-5.4,0.9-10,5.4-11.1,10.7
		L1052,1020.5z"
      />
    </a>
    <a (click)="SelectCode('SE7')">
      <path
        [class.selected]="IsSelected('SE7')"
        id="SE7"
        d="
		M1175.6,893.3c-10.5,1.9-21.4,1.3-31.6-1.9c-2.3-0.8-5.1-1.4-6.9,0.3c-0.8,0.8-1.1,1.8-1.3,2.9c-1.9,7-3.9,13.9-5.8,20.9
		c-0.6,2.2-1.3,4.5-1.1,6.8c0.1,2.1,0.8,4,1,6.1c0.4,3.8-0.8,7.6-1.5,11.3c-0.7,3.8-0.5,8.1,2.1,10.8l-0.1,0.2
		c2,0.3,3.8,1.2,4.6,3.1c2.1,4.9-4.8,10.2-2.7,15.1c2.4,5.5,11.8,1.9,16,6.1c2.7,2.7,2,7.2,3.4,10.7c1.8,4.6,7.1,7,12,8
		c5,1,10.2,1.3,14.5,3.8l1.1-0.1c7.7-2.6,15.5-5.2,23.2-7.9c2.5-0.8,5.5-2.1,6-4.7c0.3-1.4-0.2-2.9-0.4-4.3
		c-1.3-7.6,4.7-15.5,12.3-16.4c0.5-10.2-1.8-20.5-6.7-29.5c-4.4-8.2-10.8-15.3-17.1-22.2c-1.3-1.5-3.7,0.8-3.9,2.9s-0.3,4.7-2.2,5.3
		c-1.4,0.4-2.9-0.9-3.3-2.3c-0.3-1.4,0.2-2.9,0.6-4.4c-6.1-5.1-10.5-12.3-12.2-20.1V893.3z"
      />
    </a>
    <a (click)="SelectCode('SE18')">
      <path
        [class.selected]="IsSelected('SE18')"
        id="SE18"
        d="
		M1179.3,997.3c7.7-2.6,15.5-5.2,23.2-7.9c2.5-0.8,5.5-2.1,6-4.7c0.3-1.4-0.2-2.9-0.4-4.3c-1.3-7.6,4.7-15.5,12.3-16.4
		c0.5-10.2-1.8-20.5-6.7-29.5c-4.4-8.2-10.8-15.3-17.1-22.2c-1.3-1.5-3.7,0.8-3.9,2.9s-0.3,4.7-2.2,5.3c-1.4,0.4-2.9-0.9-3.3-2.3
		c-0.3-1.4,0.2-2.9,0.6-4.4c-6.1-5.1-10.5-12.3-12.2-20.1c31.8-2.4,63.6-4.9,95.4-7.4c5.7-0.4,11.5-0.9,16.9-2.9l0.1-0.3
		c-0.5,1.6-0.8,3.2-0.9,4.9c-0.3,5.8,1.9,11.3,4.2,16.6c1.4,3.4,2.9,6.9,5.1,10c3.9,5.5,10.5,9.4,17.3,9.4c1.9,0,3.8-0.3,5.7-0.6
		c5.3-0.8,10.6-1.6,15.8-2.4c0.1-2.1,0.1-4.2,0.2-6.3c5.5,1.2,11,2.3,16.4,1.4c1.2-0.2,2.4-0.5,3.6-0.9l0.3,0.6
		c3.4,2.9,3.4,8,3,12.4s-0.9,9.4,2,12.8c1.4,1.7,3.5,2.6,5.3,4c1.8,1.3,3.3,3.4,2.9,5.6c-2-1.8-5.2-1.8-7.4-0.3c-2.2,1.5-3,4.6-2,7
		c-3.1,1.3-5.2,4.5-5.1,7.8s2.4,6.4,5.6,7.5c1.6,0.5,3.4,0.6,4.9,1.4c1.2,0.7,2,1.8,2.8,3c2.5,3.8,5,7.6,7.6,11.2l1.1-0.2
		c-0.3,2.4,2.7,4.8,1.7,7.1c-0.3,0.6-0.8,1-1.2,1.3c-4.4,3.4-10.2,4.7-15.5,3.6c-0.2,0.3,0.2,0.5,0,0.9c-4.4-0.4-9.3-2.4-13.7-3.7
		l-6,5l-5.1-0.8l-2.7,7.1l-13.8,8.1l-10.6,3.2l-12.1-6.1l-10.1,9.7l-3.9,17l-0.8-0.5c-9.4-3.1-19.9-2.6-29,1.4
		c-2.3,1-4.4,2.2-6.9,2.5c-2.4,0.3-5.2-0.6-6.3-2.8c-1.7-3.4,1.6-7.1,1.6-10.9c0-4.7-4.7-7.9-8.8-10.2c-3.8-2.1-9.2-3.9-12-0.6
		l-0.1-0.9c-4.6,2.4-10.4,4.9-14.6,1.8c-2.9-2.2-3.6-6.2-4.8-9.7c-1.1-3.4-3.8-7.2-7.4-6.9c-0.6,2.3-3.7,3.6-5.8,2.4
		c-3.5-3-7-6-10.5-9.1L1179.3,997.3z"
      />
    </a>
    <a (click)="SelectCode('SE28')">
      <path
        [class.selected]="IsSelected('SE28')"
        id="SE28"
        d="
		M1337.4,828.2c-18.9,7-31.2,24.8-42.3,41.6c-3.7,5.5-7.5,11.5-7.9,18.1c-0.3,5.8,1.9,11.3,4.2,16.6c1.4,3.4,2.9,6.9,5.1,10
		c3.9,5.5,10.5,9.4,17.3,9.4c1.9,0,3.8-0.3,5.7-0.6c5.3-0.8,10.6-1.6,15.8-2.4c0.1-2.1,0.1-4.2,0.2-6.3c5.5,1.2,11,2.3,16.4,1.4
		c5.5-0.8,10.9-4.3,12.6-9.6c1.4-4.5,0.6-10.8,5-12.8c2.4-1.2,5.7-0.2,7.9-1.8c2.3-1.6,2.3-5,3.9-7.3c2.2-3.4,6.7-3.9,10.7-4.5
		c9.8-1.4,19.6-4.6,27.1-11.1c3.4-3,7.1-6.9,11.7-6.5c3.2,0.3,6.2,2.8,9.2,1.8c2.5-0.8,3.8-3.7,3.9-6.4c0.3-2.6-0.3-5.4,0.3-8
		c1.4-6.8,9.1-10.3,15.9-10.9c6.9-0.6,14,0.6,20.6-1.4l0.9-0.6c1-4.4,1.9-8.7,2.8-13c0.4-1.8,2.3-6.1,1.8-8
		c-1-3.6-10.1-8.3-13.2-10.7c-2.3-1.8-4.7-3.6-7.4-4.9c-2.8-1.3-5.9-2.1-8.9-2.8c-8.6-1.9-17.1-3.4-25.8-4.3
		c-3.9-0.4-8.9-1.6-12.8-1.1c-3.6,0.4-6.2,2.7-9.4,4.5c-7,4.1-13.9,8.6-20.6,13.3c-8.4,5.9-13.7,13.2-23.7,15.2
		c-6.8,1.3-13.3,4.4-20.2,5.3c-1.4,0.2-2.9,0.3-4.3-0.2c-1.5-0.5-2.3-1.3-2.6-2.2L1337.4,828.2z"
      />
    </a>
    <a (click)="SelectCode('SE2')">
      <path
        [class.selected]="IsSelected('SE2')"
        id="SE2"
        d="
		M1355.8,915.7c3.4,2.9,3.4,8,3,12.4s-0.9,9.4,2,12.8c1.4,1.7,3.5,2.6,5.3,4c1.8,1.3,3.3,3.4,2.9,5.6c-2-1.8-5.2-1.8-7.4-0.3
		c-2.2,1.5-3,4.6-2,7c-3.1,1.3-5.2,4.5-5.1,7.8s2.4,6.4,5.6,7.5c1.6,0.5,3.4,0.6,4.9,1.4c1.2,0.7,2,1.8,2.8,3
		c2.5,3.8,5,7.6,7.6,11.2l1.1-0.2c1.6,0.2,4.6,0.4,6,1.5c2.5,2,2,5.4,6.9,5.3c1.5-2.8,2.1-9.7,5.5-10.4c4.4-0.8,6,3.1,8.1-2.4
		c0.8-2,2.6-3.1,3.4-5.3c0.8-2.3,0-4.7,1.5-7c1.3-1.9,4.3-3,6.1-1.6c1.7,1.3,1.8,3.7,2.5,5.6c3.4,8.6,12.9-0.8,19.4,1.3
		c0.4,0.1,4.2,3,3.9,3.4c3.4-4.2,8.8-5.9,13.3-8.8c2.3-1.5,4.2,0.8,5.8-0.5c0.7-0.6,1.1-3.2,1.3-4c1-2.9,1.9-5.7,2.9-8.6l0.5-16.6
		l-19.3-0.1c-2.3-2.9-8.6-14.3-12-12.8c-1.3,0.6-2.6,1.7-4,1.6c-0.8,0-1.5-0.4-2.2-0.8c-5.4-2.9-6-9.1,1.3-10.9
		c2.2-0.6,7.7,2.3,9.1,0.3c0.4-0.5-1.8-4.2-1.8-5.1c0-0.8,0.4-1.6,0.8-2.3c3.4-6,0.4-2.8-1.4-7.1c-0.7-1.5-0.3-3.4,0.8-4.6
		c0.5-0.5,1.1-0.9,1.5-1.5c0.7-1,0.8-2.3,0.1-3.4c-1.9-3.1-2.7-0.8-1.9-5c0.3-1.8,1.2-3.5,1.8-5.2l10.7-15.4l14,4.1l17.5-11
		l2.7-21.7c0-0.2,0.1-0.4,0.1-0.6l-0.6-1c-6.6,2-13.8,0.8-20.6,1.4c-6.9,0.6-14.5,4.1-15.9,10.9c-0.5,2.6,0,5.4-0.3,8
		c-0.2,2.7-1.4,5.5-3.9,6.4c-3,1-6-1.4-9.2-1.8c-4.5-0.4-8.2,3.4-11.7,6.5c-7.6,6.5-17.3,9.7-27.1,11.1c-3.9,0.6-8.5,1.2-10.7,4.5
		c-1.5,2.3-1.6,5.7-3.9,7.3c-2.2,1.6-5.5,0.6-7.9,1.8c-4.4,2-3.5,8.3-5,12.8c-1.3,4.2-5,7.2-9.2,8.7L1355.8,915.7z"
      />
    </a>
    <a (click)="SelectCode('SE9')">
      <path
        [class.selected]="IsSelected('SE9')"
        id="SE9"
        d="
		M1282.7,1040.2c-9.4-3.1-19.9-2.6-29,1.4c-2.3,1-4.4,2.2-6.9,2.5c-2.4,0.3-5.2-0.6-6.3-2.8c-1.7-3.4,1.6-7.1,1.6-10.9
		c0-4.7-4.7-7.9-8.8-10.2c-3.8-2.1-9.2-3.9-12-0.6c-2.1,2.5-1.1,6.6-3.1,9.3c-2.4,3.2-8.1,2.9-9.9,6.4c-0.9,1.8-0.7,3.9-1.5,5.7
		c-1.2,2.3-3.9,3.3-6.5,4.1c-7.2,2.4-13.3,7.1-19,11.9c-2.9,2.4-6,5.5-9.3,7.4c-2.7,1.5-7.4,1.6-8,5.4c-0.5,3,2.2,5.4,5,5.5
		c-5.9,6.4-12.9,12.1-19.3,18c-1.8,1.7-3.8,4.3-2.3,6.3c1.4,2.1,4.8,0.9,7.2,1.8s3.6,3.5,4.5,6c3.8,10.1,7.5,20.6,6.3,31.2
		c-0.6,5.3-2.5,10.4-3.5,15.7c-1,5.2-1.2,11,1.3,15.7c0.8,1.6,2,3,2.3,4.8c0.3,2.1-0.7,4.1-1.4,6c-2.1,5.4-2.3,11.4-0.8,17
		c1.8,6.4,6,12,6.6,18.5c0.5,4.9-1,9.7-2.4,14.4l0,0l2.4,0.6l10.2,9.2l18.5,1.8l5.6,3.8l5.4-10l10.9-9.4l4.5-9l3.4-0.9l5.9,5.3
		l3.6,8.6l12.7-5.9l8.1,1.1l14-5.1l-0.8-10.2l6.6-3.2l2.8-7.6c3.8-0.8,10.4-4.1,11.8,0.3c0.4,1.3,0.8,2.7,1.8,3.8
		c0.9,1.1,2.3,1.8,3.7,1.6c2.6-0.5,3.4-3.9,2.9-6.4c-0.9-4.8-0.8-11.4,2.3-15.7l4.5-6.5l-7.2-11.3l-2.1-2.8l3.7-2v-14.6l-4.9-12.4
		l8.5-0.3l9.6-1.9l10.7-7.9l-8.6-15.4l-0.7-19.1l-5.5-14.4l-6.3-12.8l-6.5-7l-11.7-8.1l-3.9-6.5"
      />
    </a>
    <a (click)="SelectCode('SE3')">
      <path
        [class.selected]="IsSelected('SE3')"
        id="SE3"
        d="
		M1151.4,1091.9c5.9-5.3,12.3-10.6,17.6-16.4c-2.8-0.2-5.5-2.5-5-5.5c0.6-3.8,5.3-3.9,8-5.4c3.4-1.8,6.4-5,9.3-7.4
		c5.8-4.8,11.8-9.5,19-11.9c2.5-0.8,5.3-1.8,6.5-4.1c0.8-1.8,0.6-3.9,1.5-5.7c1.8-3.5,7.5-3.2,9.9-6.4c2-2.7,1-6.8,3.1-9.3l-0.1-0.9
		c-4.6,2.4-10.4,4.9-14.6,1.8c-2.9-2.2-3.6-6.2-4.8-9.7c-1.1-3.4-3.8-7.2-7.4-6.9c-0.6,2.3-3.7,3.6-5.8,2.4c-3.5-3-7-6-10.5-9.1
		c-4.4-2.5-9.6-2.8-14.5-3.8s-10.2-3.4-12-8c-1.4-3.5-0.8-8.1-3.4-10.7c-4.2-4.2-13.6-0.7-16-6.1c-2.1-4.9,4.8-10.2,2.7-15.1
		c-1.6-3.8-7-3.6-11-2.8c-8.8,1.8-17.7,3.6-26.5,5.4c-3.4,0.7-7.3,1.7-9,4.7c-1,1.8-1,3.9-1.7,5.9c-1.2,3.4-4.1,6-6,9.1
		c-1.8,3.2-2.3,7.9,0.8,9.9c5.5-2.3,13-2.3,16.3,2.8c3.4,5.4,0,12.3-3.4,17.6c-3.7,5-12.4,5-16.1-0.1c-1.1-1.4-2-3.4-3.9-3.5
		c-2.9-0.2-3.4,4.3-5.7,6.1c-1.5,1.3-3.8,1.3-5.8,1.6c-5.4,0.9-10,5.4-11.1,10.7l0.5-0.1c2.9,3.2,5.7,6.3,8.5,9.4
		c1,1.1,2,2.3,2.3,3.8s-0.5,3.3-1.9,3.5c-0.8,0.2-1.8-0.3-2.5,0.3c-1.4,1,0.4,3,2,3.7c5.5,2.2,11.7,3.9,16.7,6.7
		c3.3,1.8,7-1.5,10.2,1.1c2.7,2.2,2.3,8.4,2.9,11.6s0.3,7.5-1.2,10.7l0.4,0.6c3.2,0.9,6.4,1.8,9.6,2.7c1.7,2,3.4,4.1,6,5
		c5,1.8,10.2-1.8,14.1-5.4c3.9-3.7,8.1-7.9,13.4-7.6c-0.1,1.8,1.8,3.2,3.4,3.8c1.8,0.6,3.7,0.7,5.2,1.8c2.3,1.5,3,4.4,3.1,7.1
		s-0.3,5.5,0.6,8.1c0.8,2.6,3.2,5,5.9,4.5"
      />
    </a>
    <a (click)="SelectCode('SE12')">
      <path
        [class.selected]="IsSelected('SE12')"
        id="SE12"
        d="
		M1149.7,1093.4c-1.8,1.7-3.8,4.3-2.3,6.3c1.4,2.1,4.8,0.9,7.2,1.8s3.6,3.5,4.5,6c3.8,10.1,7.5,20.6,6.3,31.2
		c-0.6,5.3-2.5,10.4-3.5,15.7c-1,5.2-1.2,11,1.3,15.7c0.8,1.6,2,3,2.3,4.8c0.3,2.1-0.7,4.1-1.4,6c-2.1,5.4-2.3,11.4-0.8,17
		c1.8,6.4,6,12,6.6,18.5c0.5,4.9-1,9.7-2.4,14.4l-1.3-0.3l-6.3-1.5l-0.9-6.3l-8.1-7.8l-6.1-4c0,0-8.1,6.6-8.3,7.2
		c-0.2,0.8,0,1.5-0.3,2.2c-0.9,2.3-4.5,1.2-5.5-0.4c-1.1-1.8,0.6-5.3,0.5-7.3c-0.1-1.7-0.3-6-2.3-6.3c1.8,0.3,3.4-1.3,3.6-3
		c0.3-1.8-0.8-3.4-2.2-4.4c-1.8-1.3-2.2-6.5-3.3-9c-1-2.3-2-4.5-3-6.8l-6.7-3.9l-1.5-1.3c1.9-1.3,1.3-4.5-0.4-6.2
		c-1.7-1.7-3.9-2.7-5.5-4.5c-1.2-1.3-1.7-3.1-2.3-4.8c-3.1-8.8-8.6-16.7-15.5-22.9c-1.2-1.1-3.7-3.1-6.7-5.2l-0.3,0.4
		c2.4-2.9,1.3-7.3-0.3-10.8c-1.6-3.5-3.5-7.3-2.3-10.9c2.9,1.7,6.4-1.5,6.6-4.8c0.3-3.3-1.5-6.3-2.6-9.4c-3.2-8.5-1.9-18.5,3.3-25.9
		c3.2,0.9,6.4,1.8,9.6,2.7c1.7,2,3.4,4.1,6,5c5,1.8,10.2-1.8,14.1-5.4c3.9-3.7,8.1-7.9,13.4-7.6c-0.1,1.8,1.8,3.2,3.4,3.8
		c1.8,0.6,3.7,0.7,5.2,1.8c2.3,1.5,3,4.4,3.1,7.1s-0.3,5.5,0.6,8.1c0.8,2.6,3.2,5,5.9,4.5L1149.7,1093.4z"
      />
    </a>
    <a (click)="SelectCode('SE4')">
      <path
        [class.selected]="IsSelected('SE4')"
        id="SE4"
        d="
		M1006.4,1031.1c-4.1-4.9-11.6-19-19-17.2l-0.1,0.1c-0.6,0-0.8-0.1-1.4-0.1c0.2-3.2-2.2-6.2-5.1-4.6c-2.9,0.3-4.8,3.2-5.9,5.9
		c-2.9,7-3.5,14.9-1.8,22.2c-2.3-0.8-4.4-1.7-6.7-2.5c-0.3-4.2,0.7-8.5,2.5-12.3c-2.3,0.5-4-1.8-5-3.9s-2.1-4.7-4.4-5
		c-2.3-0.3-4.1,2.3-4.4,4.6c-0.3,2.3,0.6,4.7,0.6,7c0.1,5.5-4,10.5-9.2,12.1s-11.1,0.2-15.4-3.1c0,1.8,0,3.7,0,5.5
		c7.4,3.4,11.7,11.4,12.6,19.5c0.9,8.1-0.8,16.1-2.7,24l2.5,0.7c2.5,2.9,3.4,7.1,2.3,10.8c5,0.8,10,1.7,14.4,4.1
		c4.4,2.5,7.9,7,7.7,12c-0.1,1.5-0.4,2.9-0.2,4.4c0.3,1.5,1.2,3,2.7,3.1c1.8,0.2,3.2-1.8,5-1.7c0.5,0,1,0.2,1.4,0.5l1.6,0.7
		c10.5,1.8,21.8-1.9,29.1-9.8l-0.2-1.1c2.3-1.8,1.3-5.5-0.3-8s-3.6-5.4-2.5-8.1c0.3-0.9,1-1.7,1.3-2.6c0.8-2.8-1.9-5.4-4.8-6
		s-5.8,0-8.6-0.6s-5.6-3.3-4.7-6c6.4,1,12.7,2.1,19,3.1c1.4,0.3,2.9,0.4,4.2-0.3c1.3-0.8,1.6-2.9,0.3-3.5c-2.3,1.1-5.1-0.3-6.5-2.3
		c-1.4-2.1-1.7-4.7-1.8-7.2c-0.7-11.9,0.9-24,4.7-35.4L1006.4,1031.1z"
      />
    </a>
    <a (click)="SelectCode('SE13')">
      <path
        [class.selected]="IsSelected('SE13')"
        id="SE13"
        d="
		M1088.3,1073.6c3.2-3.9,3.2-7.9,2.3-12.5c-0.6-3.2-0.3-9.4-2.9-11.6c-3.2-2.6-6.9,0.8-10.2-1.1c-5-2.9-11.2-4.5-16.7-6.7
		c-1.6-0.7-3.4-2.7-2-3.7c0.7-0.5,1.7-0.1,2.5-0.3c1.4-0.3,2.3-2,1.9-3.5s-1.3-2.7-2.3-3.8c-5.5-6.1-11-12.3-16.4-18.4
		c-4.2,0.3-8.4,0.6-12.6,0.9c-1.3-2.2-2.1-4.8-2-7.4c-2.6,0.3-5.3,0.7-7.9,1c0.7,1.8-2,3.1-3.6,2.2c-1.6-1-2.2-2.9-2.7-4.7
		s-0.8-3.9-2.6-4.3c-0.8-1.5-3.3-1.3-4.4,0c-1.1,1.3-1.1,3.2-0.8,4.9c1.9,9,12.5,12.9,17.9,20.4c1.4,2,2.5,4.3,4.2,6.1
		c1.7,1.8,4.2,3.2,6.6,2.6c-1,1.8-2,3.6-3.7,4.8c-1.7,1.2-4.2,1.3-5.5-0.2c-0.9-1-1.1-2.5-1.6-3.8c-1.3-3.1-4.6-5-8-5.5
		s-6.7,0.3-10,1c-3.8,11.4-5.4,23.5-4.7,35.4c0.1,2.5,0.3,5.1,1.8,7.2c1.3,2.1,4.2,3.4,6.5,2.3c1.3,0.7,1,2.8-0.3,3.5
		c-1.3,0.8-2.8,0.6-4.2,0.3c-6.4-1-12.7-2.1-19-3.1c-0.9,2.8,1.9,5.5,4.7,6c2.8,0.6,5.7,0,8.6,0.6s5.6,3.2,4.8,6
		c-0.3,0.9-1,1.7-1.3,2.6c-1.1,2.7,0.9,5.5,2.5,8.1c1.6,2.5,2.6,6.2,0.3,8l0.2,1.1c2.4-0.2,4.6,1.3,6.6,2.6c2.3,1.4,5.3,2.9,7.8,1.5
		c-1.3-0.8-2.3-2.5-1.4-4c0.8-1.4,2.8-1.8,4.3-1.2c2.1,0.9,2.9,3.1,5,4.1c2.3,1.2,5.5,1.4,8.1,1.4c3.4-2.2,8.3-1.4,10.9,1.7
		c3.2,0.2,5.8,3.6,5.1,6.7c-0.3,1-0.7,1.8-0.8,2.9c-0.1,2.3,2,3.9,3.9,5.3c6.8,4.5,5.9,2.7,11.4-1.7c3.1-2.7,10.7,1.6,16.7,6
		l-0.1,0.7c2.4-2.9,1.3-7.3-0.3-10.8c-1.6-3.5-3.5-7.3-2.3-10.9c2.9,1.7,6.4-1.5,6.6-4.8c0.3-3.3-1.5-6.3-2.6-9.4
		c-3.2-8.5-1.9-18.5,3.3-25.9L1088.3,1073.6z"
      />
    </a>
    <a (click)="SelectCode('SE14')">
      <path
        [class.selected]="IsSelected('SE14')"
        id="SE14"
        d="
		M944.3,936.1c-0.7,0.1-1.4,0.3-1.3,1.1c0.2,2.6-2.9,4.2-5.4,4.9s-5.6,1.5-6.4,4c-0.9,3,2,5.7,3,8.6c1.3,3.8-0.9,7.9-3.6,10.8
		c-2.7,3-6,5.5-7.6,9.2c-1.2,2.7-1.3,5.6-1.5,8.6c-0.3,6.4-0.8,12.8-1.4,19.2c1.5,0.4,2.9-0.6,4.3-1.3c1.4-0.8,3.3-1.2,4.3,0
		c1.8,2.3-1.7,3.9-2.3,5.5c-1,2.6-0.5,2,0,4.5c1.1,5.9,2.6,11.7,3.8,17.5c-0.3,1.1-0.7,2.1-1,3.2c0.4,0.8,0.9,1.4,1.4,2.1l0.5,0.3
		c4.3,3.3,10.2,4.7,15.4,3.1s9.3-6.6,9.2-12.1c0-2.3-0.8-4.7-0.6-7c0.3-2.3,2-4.9,4.4-4.6c2.3,0.3,3.4,2.9,4.4,5s2.7,4.4,5,3.9
		c-1.8,3.8-2.8,8.1-2.5,12.3c2.3,0.8,4.4,1.7,6.7,2.5c-1.7-7.3-1.1-15.2,1.8-22.2c1.1-2.7,3-5.5,5.9-5.9c2.9-1.6,5.3,1.4,5.1,4.6
		c0.6,0,0.8,0.1,1.4,0.1l0.1-0.1c0.3-0.1,3.2-8,3.5-8.6c0.9-1.9,2-4.6,3.5-6c2-1.8,7.7-3,3.1-6.6c-2.2-1.8-5.3-2.9-8.1-2.8
		c-2,0.1-7.6,5-8.4,1.5c-0.3-1.1,2.8-2.9,2.9-4.3c0.1-1.4-1.3-2.1-1.7-3.4c-0.4-1.7,0.2-4.1,0.3-5.8c0.3-5.7,2.9-11.4-3.6-13.6
		c-11.6-3.9-24.9-2.4-31.5-15.5c-1.8-3.6-2.5-7.7-2.9-11.7"
      />
    </a>
    <a (click)="SelectCode('SE15')">
      <path
        [class.selected]="IsSelected('SE15')"
        id="SE15"
        d="
		M930.2,1101.4c1.3-5.3,3.8-10.4,7.1-14.7c0.9-1.1,2.1-2.3,3.4-2.8l0.3-0.6c1.8-7.9,3.6-15.9,2.7-24c-0.9-8.1-5.2-16.1-12.6-19.5
		c0-1.8,0-3.7,0-5.5l-0.5-0.3c-0.5-0.7-1-1.3-1.4-2.1c0.3-1.1,0.7-2.1,1-3.2c-1.2-5.9-2.7-11.7-3.8-17.5c-0.5-2.5-1-1.9,0-4.5
		c0.6-1.7,4.1-3.3,2.3-5.5c-1-1.2-2.9-0.8-4.3,0c-1.3,0.8-2.8,1.8-4.3,1.3c0.7-6.4,1.1-12.8,1.4-19.2c0.2-2.9,0.3-5.9,1.5-8.6
		c1.6-3.7,4.9-6.2,7.6-9.2c2.7-2.9,4.9-7,3.6-10.8c-1-2.9-3.9-5.6-3-8.6h0.3c-0.4,0-0.8,0-1.2,0.1c-0.2,0.2-0.4,0.3-0.5,0.5
		c0,3-1.8,5.8-5.4,5c-2.8-0.7-4.7-3-6.4-5.2c-0.1,2.9-2.7,5.3-5.5,6c-2.8,0.8-5.8,0.3-8.6-0.3c-2.9-0.5-5.8-1.2-8.7-1.6
		c-1.8-0.3-7.2-1.7-8.7-0.5c-1.2,1-1.6,4.5-3,5.9c-1.8,1.8-4.2,2.9-6.7,2.9c-2.6-1.3-3.9-4.2-5-7c-1-2.8-2-5.7-4.1-7.7
		s-5.9-2.7-7.9-0.6c0.5,1.3,1.1,2.6,1.6,3.9c-3.5,1.3-5.3,6-3.6,9.4c-5-0.9-10.2-1.8-15-0.5c-4.9,1.4-9.3,5.8-8.9,10.8
		c0.3,3.5,2.8,6.5,5.1,9.1c5.3,6,10.7,12.1,15.9,18.1c-2.2,3.5-3.9,7.6-3.3,11.7c0.3,2.1,1.1,4,1.3,6c0.3,2.1-0.3,4.4-2.1,5.5
		s-4.6-0.3-4.4-2.3c-1.7-1.7-5,0.5-4.7,2.9s2.8,4,5.2,4.2c2.3,0.3,4.8-0.6,7.1-1s5-0.5,7,0.9c-7.5,3.6-12.3,12.1-11.4,20.3l-0.1-0.4
		c-0.6,4.3,1.3,8.7,4.8,11.3c3.4,2.6,8.3,3.1,12.2,1.4c1.4-0.6,2.8-1.5,4.3-1.4s2.9,2,1.9,3.1c1.6,0.3,3.3-0.8,3.6-2.3
		c6.1,2.6,12.8,0.5,14.8,8.2c1.3,5-0.6,10.2,4.5,13.5c7.1,4.8,11.4-0.8,18.4-2.3c2.1-0.4,4.5-0.6,6,1c2,2.1,0.4,4.1,0.3,6.4
		c-0.2,2.8-0.3,3.9,1.1,6.7c2.2,4.7,5.1,9,8.9,12.5"
      />
    </a>
    <a (click)="SelectCode('SE5')">
      <path
        [class.selected]="IsSelected('SE5')"
        id="SE5"
        d="
		M849.5,1042.9c-0.8-8.2,3.9-16.7,11.4-20.3c-1.9-1.4-4.6-1.3-7-0.9c-2.3,0.4-4.8,1.3-7.1,1c-2.4-0.2-5-1.8-5.2-4.2
		c-0.3-2.4,3-4.6,4.7-2.9c-0.3,2,2.6,3.4,4.4,2.3s2.3-3.4,2.1-5.5c-0.3-2-1-3.9-1.3-6c-0.6-4.1,1.1-8.2,3.3-11.7
		c-5.3-6-10.7-12.1-15.9-18.1c-2.3-2.7-4.8-5.6-5.1-9.1c-0.4-5,4-9.4,8.9-10.8c4.9-1.3,10.1-0.4,15,0.5c-1.7-3.4,0.1-8.1,3.6-9.4
		c-0.5-1.3-1.1-2.6-1.6-3.9l-0.3,1.2c-1.5-0.1-3.1-0.2-4.6-0.3c0.3-2,1.8-3.9,3.7-4.7c0.3-2.3-1.7-4.7-4-4.8c-1.3,3.4-4,6.1-7.3,7.6
		c2.2,1,2.3,4.6,0.3,5.7c-2.1,1.1-5-1.1-4.5-3.4c-1.1-0.2-2,1-1.8,2c-1.8-0.5-3.9-0.2-5.4,0.9c-0.2-1.6-2.6-1.8-3.8-0.8
		s-1.3,2.9-1.3,4.4c0,1.6-0.1,3.3-1.1,4.5c-1.4,1.8-4.8,1.2-5.6-0.9c-1,2.7-1.9,5.5-2.9,8.2c-0.8-2.7-3-5-5.7-5.7
		c1,2,1.3,4.4,0.7,6.5c-2.3,0.1-4.6-1.4-5.5-3.6c-1.9,0-3.4-1.7-3.9-3.5c-0.4-1.8,0-3.7,0.4-5.5c-6,3.9-11.9,8-17.9,11.9
		c-2.8,1.8-5.7,3.7-9,4.3c-6.5,1.1-12.6-3.1-17.8-7.1c-0.5,1.5-0.9,3-1.4,4.5l0.7-1.1c1,6.5,7.8,10.3,13.7,13.3s12.4,7.7,12.2,14.4
		c-4.6,2.1-9.8,2.8-14.9,2c-1.6,4.4-3,9.9,0.3,13.1c1.3,1.3,3.4,2.3,3.4,4.1c0.1,1.9-2.1,3.8-1,5.4c0.7,0.9,2.1,0.9,3.1,1.3
		c2.6,1,2.9,4.6,2.5,7.5s-0.8,6.2,1.3,8c2.5-0.5,5.3,1.8,5.1,4.4l-1,1.3c2.3-1,5,0.8,6.1,3.1c1.2,2.2,1.7,4.8,3.1,6.9
		c1.5,2,4.7,3.3,6.5,1.4c2.2-2.2,0-6.3,1.7-8.9c1-1.5,3.1-2,4.8-1.6c1.8,0.5,3.1,1.8,4.2,3.3c0.7,0.9,1.3,2.1,1.1,3.2
		c-0.4,3.1-5.3,3.2-7,5.8c-1.6,2.3-0.3,6-2.3,8c0.3,2.2,0.2,3.9,1.7,5.4c1.6,1.5,4.7,1.4,5.5-0.6c0.2-0.3,0.2-0.8,0.3-1
		c0.6-0.9,2.1-0.8,2.9-0.1c0.8,0.8,1.3,1.8,1.8,2.8c2.1,3.7,6.5,5.5,9.2,8.7c0.5,0.6,0.9,1.3,1.3,2c0.1,0.2,0.2,0.4,0.3,0.6l0.1,1
		c3.8-2.2,3.9-7.6,3.2-11.9c-0.8-4.4-1.9-9.2,0.8-12.8c1.4-1.9,3.9-3.2,4.4-5.5c0.9-3.4-2.3-8.1,0.6-10.1c2.1-1.4,4.7,0.6,6.5,2.3
		c1.8,1.8,4.8,3.4,6.5,1.6L849.5,1042.9z"
      />
    </a>
    <a (click)="SelectCode('SE22')">
      <path
        [class.selected]="IsSelected('SE22')"
        id="SE22"
        d="
		M823.8,1091.1c1,0.8,1.3,2.1,2.3,3c2,2.2,5.6,1.1,8.5,0.3c2.9-0.8,7-0.3,7.4,2.7c0.4,3.3-4.6,5.3-4.3,8.6c0.4,4.1,8.5,4.7,7.7,8.7
		c1.1-2.1,4.4-1.3,5.9,0.5c1.4,1.8,1.9,4.4,3.4,6.1c1.4,1.8,4.9,2.5,5.9,0.3c1,3,3.3,5.6,6.1,7c-2.3,2.1-4.5,4.3-5.7,7.1
		c-1.2,2.9-0.8,6.5,1.8,8.4c4.8,3.4,5.2-2.8,9.1-1.8c1.9,0.5,3.2,2.3,3.9,4.2c1.7,3.7,2.4,8.1,2.2,12.4l0.5,0.1
		c3,0.6,6.2-0.9,8.3-3.2c2.1-2.3,3.2-5.4,3.9-8.4c1.3-5.6,1.2-11.5,2-17.1c1-6.7,3.8-13.7,9.4-17.5c2.2-1.5,4.7-2.4,7.2-3.4
		c7-2.6,14-5.3,21-7.9v-0.8c-3.8-3.5-6.7-7.8-8.9-12.5c-1.3-2.8-1.3-3.9-1.1-6.7c0.1-2.3,1.7-4.3-0.3-6.4c-1.4-1.6-3.9-1.4-6-1
		c-7,1.5-11.2,7.1-18.4,2.3c-5.1-3.4-3.2-8.6-4.5-13.5c-2-7.7-8.6-5.6-14.8-8.2c-0.3,1.5-2,2.6-3.6,2.3c1-1.1-0.4-3-1.9-3.1
		s-2.9,0.8-4.3,1.4c-3.9,1.7-8.7,1.2-12.2-1.4c-3.4-2.6-5.4-7-4.8-11.3c-1.8,1.8-4.8,0.2-6.5-1.6c-1.8-1.8-4.4-3.8-6.5-2.3
		c-2.9,2,0.3,6.6-0.6,10.1c-0.6,2.3-3,3.5-4.4,5.5c-2.7,3.5-1.5,8.4-0.8,12.8c0.8,4.3,0.6,9.7-3.2,11.9l0.2-0.1
		c0.6,1.7,0.8,3.5,0.5,5.3c-0.3,3.5-0.8,6.2-3.7,7.1L823.8,1091.1z"
      />
    </a>
    <a (click)="SelectCode('SE23')">
      <path
        [class.selected]="IsSelected('SE23')"
        id="SE23"
        d="
		M964.4,1200.5c-1-6.3,3.2-13,9.3-14.9c-3.6-3.9-5.9-9-6.4-14.3c3.4-2.1,6.7-4.7,8.8-8.1c2.2-3.4,3-7.8,1.5-11.5
		c-1.3-3.1-3.9-5.4-5.6-8.3c-3-5.1-2.3-12.1,1.6-16.5c1.4-1.7,3.3-3,4.1-5s-0.2-5-2.3-5c-1.8-0.1-3.2,1.8-5,1.7
		c-1.5-0.1-2.4-1.6-2.7-3.1s0.1-2.9,0.2-4.4c0.2-5-3.4-9.5-7.7-12c-4.4-2.4-9.4-3.3-14.4-4.1c1.1-3.7,0.2-8-2.3-10.8
		c-2.2-1.3-4.7,0.8-6.2,2.7c-3.4,4.3-5.8,9.4-7.1,14.7c-7,2.6-14,5.3-21,7.9c-2.5,0.9-5,1.8-7.2,3.4c-5.6,3.9-8.4,10.8-9.4,17.5
		c-0.8,5.6-0.8,11.5-2,17.1c-0.7,3-1.8,6-3.9,8.4c-2.1,2.3-5.3,3.8-8.3,3.2l-0.5-0.4c-0.2,3.5-1,7-2.5,10.1h-0.1
		c10.7-2.9,22.9,0.7,30.3,8.9c1.1-1.6,3.7-2,5.2-0.8s1.7,3.8,0.3,5.2c3.9,0.7,7.9,0.9,11.8,0.8c-1.2,0.1-0.4,10.1,0,11.2
		c1.5,3.9,5.6,5.3,8.1,8.5c1,1.3,2,2.6,3.5,3.1c4.1,1.3,6-2.2,8.6-4.4c1.6-1.3,2.9-1.8,4.5-2.7c1.4-0.7,4.4-2.7,6-2.9
		c4.3-0.8,4.5,4.1,7.4,5.3c0.8,0.3,1.7,0.4,2.9,0.4L964.4,1200.5z"
      />
    </a>
    <a (click)="SelectCode('SE6')">
      <path
        [class.selected]="IsSelected('SE6')"
        id="SE6"
        d="
		M964.2,1201.1c3.3-0.1,7.8-1.4,10.4-1.5c1.4-0.1,2.9-0.1,4.1,0.5c2.4,1.2,3.2,4.3,3,6.9c-0.2,2.7-1,5.3-0.8,8
		c0.3,2.7,2.1,5.5,4.7,5.5c-1.3,2-2.5,4-3.7,6c4.5,2.1,7.4,7.3,6.7,12.3l0.2,0.2l2-2c2.6-0.8,8.9-4.1,10.9-3.9
		c1.3,0.2,2.4,1.4,2.9,2.8c0.4,1.3,0.3,2.8,0.2,4.2c1.6-0.3,2.9,2,4.6,1.6c2-0.5,0.9-3.2,2.4-3.9c0.9-0.5,2.7,0,3.7,0.1
		s6.3,1.3,6.8,2.1c1.9,3,3.6,6.4,6,9c1.9-1.9,2.8-6.2,2.4-9.1c-0.2-1.1-0.5-2.2-0.3-3.3c0.7-5.6,5.6-4.3,9.7-4.4
		c1.7,0,3.8,0.4,5.1-1c1.6-1.8-0.6-6.8,3.8-6.3c9.8,1.1-0.9-4.8-3.3-6.7c-1.3-1.1-2.3-5.5-4.6-4.8c-1.7,0.6-1.3,3.8-2.9,4.2
		c-0.3,0.1-0.8,0-1.1-0.1c-3.8-1.1-3-2.9-1.3-5.5c0.8-1.3,1.6-2.9,2.8-4c1.6-1.4,3.9-1.8,5.7-3.1c1.6-1.3,2.9-3,4.4-4.4
		c0.4-0.5,6.1-6.6,6.4-6.5l8.7,5.4l5-3.3l8,2.7c0,0,5.2-7.5,3.6-5.5s8.4-3.3,8.4-3.3s5.2-2,7.4,0.6c2.2,2.5,5.8-9.7,5.8-9.7l2.4-3.4
		l13.1,1.5l-1.5-1.3c1.9-1.3,1.3-4.5-0.4-6.2c-1.7-1.7-3.9-2.7-5.5-4.5c-1.2-1.3-1.7-3.1-2.3-4.8c-3.1-8.8-8.6-16.7-15.5-22.9
		c-3.7-3.2-18.9-15.3-23.6-11.6c-5.5,4.4-4.6,6.2-11.4,1.7c-1.9-1.3-4-3-3.9-5.3c0.1-1,0.5-1.8,0.8-2.9c0.7-3.1-1.9-6.5-5.1-6.7
		c-2.6-3.1-7.6-3.9-10.9-1.7c-2.5,0-5.8-0.3-8.1-1.4c-2.1-1-2.9-3.2-5-4.1c-1.5-0.7-3.4-0.3-4.3,1.2c-0.9,1.5,0.2,3.2,1.4,4
		c-2.5,1.4-5.5-0.1-7.8-1.5c-2-1.3-4.2-2.8-6.6-2.6c-7.3,7.9-18.6,11.7-29.1,9.8l-1.6-0.7c1.2,1,1.6,3,0.9,4.5c-0.8,2-2.7,3.4-4.1,5
		c-3.9,4.4-4.6,11.4-1.6,16.5c1.7,2.9,4.4,5.2,5.6,8.3c1.5,3.7,0.7,8.1-1.5,11.5c-2.1,3.4-5.4,6-8.8,8.1c0.5,5.3,2.8,10.4,6.4,14.3
		c-6.1,1.9-10.3,8.6-9.3,14.9L964.2,1201.1z"
      />
    </a>
    <a (click)="SelectCode('SE24')">
      <path
        [class.selected]="IsSelected('SE24')"
        id="SE24"
        d="
		M773.3,1154.1c3.8-3.6,3.3-9.8,5.8-14.5c1.2-2.2,2.9-3.9,4.7-5.7c3.1-3,6.2-6,9.2-9.1c4.1-4,9.4-8.4,14.9-6.8
		c2.7,0.8,5.8,2.9,7.9,1c1.8-1.5,1.1-4.4,0.3-6.5c-1.2-3.2-2.4-6.3-3.6-9.5c-0.8-2-1.5-4.4-0.6-6.3c1-1.9,4.5-2.1,4.9,0
		c0.4-1.8,0.9-3.5,2.1-4.9c1.2-1.3,3.4-1.9,4.9-0.8l0.7-0.1c2.9-0.9,3.4-3.6,3.7-7.1c0.4-3.1-0.5-6.4-2.4-8.8
		c-2.7-3.3-7.1-5-9.2-8.7c-0.5-1-0.9-2-1.8-2.8c-0.8-0.8-2.3-0.8-2.9,0.1c-0.2,0.3-0.2,0.7-0.3,1c-0.8,2-3.9,2.1-5.5,0.6
		c-1.5-1.5-1.3-3.2-1.7-5.4c2.1-1.9,0.8-5.6,2.3-8c1.8-2.6,6.6-2.7,7-5.8c0.2-1.1-0.4-2.3-1.1-3.2c-1.1-1.5-2.4-2.8-4.2-3.3
		c-1.7-0.4-3.8,0.1-4.8,1.6c-1.7,2.6,0.5,6.7-1.7,8.9c-1.8,1.8-5,0.6-6.5-1.4c-1.4-2.1-1.9-4.7-3.1-6.9c-1.2-2.3-3.9-4.1-6.1-3.1
		l0.8-0.2c-0.7,2.1-3.2,3.5-5.3,2.9c0.7,4.8-0.6,9.8-3.4,13.7c-1.8,2.1-2,5.1-1.8,7.9c0.3,2.8,0.8,5.5,0.1,8.2
		c-0.8,2.7-3.4,5-6.1,4.4c-2-5.2-5.9-9.7-10.6-12.5l0.4,0.3c-0.6,4.3,1.4,8.9,5,11.3c-0.2,3-0.4,6.1-0.6,9.1
		c-4.2,2.5-5.8,8.7-3.2,12.9c2.8,4.5,9.1,6.7,10.2,11.9c0.8,4.4-2.6,8.1-5.5,11.5s-5.5,8.2-3.1,11.9c1.6-1.4,3.4-3,5.6-3.3
		s4.7,1.4,4.4,3.6c-0.3,2-2.6,3-4.2,4.3c-3,2.3-4.1,6.9-2.3,10.3c2.3-0.5,4.2,2.2,4.3,4.5L773.3,1154.1z"
      />
    </a>
    <a (click)="SelectCode('SE21')">
      <path
        [class.selected]="IsSelected('SE21')"
        id="SE21"
        d="
		M773.3,1154.1c3.8-3.6,3.3-9.8,5.8-14.5c1.2-2.2,2.9-3.9,4.7-5.7c3.1-3,6.2-6,9.2-9.1c4.1-4,9.4-8.4,14.9-6.8
		c2.7,0.8,5.8,2.9,7.9,1c1.8-1.5,1.1-4.4,0.3-6.5c-1.2-3.2-2.4-6.3-3.6-9.5c-0.8-2-1.5-4.4-0.6-6.3c1-1.9,4.5-2.1,4.9,0
		c0.4-1.8,0.9-3.5,2.1-4.9c1.2-1.3,3.4-1.9,4.9-0.8c1,0.8,1.3,2.1,2.3,3c2,2.2,5.6,1.1,8.5,0.3c2.9-0.8,7-0.3,7.4,2.7
		c0.4,3.3-4.6,5.3-4.3,8.6c0.4,4.1,8.5,4.7,7.7,8.7c1.1-2.1,4.4-1.3,5.9,0.5c1.4,1.8,1.9,4.4,3.4,6.1c1.4,1.8,4.9,2.5,5.9,0.3
		c1,3,3.3,5.6,6.1,7c-2.3,2.1-4.5,4.3-5.7,7.1c-1.2,2.9-0.8,6.5,1.8,8.4c4.8,3.4,5.2-2.8,9.1-1.8c1.9,0.5,3.2,2.3,3.9,4.2
		c4,8.9,2.8,22-5,28.5c-4.6,3.9-11.6,6.4-12.2,12.3c-0.4,5,4.2,10.7,0.8,14.4c0.6,3.3-1.9,6.8-5.2,7.3l-1,0.3
		c-1.7-1.1-3.5-2.3-5.5-2.3c-2-0.1-4.2,1.5-4,3.5c0.2,1.9,2.3,3.4,2.2,5.3c-0.3,2.3-3.6,2.9-5.6,1.7s-3.4-3.3-5.4-4.4
		c-1.3-0.7-3.1-0.7-4.3,0l0.1,0.1c-4.3-2.6-9.3-4-14.4-3.9c0.1-2.9,0.2-5.8-0.9-8.6c-1.1-2.8-3.4-5.1-6.3-5.4
		c-3.8-0.3-8.1,3-11.1,0.6c-1.8-1.4-1.8-4.2-0.8-6.2c0.9-2,2.4-3.8,3.4-5.8c3.2-6.9-1.3-14.8-6.1-20.6c-1.2,1.8-3.7,2.4-5.8,1.9
		s-3.9-1.9-5.5-3.3L773.3,1154.1z"
      />
    </a>
    <a (click)="SelectCode('SE26')">
      <path
        [class.selected]="IsSelected('SE26')"
        id="SE26"
        d="
		M941.4,1255.6l2.3-1.8l8.4-11.5l7.4-6.5c4.7-0.8,12-4.4,13.3,2.8c0.5,2.7-1.2,5.6-3.7,6.7c-0.3-2.4-3.9-3.5-5.5-1.8
		c2.5,4.9-3.2,5.4-3.4,9.3c-0.2,1.9,1,4,2.9,4.9c1.7,0.8,3.8,0.6,5.5-0.1c5.7-2.3,8.7-6.5,12.4-11l7.8-7.7l-0.2-0.2
		c0.7-5-2.2-10.2-6.7-12.3c1.2-2,2.4-4,3.7-6c-2.6,0-4.4-2.9-4.7-5.5c-0.2-2.7,0.7-5.3,0.8-8c0.2-2.6-0.6-5.7-3-6.9
		c-1.3-0.6-2.7-0.6-4.1-0.5c-3.4,0.2-10.2,2.4-13.3,1.2c-2.9-1.2-3.1-6-7.4-5.3c-1.6,0.3-4.6,2.3-6,2.9c-1.7,0.9-2.9,1.3-4.5,2.7
		c-2.7,2.2-4.5,5.7-8.6,4.4c-1.5-0.5-2.5-1.8-3.5-3.1c-2.5-3.2-6.6-4.6-8.1-8.5c-0.4-1.1-1.2-11.1,0-11.2c-3.9,0.2-8-0.1-11.8-0.8
		c1.3-1.4,1.2-3.9-0.3-5.2s-4.1-0.8-5.2,0.8c-7.4-8.2-19.6-11.7-30.3-8.9h0.1c-1.2,2.4-2.8,4.5-4.8,6.3c-4.6,3.9-11.6,6.4-12.2,12.3
		c-0.4,5,4.2,10.7,0.8,14.4c0.6,3.3-1.9,6.8-5.2,7.3l-1,0.3c2.3,1.5,4.8,3.1,6.4,5.5c1.6,2.3,2.2,5.6,0.7,8
		c6.7,3.2,12,9.3,14.4,16.3l0.3,0.2c3.8-1.8,8.6-0.8,11.6,2.1c3.9,3.9,4.4,10.7,8.9,14.1c2.6,1.9,6.2,2.2,9.1,0.8
		c2.9-1.4,4.8-4.5,4.8-7.7c2.3,0.3,4.2,2.1,5.5,4c1.4,2.1,5,9.4,8.2,6.3c1.8-1.8-2.3-6.4,2.9-6.5c1.8,0,3.5,1.2,5.1,2.2
		c2.9,1.8,7.2,2.9,10.5,1.9L941.4,1255.6z"
      />
    </a>
    <a (click)="SelectCode('SE20')">
      <path
        [class.selected]="IsSelected('SE20')"
        id="SE20"
        d="
		M870.3,1307.2c-2.2-12.8-2.9-25.7-2.3-38.6c0.1-1.8,0.3-3.7,1.3-5.1s3.3-2.2,4.6-1c-1.4,1.7,0.6,4.4,2.8,4.5s4.1-1.3,5.8-2.8
		c1.5-1.3,3.2-2.6,4-4.4s0.7-4.3-0.9-5.5c-1.8-1.4-4.6-0.6-6.6-1.8c-2.5-1.3-2.7-4.8-2.9-7.6c-0.2-2.1-0.7-4.1-1.4-6l0.3,0.2
		c3.8-1.8,8.6-0.8,11.6,2.1c3.9,3.9,4.4,10.7,8.9,14.1c2.6,1.9,6.2,2.2,9.1,0.8c2.9-1.4,4.8-4.5,4.8-7.7c2.3,0.3,4.2,2.1,5.5,4
		c1.4,2.1,5,9.4,8.2,6.3c1.8-1.8-2.3-6.4,2.9-6.5c1.8,0,3.5,1.2,5.1,2.2c2.9,1.8,7.2,2.9,10.5,1.9v-0.7l1.6,16.4
		c0.9,1.9,2.3,4,2.6,6c-2.5,0.3-5,0.8-7.4,1.6c-0.6,0.2-1.1,0.4-1.5,0.9c-2.5,2.9,3.3,10.2,4.8,12.8l-5.9,5.3l-10.4,9.8l-10.4,7.4
		l-4.3,6c1.1,2,2.9,4.2,3.6,6.3c1,3.3,0,4-0.8,7.3c-0.6,2.6-0.6,5.3-0.3,7.9l-0.4,0.7c-8.3-1.1-16.9-2.3-24.3-6.1
		c-7.4-3.9-13.8-10.9-14.4-19.3c-0.3-3.3,0.3-6.8-1.4-9.6c-0.7-1.1-1.7-1.9-2.9-2.3L870.3,1307.2z"
      />
    </a>
    <a (click)="SelectCode('SE19')">
      <path
        [class.selected]="IsSelected('SE19')"
        id="SE19"
        d="
		M774.4,1240.4c0.3-0.5,0.6-0.9,0.8-1.4c4.8-1.9,9.9-3.9,15-2.9c2.1,0.4,4.1,1.3,6.1,1.9c2.1,0.5,4.4,0.5,6.2-0.8s2.3-4.1,0.8-5.5
		c8.9-5.3,17.5-10.9,25.8-17c0.2-2.3,3.5-2.9,5.5-1.8c2,1.2,3.4,3.3,5.4,4.4s5.4,0.6,5.6-1.7c0.2-1.9-2-3.4-2.2-5.3
		c-0.2-2,2-3.6,4-3.5c2,0,3.9,1.2,5.5,2.3c2.3,1.5,4.8,3.1,6.4,5.5c1.6,2.3,2.2,5.6,0.7,8c8.6,4.1,14.8,12.8,15.8,22.3
		c0.3,2.8,0.4,6.2,2.9,7.6c2,1.2,4.8,0.3,6.6,1.8c1.6,1.3,1.8,3.7,0.9,5.5c-0.8,1.8-2.5,3.2-4,4.4c-1.7,1.4-3.6,2.9-5.8,2.8
		s-4.2-2.9-2.8-4.5c-1.3-1.2-3.6-0.4-4.6,1s-1.2,3.4-1.3,5.1c-0.7,12.9,0.1,25.8,2.3,38.6l0.1-0.3c-3.5-1.9-8.7-0.5-11.4,2.7
		c-3.4,4-3.9,9.7-4.2,14.9c-4.4-3.2-9.4-5.5-14.7-6.9c0.9-1.8,2.9-3.1,5-3.3c-2.4-9.5-12.3-16.5-22-15.8c0,4.9-2.2,9.7-5.8,12.8
		l0.3-1.2l-10.1-7.6l-6.2-4.4l-6-9.7l-10.7-5.5l-9.4-1.4l-1-0.6c0.3,0.2,0.6,0.3,0.8,0.4c-1.3-0.8-1.7-2.7-1.1-4
		c0.6-1.3,2.3-2.2,3.7-1.8c-6-6.1-8.1-15.8-5.2-23.8c-1.6-0.2-3.2-0.4-4.7-0.6c-0.6-3.1-1.2-6.2-1.7-9.3c2.9,1.5,6.8,0.6,8.8-2
		L774.4,1240.4z"
      />
    </a>
    <a (click)="SelectCode('SE27')">
      <path
        [class.selected]="IsSelected('SE27')"
        id="SE27"
        d="
		M771.1,1152.4c3.9,3.2,7.9,6.3,11.8,9.5c1.7,1.3,3.4,2.8,5.5,3.3s4.6-0.1,5.8-1.9c4.9,5.8,9.3,13.7,6.1,20.6
		c-0.9,2-2.4,3.8-3.4,5.8c-0.9,2-0.9,4.8,0.8,6.2c2.9,2.4,7.3-0.9,11.1-0.6c2.9,0.3,5.2,2.6,6.3,5.4s1,5.7,0.9,8.6
		c5-0.2,10.1,1.3,14.4,3.9l-0.1-0.1c-0.7,0.4-1.1,1-1.2,1.9c-8.3,6.1-17,11.7-25.8,17c1.6,1.4,1,4.3-0.8,5.5
		c-1.8,1.3-4.1,1.3-6.2,0.8c-2-0.6-4-1.5-6.1-1.9c-5.1-1-10.2,0.9-15,2.9c-0.3,0.5-0.6,0.9-0.8,1.4l0.4-0.4
		c-3.3-0.9-5.2-4.2-7.6-6.5c-2.4-2.3-7-3.6-8.9-0.8c-3.3-3.3-6-6.9-8.4-10.8c2.8-1.2,4.4-4.2,4.5-7.1s-0.8-5.9-2-8.6
		c-2.3-5.2-5.6-10.7-3.9-16.2c1.2-3.8,4.5-6.5,8.1-7.9c3.7-1.4,7.6-1.6,11.6-1.8c0.6-2.3-0.8-4.7-2.7-6l-0.8-0.9
		c2.6-2.9,5.1-5.9,7.7-8.8c-2.3-0.5-3.2-3.4-2.9-5.8s1.3-4.6,1.3-7L771.1,1152.4z"
      />
    </a>
    <a (click)="SelectCode('SE25')">
      <path
        [class.selected]="IsSelected('SE25')"
        id="SE25"
        d="
		M913.6,1346.5c0.6,2.3,3,5.5,2.8,7.8c-0.3,3.2-5.1,6.1-7.1,9c-1.8,2.5-2,5.4-2.9,8.2c-0.4,1.3-0.9,2.7-1,4
		c-0.5,5.2,4.4,8.2,2.2,12.5c-1.9,3.8-7,7.7-10.2,10.5c-3.6,3.2-8.9,3.7-9.6,9.9c0,0.3,0,0.5,0.1,0.7c0.2,0.3,0.6,0.3,0.9,0.3
		c2.3-0.3,4.6-0.6,7-0.8c-3,6.1-8.3,9-14.7,4c-1.3-1-3-2.3-4.4-1.5c-1.4,0.9-0.9,3.2-2,4.4c-5.6,7.2-8.1-8-8.7-10.6l2.2-9.7
		l-1.7-8.3l-5.8-7l-4.7-1.9l-1.8,6l-12.7,0.9l-6,9.7l-6,14.7l-6.5-4l-1.7-6.1l-5.7,0.3l0.2-9.4l-5.3-9.7l8.1-0.9l-6-10.9l4.4-6.9
		l-5.8-12.3l-1-8.7l4.1-9.5c0,0,2.9-11,3.5-12.3s-0.2-8.5-0.2-8.5l-0.3,1.2c3.6-3.2,5.8-8,5.8-12.8c9.7-0.8,19.6,6.3,22,15.8
		c-2.1,0.2-4,1.4-5,3.3c5.3,1.3,10.2,3.7,14.7,6.9c0.3-5.3,0.8-10.9,4.2-14.9s10.7-5.1,13.6-0.7c1.8,2.8,1.2,6.3,1.4,9.6
		c0.6,8.4,7,15.4,14.4,19.3s15.9,5,24.3,6.1L913.6,1346.5z"
      />
    </a>
    <a (click)="SelectCode('SW6')">
      <path
        [class.selected]="IsSelected('SW6')"
        id="SW6"
        d="
		M563.3,999.5c-3.1,12.8-6.6,26.2-15.9,35.5c-12.1,12.3-31.7,14.4-48.3,9.6c-16.5-4.8-30.7-15.4-44.3-25.9c-9-7-18.2-14.5-22.3-25.1
		c-3.9-10-2.8-21.1-1.5-31.7v-0.5c3.7-0.6,9-0.3,12.4-1.8c3.1-1.3,5.6-4.4,8.8-5.8c3.4-1.5,8-1.3,9.8,1.8c3.9,6.8,17.2,2.6,20.6-4.5
		l-0.3-0.9c3.3-1.5,7-0.9,10.7-1.5c3.5-0.6,7.5-3.4,6.8-6.9c2.4,1,6,1.7,7.1-0.7c1.6-3.2-3.7-6.9-1.8-9.9c-2.7-2.5-4.3-6-4.4-9.7
		h0.2c1.9-1,4.4-0.1,6,1.3c1.6,1.5,2.6,3.5,3.9,5.4c3.4,5.4,6.7,9.9,12.8,12.1c1.1,0.4,2.5,0.8,3.4,0l0.8,0.1
		c4.5,12.5,10.7,24.5,18.5,35.4c3.7,5.3,8,11.7,5.6,17.7c1.7-0.7,3.4,1.1,4,2.8s0.8,3.8,2.3,4.9c1.5,1.2,3.7,0.7,5.2-0.7v-1
		L563.3,999.5L563.3,999.5z"
      />
    </a>
    <a (click)="SelectCode('SW10')">
      <path
        [class.selected]="IsSelected('SW10')"
        id="SW10"
        d="
		M527.4,940.3c4.5,12.5,10.7,24.5,18.5,35.4c3.7,5.3,8,11.7,5.6,17.7c1.7-0.7,3.4,1.1,4,2.8s0.8,3.8,2.3,4.9c2,1.5,5.1,0.1,6.4-2.1
		c1.3-2.2,1.3-4.9,1.6-7.5c1-7,4.9-13.6,10.6-17.9c2.9-2.2,6.7-4.5,6.4-8.2c-0.2-2-1.6-3.6-2.9-5c-3.6-3.8-7.6-7.3-11.7-10.6
		c-2.3-1.8-5-4.9-3.3-7.3c1.9-2.8,6.2-0.5,9.5-1.3c2.9-0.7,4.5-4.2,3.4-6.8c-0.9-2-3.3-3-5.4-2.7l-1,0.3c-1.1,1.5-2.8,2.8-4.6,2.7
		c-3-0.1-4.8-3.3-6-6s-3.4-5.8-6.4-5.5l0.1-0.3c-1.8,3-5.3,4.6-8.7,5.3c-4.8,1-9.9,0.5-14.3,2.5c-2.3,1.1-5,2.2-4.3,5.2
		c0.3,1.1,0.6,2.4,0.2,3.4L527.4,940.3z"
      />
    </a>
    <a (click)="SelectCode('SW7')">
      <path
        [class.selected]="IsSelected('SW7')"
        id="SW7"
        d="
		M613,855.3c0.9,7.7-0.6,15.7-4.3,22.5c-1.8,3.2-4,6.3-7.3,8s-7.6,1.6-10.2-0.9c2,9.7,3.7,21.1-3,28.6c-4,4.4-10.5,6.6-13.6,11.8
		c-1.1,1.8-1.7,4-2.8,6c-1.1,1.9-2.9,3.6-5.1,3.5c-3-0.1-4.8-3.3-6-6c-1.3-2.7-3.4-5.8-6.4-5.5l0.1-0.3c1.8-3,1.4-7.5-1.6-9.3
		c-1.7-1-3.8,0.3-5.6,1.1s-4.8,0.5-4.8-1.5c0-0.8,0.6-1.6,1-2.3c1.9-3.7-1.7-8.9-5.8-8.3c-0.6,0-0.6,0-1.2,0c0-0.3,0-0.6,0-0.8
		l-0.2-0.1c0.5,0,0.9-0.2,1.4-0.3c2.2-1,3-3.8,2.5-6.1s-2.1-4.3-3.5-6.1c3.2,0.5,6.5,0.9,9.7-0.1c3.1-1,5.8-3.9,5.4-7.2
		c1.3,0.3,2.4-1.2,2.3-2.5c-0.1-1.3-0.9-2.4-1.7-3.5c-5.2-8.3-1.7-20.7,7-25.1c0.2-0.6,0.4-0.6,0.6-1.2l0.1-0.1
		c0.7,0.7,1.3,1.4,1.9,2.2c2.6,3.3,4.5,7,7.6,9.7s8,4.1,11.4,1.7c2.3-1.7,3.4-4.7,5.5-6.7c4-3.7,10.2-2.3,15.5-1.1
		c3.6,0.8,7.7,1.4,11.1,0.4L613,855.3z"
      />
    </a>
    <a (click)="SelectCode('SW5')">
      <path
        [class.selected]="IsSelected('SW5')"
        id="SW5"
        d="
		M505.6,901.9c4,0.3,7.5,2.6,11.6,0.8c3.1-1.3,5.6-4.3,9-4.3c3.5,0,6.9,3.4,10.2,3.2l0.2,0.1c0,0.3,0,0.6,0,0.8c0.6,0,0.6,0,1.2,0
		c4.1-0.5,7.7,4.6,5.8,8.3c-0.4,0.8-1,1.5-1,2.3c0.1,2,2.9,2.3,4.8,1.5c1.8-0.8,3.9-2.1,5.6-1.1c3,1.8,3.4,6.4,1.6,9.3
		c-1.8,3-5.3,4.6-8.7,5.3c-4.8,1-9.9,0.5-14.3,2.5c-2.3,1.1-5,2.2-4.3,5.2c0.3,1.5,0.8,3.3-0.4,4.3c-0.9,0.8-2.3,0.4-3.4,0
		c-6.1-2.1-9.4-6.7-12.8-12.1c-1.2-1.8-2.2-3.9-3.9-5.4c-1.6-1.5-4.1-2.3-6-1.3l-0.2-1.7c0.3-4.2,2.7-8.2,6.2-10.6
		c-3.4-1.3-6.6-2.7-10-4c0.4-1.8,2.1-3,3.9-3.4s3.6-0.3,5.5,0"
      />
    </a>
    <a (click)="SelectCode('SW3')">
      <path
        [class.selected]="IsSelected('SW3')"
        id="SW3"
        d="
		M611.4,871.2c-0.8,2.3-1.7,4.5-2.8,6.7c-1.8,3.2-4,6.3-7.3,8s-7.6,1.6-10.2-0.9c2,9.7,3.7,21.1-3,28.6c-4,4.4-10.5,6.6-13.6,11.8
		c-1.1,1.8-1.7,4-2.8,6l-0.3,0.8c0.3-0.1,0.4-0.1,0.7-0.2c2.1-0.3,4.5,0.8,5.4,2.7c1.2,2.6-0.5,6.2-3.4,6.8
		c-3.3,0.8-7.6-1.5-9.5,1.3c-1.7,2.4,1,5.5,3.3,7.3c4.1,3.3,8.1,6.8,11.7,10.6c1.3,1.4,2.8,3.1,2.9,5c0.1,0.6,0,1.3-0.2,1.8h0.1
		c8.9-3.5,18-3.6,27.4-3c5.8,0.3,11.6,2.5,17.5,1.7c6.5-1,10.4-7.3,14.3-11.9c-2.9-3.6-2.3-9.2-3.9-13.5c-2.3-5.8-5.7-11.2-9.8-16
		c-2.3-2.7-5-5.5-4.9-9.1c0.2-2.6,1.8-5,1.2-7.6c-1-3.4-5.5-3.9-8.9-3.9c-3.5,0.1-8-0.6-8.9-3.9c-0.6-2.3,0.9-4.5,2.6-6.1
		c1.8-1.6,3.9-2.9,5.1-4.8c1.3-2,1.2-5.1-0.8-6.2c-0.6-0.3-1.3-0.4-1.6-1c-0.7-0.9,0.3-2.3,1.3-2.4c1.1-0.3,2.2,0.3,3.2,0.8
		c1.9-0.9,2.9-3.3,2.3-5.4c-0.6-2-2.9-3.4-5-3.2l-2.1-1.3V871.2z"
      />
    </a>
    <a (click)="SelectCode('SW1')">
      <path
        [class.selected]="IsSelected('SW1')"
        id="SW1"
        d="
		M641.9,953.9c4.8-2.8,9.4-2.8,14.8-2c5.5,0.8,10.7,2.5,16.1,3.2c12.4,1.6,25.4-2.2,35-10.2s15.7-20.1,16.3-32.6
		c1.1-21.7,3.4-42.3,8.6-63.4c-1.8-0.6-3.5-1.2-5.3-1.8c-6.3,1.4-13.1,0.3-18.7-2.9c-1.3-1.4-0.5-4.2,1.4-4.7
		c-2.9-2.3-6.5-3.8-10.2-4c0.1-1.3,0.1-2.6,0.2-3.9c-16.4,2.4-31.1,14.4-36.8,30c-0.8,2.3-1.8,5.1-4,6.2c-9,4.5-23.1-7.3-27.3-14.2
		c-1.3-2.2-3.4-3.6-5.9-4.3c-2.2-0.6-5.5,0.1-7.4-0.9c0.1-0.5,0.8,1,0.2,0.4h-0.2c-0.3,1.3-0.8,2.6-1.6,3.7c-1.1,1.3-2.4,2.3-4,2.8
		v0.7c0.5,4.5,0.2,8.9-0.9,13l-0.2,1c0.8,0.5,1.2,0.8,2,1.3c2.1-0.3,4.3,1.2,5,3.2c0.6,2-0.4,4.4-2.3,5.4c-1-0.5-2.1-1-3.2-0.8
		c-1.1,0.3-1.9,1.6-1.3,2.4c0.3,0.5,1.1,0.7,1.6,1c2.1,1.1,2.1,4.2,0.8,6.2s-3.4,3.3-5.1,4.8c-1.8,1.6-3.2,3.9-2.6,6.1
		c0.9,3.4,5.4,4,8.9,3.9s8,0.5,8.9,3.9c0.8,2.4-1,5-1.2,7.6c-0.2,3.5,2.5,6.4,4.9,9.1c4,4.7,7.5,10.2,9.8,16
		C639.6,944.7,639,950.4,641.9,953.9z"
      />
    </a>
    <a (click)="SelectCode('SW14')">
      <path
        [class.selected]="IsSelected('SW14')"
        id="SW14"
        d="
		M303.3,995.1c7.2,6.4,15.2,13.1,24.8,13.8c6.3,0.4,12.3-1.8,17.4-5.6h0.5c1.4,5.9,1.8,12,3.3,18c1.3,5.3,3.7,10.6,7.7,14.1l0.6,0.8
		c-0.1,1.1-0.3,1.3-0.2,2.3c0.3,2.9-2.3,5.3-5,6.6c-2.6,1.3-5.6,2.5-7,5.1c-1.9,3.8,0.7,8.2,0.3,12.4c-0.4,3.8-3.2,6.9-5.5,9.8
		c-7.9,9.7-13.3,21.2-15.7,33.5h-0.9c-1.5-0.8-9,0.6-10.7,1.1c-6.3,1.8-7.5,5-13-1.4c-2.6-3-6.2-4.5-9.1-7.2
		c-2.8-2.6-5.4-5.9-7.9-8.8c-1.1-1.3-2-3.2-3.2-4.2c-1.8-1.5-4.4-1.8-5.8-3.7c-1.3-1.8-0.9-4.2-0.3-6.2c2.3-6.7,8.6-9.9,11.8-15.9
		c1.8-3.4,1.2-3.9,0.1-7.8c-0.8-2.4-1.3-5.1-0.1-7.4c1.4-2.7,5.1-3.9,5.7-7c0.3-1.7-0.5-3.3-1.3-4.8c-2.8-5.2-3.9-6.6-2.9-12.3
		c0.8-3.9,0.8-7.7,4.3-10.2c3.9-1.8,10.5-3.4,12.8-7.2c1.3-2.2,0.5-4.7-0.8-7.2L303.3,995.1z"
      />
    </a>
    <a (click)="SelectCode('SW13')">
      <path
        [class.selected]="IsSelected('SW13')"
        id="SW13"
        d="
		M433.9,997.1c-0.8,0.2-0.8,0.8-0.8,1.5c-9,1-17.5,5.8-23.2,12.8c-2.7,3.4-4.6,8.6-1.5,11.6c2.1,2.1,5.9,2,7.6,4.4
		c2.6,3.3-0.9,8.2-5,9.5c-3.3,1-6.8,0.5-9.8-1.1c-1.3-0.7-2.7-1.6-3.4-2.9c-0.5-0.8-0.2-2.6-1.4-2.9c-2.4-0.6-0.2,2.5,0.1,3
		c0.8,2,0.5,4.6-0.8,6.4c-1.8,2.6-5.8,3.7-8.4,1.8c-1.8-1.3-2.6-3.4-3.8-5.3c-1.2-1.8-3.3-3.5-5.4-2.9c-1.3,0.4-2.2,1.7-3.1,2.6
		c-4.3,4.4-11.7,4-16.8,0.5c-5-3.5-7.7-9.4-9.2-15.3s-1.8-12-3.3-18l0.2-0.5c3.7-2.9,7-6.6,9.4-10.6c6-9.6,8.6-20.8,12.5-31.4
		c3.9-10.6,8.3-20.6,18-26.5l0.3-0.4c5.2-3.9,14.9-4.7,21.2-4.6c7.4,0.2,14.4,4.4,18.5,10.5c1.3,2,7.9,21.1,4.7,21.7v0.5
		c-1.3,10.7-2.3,21.7,1.5,31.7c0.5,1.2,1,2.3,1.6,3.5L433.9,997.1z"
      />
    </a>
    <a (click)="SelectCode('SW15')">
      <path
        [class.selected]="IsSelected('SW15')"
        id="SW15"
        d="
		M345.7,1236.2c7.2-8.5,14.4-17,21.6-25.4c3.1-3.7,6.5-7.6,11.2-8.7c5.4-1.4,11.7,1,16.4-2c3.4-2.2,4.7-6.5,4.7-10.6s-1-8-1.2-12.1
		c-0.4-12.8,9.7-24.9,22.2-27c10.2-9.3,16.7-22.3,21.3-35.3c4.1-0.8,8.3-1.7,12.4-2.4c2-5.5,8.4-8.9,14.1-7.6
		c2.3,0.5,4.4,1.7,6.7,1.6c2.3-0.1,4.8-2.3,3.9-4.4c-3.4-0.9-3.4-6-0.8-8.5c2.4-2.4,6.1-3.1,9.2-4.4c5.6-2.4,10-7.6,11.7-13.4
		c0.4-1.4,0.7-2.9,1.8-3.9c1.5-1.3,3.8-0.8,5.8-0.8s4.4-1.6,3.8-3.4c-0.5-1.3-2-1.6-3.3-2c-4-1.3-6.9-5-8.5-8.8
		c-1.6-3.9-2-8.1-2.3-12.3l-1-0.8c-14.9-5.2-28-14.9-40.6-24.8c-7.9-6.2-16-12.8-20.7-21.6l-0.2,0.1c-0.8,0.2-0.8,0.8-0.8,1.5
		c-9,1-17.5,5.8-23.2,12.8c-2.7,3.4-4.6,8.6-1.5,11.6c2.1,2.1,5.9,2,7.6,4.4c2.6,3.3-0.9,8.2-5,9.5c-3.3,1-6.8,0.5-9.8-1.1
		c-1.3-0.7-2.7-1.6-3.4-2.9c-0.5-0.8-0.2-2.6-1.4-2.9c-2.4-0.6-0.2,2.5,0.1,3c0.8,2,0.5,4.6-0.8,6.4c-1.8,2.6-5.8,3.7-8.4,1.8
		c-1.8-1.3-2.6-3.4-3.8-5.3c-1.2-1.8-3.3-3.5-5.4-2.9c-1.3,0.4-2.2,1.7-3.1,2.6c-4.3,4.4-11.7,4-16.8,0.5l-0.9-0.3
		c-0.1,1.1-0.3,1.3-0.2,2.3c0.3,2.9-2.3,5.3-5,6.6c-2.6,1.3-5.6,2.5-7,5.1c-1.9,3.8,0.8,8.3,0.3,12.4c-0.6,4.1-3.5,7.4-5.5,9.8
		c-8.1,9.5-13.3,21.2-15.7,33.5c5,2.9,10.1,5.3,14.4,8.8c4.6,3.8,13.5,14.5,13.3,20.9c-0.2,6.5-12.3,16.1-17.1,19.9
		c-8.1,6.3-17.1,7.6-27,8.3c-10.4,0.8-14.9,7-5.8,15c6.8,6,11.2,13.3,17,20.1c3.2,3.7,9.1,3.4,12.2,6.9c3.7,4.4-0.3,8.1-1.8,12.3
		c-1,3.1-0.2,7-0.3,10.2c-0.2,3.2-1.3,5,1.4,8c2.3,2.5,4.7,2.7,7.6,2c2.5-0.6,3.9-2.1,5.7-2.3L345.7,1236.2z"
      />
    </a>
    <a (click)="SelectCode('SW18')">
      <path
        [class.selected]="IsSelected('SW18')"
        id="SW18"
        d="
		M464.3,1105.7c-1.5,3.2-3,6.4-4.5,9.6c0.8,0.3,1.7,0.8,2.5,1.1c0.1,1.4,0.2,2.8,0.3,4.2c0,2.3,3.1,3.3,5.5,2.9c2.3-0.3,5-1,6.8,0.6
		c1.1,1,1.3,2.5,1.9,3.9c1.7,3.9,6.4,6.3,10.5,5.2c3.2,4.5,1.4,10.7,0,16.1s-1.8,12.2,2.7,15.4c3.4,2.3,8.1,1.4,12-0.1
		c7-2.7,14.3-7.1,21.3-4.7c5.1,1.8,8.3,6.6,11.2,11.2c0.9,1.5,1.8,3.2,2.3,4.9l0,0c0.3-1.8,1.5-4.5,2.6-6c1.1-1.4,3.4-2,4.8-0.9
		c1,0.8,1.3,2,1.9,3.1c2.1,3.3,7.2,3.2,10.3,0.8c3.1-2.3,4.6-6.1,6-9.8c2.7,1.8,6.4,0.5,8.8-1.5c2.4-2,4.4-4.7,7.3-6.2
		c2.6-1.4,6.3-2.3,6.5-5.3c1.6,1.8,4.9,1.2,6.4-0.8s1.7-4.6,1.5-7s-0.8-4.9-0.4-7.3c0.7-4.6,4.4-8.2,6-12.6c2.6-7-0.4-14.9-3.4-21.7
		c-2.3-5.4-5-11.1-10-14.1c-2-1.3-4.6-2.2-5.3-4.4c-1.3-3.9,4.1-7.2,3.7-11.2c-0.2-2.2-2.1-3.9-4.3-4.5c-2.1-0.6-4.4-0.3-6.5,0
		c-2.9,0.4-6,1-8.5-0.3c-2.6-1.3-3.9-5.4-1.5-7c1.3-1.3,5.1-4.1,1.1-5.5c-1.6-0.5-3.4,0.3-4.6,1.3c-1.3,1.1-2.3,2.5-3.5,3.5
		c-1.3,1-3.3,1.5-4.7,0.7c-1.6-1-1.8-3.4-1-5.1c0.8-1.8,2.2-3.1,3.4-4.6c4.8-6.4-4.5-10.2-9.6-11.2l-0.8,0.6
		c-12.2,8.9-29.3,10.1-44,5.9l-2.8-0.4c0.4,4.2,0.8,8.5,2.3,12.3c1.6,3.9,4.4,7.5,8.5,8.8c1.3,0.4,2.8,0.8,3.3,2
		c0.7,1.8-1.8,3.4-3.8,3.4s-4.3-0.5-5.8,0.8c-1.1,0.9-1.4,2.5-1.8,3.9c-1.6,5.9-6,11-11.7,13.4c-3.2,1.3-6.8,2-9.2,4.4
		s-2.4,7.6,0.8,8.5c0.8,2.2-1.6,4.4-3.9,4.4c-2.3,0.1-4.4-1.1-6.7-1.6c-1.2-0.3-2.3-0.3-3.4-0.3L464.3,1105.7z"
      />
    </a>
    <a (click)="SelectCode('SW11')">
      <path
        [class.selected]="IsSelected('SW11')"
        id="SW11"
        d="
		M636.2,1093.8c-2.3-6.5-4.6-13.1-7-19.6c-0.7-2-1.7-4.2-3.6-4.9c-1.4-0.5-3.1,0-4.6-0.2c-2.5-0.3-4.5-2.3-5.5-4.6s-1.1-4.9-1.2-7.4
		c6.2-0.3,12.5-0.8,18.7-0.9c2.8-0.1,9.2,2,11-0.4c1-1.4-1.1-8.2-0.6-10.7c0.8-3.6,2-7.1,1.8-10.8c-0.3-5.1-3.4-9.6-4.4-14.6
		c-1.1-5.6,0.6-11.7,4.4-16c2.8-3,14.4-5.1,12.4-9.5c-0.2-0.3-3.4-2.3-4.1-3.2c-2.6-3.7-2.9-9.5-1.6-13.7c-5-2.2-10-4.9-15.1-6.5
		c-3-0.9-7.9-1.4-6.3-6.5l0.2,0.4c-1,0.5-2.1,0.9-3.3,1c-5.9,0.9-11.7-1.3-17.5-1.7c-9.4-0.6-18.5-0.5-27.4,3h-0.1
		c-0.7,2.7-3.8,4.7-6.2,6.5c-5.7,4.3-9.6,10.8-10.6,17.9c-0.3,2.6-0.3,5.3-1.6,7.5c-0.3,0.5-0.7,1-1.2,1.5l0.2-0.9
		c-3.1,12.8-6.6,26.2-15.9,35.5c-1.2,1.2-2.4,2.3-3.7,3.3l0,0c5,0.9,14.4,4.8,9.6,11.2c-1.2,1.5-2.6,2.9-3.4,4.6
		c-0.8,1.7-0.6,4.1,1,5.1c1.4,0.8,3.4,0.3,4.7-0.7s2.3-2.4,3.5-3.5c1.3-1.1,3-1.8,4.6-1.3c4,1.3,0.3,4.2-1.1,5.5
		c-2.3,1.7-1.1,5.8,1.5,7c2.5,1.3,5.6,0.7,8.5,0.3c2.2-0.3,4.4-0.6,6.5,0c2.2,0.7,4.1,2.3,4.3,4.5c0.4,4-5,7.4-3.7,11.2
		c0.7,2.3,3.3,3.2,5.3,4.4c5,3,7.6,8.7,10,14.1c2.6,5.9,5.1,12.4,4.3,18.5h0.1c0.4,0.1,1.3,0.2,1.7,0.3c0-0.2-0.1-0.3-0.1-0.4
		c-0.3-0.1,0.4,0.3,0.2,0.3c-0.7-0.3,3.2,1.1,5.9,0.6c2.6-0.5,5.1-3.1,4.4-5.7c-0.3-1.3-1.3-2.4-1.7-3.8c-0.7-3.2,2.8-5.5,5.7-7
		c6.6-3.2,13.3-6.4,19.9-9.6"
      />
    </a>
    <a (click)="SelectCode('SW8')">
      <path
        [class.selected]="IsSelected('SW8')"
        id="SW8"
        d="
		M727.3,999.9c7.3-3.7,11.5-11.4,15.2-18.7c2.3-4.7,4.8-9.3,7.1-14c0.8-1.4,1.4-3.3,0.4-4.5c-0.9-1.1-2.7-1.1-3.7-2
		c-1.1-0.9-1.2-2.6-1.8-3.9c-0.8-1.8-2.4-3.1-4.1-4.3c-7.7-5.5-15.4-11.1-23.2-16.6l-0.7-0.7c-2.4,3.7-5.4,7.1-8.8,10
		c-9.6,8-22.6,11.7-35,10.2c-5.5-0.7-10.7-2.3-16.1-3.2c-5.5-0.8-11.2-0.7-16,2.1l-1.9,3.7l-3.7,4l-4.3,2.4c-1.6,5,3.3,5.5,6.3,6.5
		c5.1,1.6,10.2,4.3,15.1,6.5c-1.3,4.2-1,10,1.6,13.7c0.7,0.8,3.9,2.9,4.1,3.2c2,4.4-9.7,6.5-12.4,9.5c-3.9,4.3-5.5,10.4-4.4,16
		c1,5,4.1,9.5,4.4,14.6c0,1.1,0,2.2-0.2,3.2l0.3,0.5c10.5-2.3,20.3-7.7,28-15.2c1.8-1.8,3.9-3.8,6.5-3.4c1.8,0.3,3,1.8,4.6,2.6
		c3.4,1.8,7.8,0.4,10.7-2.1c7.1-6,8.7-17.4,16.9-21.9c5-2.8,11.5-2.1,15.8,1.6L727.3,999.9z"
      />
    </a>
    <a (click)="SelectCode('SW12')">
      <path
        [class.selected]="IsSelected('SW12')"
        id="SW12"
        d="
		M667.9,1190.5c5.4-2.3,7.2-8.9,7.5-14.7c0.3-5.8-0.3-12,2.8-17c3.5-5.9,10.7-8.1,16-12.4c5.5-4.5,8.6-11.6,8.5-18.7
		c-0.1-2-0.4-4.1-1.7-5.5c-1.9-2.2-5.3-2.3-8.1-2.3c-5,0.1-10,0.2-14.9,0.2c-1.9,0-4.2-0.1-5.3-1.7c-1.6-2.3,1.3-2.3,1.7-3
		c0.8-1.4-0.6-1.4-1.3-2.3c-0.7-0.8-1.1-2-1.4-3c-0.8-2-1.1-4.2-1.6-6.3c-1-4.2-3.4-8.9-7.7-9.2c-3.4-0.3-6.2,2.3-8.8,4.5
		c-2.6,2.3-6,4.4-9.1,3.1c0.8-2.3,1.7-4.4,2.5-6.7c-3.4-2.1-7.6-2.6-11.4-1.4c-6.6,3.2-13.3,6.4-19.9,9.6c-2.9,1.4-6.4,3.8-5.7,7
		c0.3,1.3,1.3,2.4,1.7,3.8c0.7,2.6-1.8,5.2-4.4,5.7c-2.7,0.5-6.5-0.8-5.9-0.6c0.3,0.1-0.5-0.3-0.2-0.3c0,0.2,0.1,0.3,0.1,0.4
		c-0.4-0.1-1.3-0.2-1.7-0.3l-0.5,3.9c2.9,1.8,5.9,3.5,8.1,6c2.3,2.5,3.7,6,3,9.3c-0.5,2.3-1.8,4.3-2.3,6.5
		c-0.8,4.8,2.9,9.1,6.2,12.6c5.3-1.5,9.9-5.2,12.7-9.9c7.9,1,15.9,3.9,21.3,9.8c2.3,2.6,4.2,5.6,6,8.6c4.8,8.1,9.7,16.1,14.4,24.3
		H667.9z"
      />
    </a>
    <a (click)="SelectCode('SW20')">
      <path
        [class.selected]="IsSelected('SW20')"
        id="SW20"
        d="
		M352.3,1228.2c3.9,7,12.3,10.2,20.1,11c7.9,0.8,15.9-0.5,23.8,0c7.7,0.5,15.4,2.7,22.2,6.3c1.7,0.9,3.4,2,4.1,3.7
		c1.2,2.9-0.8,6-2.6,8.5c1.3,2.9,5.1,3.6,8.2,3.2s6.2-1.7,9.4-1.1c5.1,0.9,8.2,6,10.5,10.7s5,9.9,10.1,11.2
		c-1.9-3.4,0.8-8.1,4.7-8.6c3.9-0.5,7.6,2.9,8.1,6.7c0.5,3.9-1.9,7.7-5.4,9.6c6.8,0,13.5,3.7,17.1,9.4c1.3-0.2,2.6-0.3,3.9-0.5
		c-1,8.6,1,17.5,5.6,24.9l-3.4,5.6c-2.3,0-4.5,3-6.1,2.9c-1.4-0.2-1.4-2.3-2.9-2.5c-0.9-0.1-1.6,1-2.5,0.9c-0.4,0-0.8-0.3-1.2-0.6
		c-2.5-1.9-8.4-2.7-8.6,1.8c-0.1,2.1-2.5,3.1-4.5,3.5c-3.1,0.7-6,2.1-6.3,5.7c-0.1,1.7,3,1.8,1.5,3.8c-0.8,1.1-3,6.5-4.7,6.2
		c-0.3-0.1-0.7-0.3-1-0.3c-1.5-0.3-2.6,1.7-2.3,3.2c0.3,1.5,1.3,2.9,1.6,4.4c0.6,2.6-1,5.5-3.5,6.4c-0.5,0.2-1.1,0.3-1.5,0.7
		c-1.2,1-0.8,3-1.8,4.1c-0.7,0.8-2.4,0.9-2.9,1.5c-1.3,1.8-2.5,5.5-1.2,7.9c0.8,1.6,3.9,2.2,5.1,3.7c1.7,2,1.4,4.3-1.3,5
		c-2.4,0.6-3.1-1.9-5.1-2.4c-3.4-0.9-5.6,2.2-9,0.3c-3.6-2-8.2-5-8.9-9.1c-0.4-2.5,0.8-6,0.9-8.6c0.3-5.3-0.3-12.5-7.1-13
		c-0.3,0-0.7,0-0.9-0.3c-0.3-0.3-0.3-0.7-0.3-1.1c-0.2-2.9-0.3-5.9-0.4-8.8c-0.1-2.5-16.4-8.2-9.4-12.5c2.8-1.7,4.1-5,3-8.4
		c-1.2-3.6-6-3-8.2-0.8c-2.6,2.4,0,7.4-2.4,10.1c-0.9,1.1-2.5,1.4-3.9,1.3c-8.9-0.9-7.6-8.7-11.2-14.4c-2.8-4.5-14-6.4-14.6-12.1
		c-0.3-2.9,4.2-7.5,5.7-9.7c1.3-1.9,2.6-4.4,1.4-6.5c-1.3-2.3-4.4-2.2-7-1.7c-4,0.8-13.1,6.2-14.3-1.2c-0.3-1.8,1.4-3,2.3-4.5
		c2.1-3.3,0.9-7.8,2.9-11.2c0.5-0.8,1.2-1.5,1.7-2.3c2.2-3.3,2.3-7.6,4.3-10.9c0.8-1.4,2-2.6,2.7-4.1s0.6-3.5-0.7-4.5
		c-1.4-1.1-3.5-0.4-5.2,0.3c-3.2,1.3-4.3,1.8-5.7-1.8c-1.4-3.8-4.4-9.8-8.1-12c-0.8-0.5-1.5-0.7-2.1-0.8L352.3,1228.2z"
      />
    </a>
    <a (click)="SelectCode('SW19')">
      <path
        [class.selected]="IsSelected('SW19')"
        id="SW19"
        d="
		M352.4,1228.3c5-5.8,9.9-11.7,14.8-17.5c3.1-3.7,6.5-7.6,11.2-8.7c5.4-1.4,11.7,1,16.4-2c3.4-2.2,4.7-6.5,4.7-10.6s-1-8-1.2-12.1
		c-0.4-12.8,9.7-24.9,22.2-27c10.2-9.3,16.7-22.3,21.3-35.3c4.1-0.8,8.3-1.7,12.4-2.4c1.5-4.1,5.5-7,9.8-7.7l0.2,0.9
		c-1.5,3.2-3,6.4-4.5,9.6c0.8,0.3,1.7,0.8,2.5,1.1c0.1,1.4,0.2,2.8,0.3,4.2c0,2.3,3.1,3.3,5.5,2.9c2.3-0.3,5-1,6.8,0.6
		c1.1,1,1.3,2.5,1.9,3.9c1.7,3.9,6.4,6.3,10.5,5.2c3.2,4.5,1.4,10.7,0,16.1s-1.8,12.2,2.7,15.4c3.4,2.3,8.1,1.4,12-0.1
		c7-2.7,14.3-7.1,21.3-4.7c5.1,1.8,8.3,6.6,11.2,11.2c2.2,3.4,4.3,8.1,1.6,11.2c-1.2,1.3-3,2-4.3,3.2c-3.4,3.3-1.6,9.1,1.1,12.8
		c5,7.1,12.8,13.1,14,21.7c0.7,4.6-0.2,10.6,4,12.8c2.3-4.6,7.7-7.4,12.8-6.7s9.6,4.9,10.6,9.9c8.1,7.3,16.1,14.6,24.1,21.9
		c0.2,0.1,0.3,0.3,0.5,0.4l-1.1-0.2c-1.1-0.1-2,0.1-1.9,0.5c0.3,1.7,0.7,3.4,0.5,5c-0.6,8.4-17.2,4.3-16.5,12.9
		c0.1,1.7,1.2,3.1,1.8,4.6s0.8,3.6-0.6,4.6c-1.6-0.2-2.3-2.1-4-2.3c-0.1,3.6-4.3,5-4.4,8.4c-0.1,1.8,4.4,7-1.6,5.5
		c-8.4-1.9,0.8,5.3-4.9,7c-3.7,1.2-6.4-4.5-9.8-3.3c-4.4,1.5,1.2,6.6-2.5,9.3c-1.2,0.8-3,1.1-3.3,2.4c-0.6,3.1,5.3,8.6,7,10.7
		c-1.7,2.7-4.4,10.6-8.6,8.6c-1.3-0.6-2-1.8-2.8-2.9c-2.5-3.3-4.6-5.5-8-4.6c-2.2,0.5-4.7,2.5-6.7,3.6l-8.8,1.4c0,0-6.4,4-10.5,3.9
		c-4.1-0.2-12.8-2.9-12.8-2.9c-1.9,0.4-4.6,2.3-6.3,2.3c-2.4,0.1-4.8-4.3-4.1-4.3l3.4-5.6c-4.6-7.4-6.6-16.3-5.6-24.9
		c-1.3,0.2-2.6,0.3-3.9,0.5c-3.6-5.7-10.3-9.4-17.1-9.4c3.4-1.8,5.9-5.7,5.4-9.6s-4.2-7.2-8.1-6.7s-6.6,5.3-4.7,8.6
		c-5-1.3-7.8-6.5-10.1-11.2c-2.3-4.7-5.4-9.8-10.5-10.7c-3.2-0.6-6.3,0.7-9.4,1.1s-7-0.3-8.2-3.2c1.8-2.5,3.8-5.6,2.6-8.5
		c-0.8-1.7-2.4-2.8-4.1-3.7c-6.9-3.6-14.5-5.8-22.2-6.3c-7.9-0.5-15.9,0.8-23.8,0C364.6,1238.4,356.2,1235.1,352.4,1228.3
		L352.4,1228.3z"
      />
    </a>
    <a (click)="SelectCode('SW17')">
      <path
        [class.selected]="IsSelected('SW17')"
        id="SW17"
        d="
		M536.8,1176c0.3-1.8,1.5-4.5,2.6-6c1.1-1.4,3.4-2,4.8-0.9c1,0.8,1.3,2,1.9,3.1c2.1,3.3,7.2,3.2,10.3,0.8c3.1-2.3,4.6-6.1,6-9.8
		c2.7,1.8,6.4,0.5,8.8-1.5s4.4-4.7,7.3-6.2c2.6-1.4,6.3-2.3,6.5-5.3c1.6,1.8,4.9,1.2,6.4-0.8c1.5-1.9,1.7-4.6,1.5-7
		s-0.8-4.9-0.4-7.3c0.7-4.6,4.4-8.2,6-12.6l0.4,0.7c2.9,1.8,5.9,3.5,8.1,6c2.3,2.5,3.7,6,3,9.3c-0.5,2.3-1.8,4.3-2.3,6.5
		c-0.8,4.8,2.9,9.1,6.2,12.6c5.3-1.5,9.9-5.2,12.7-9.9c7.9,1,15.9,3.9,21.3,9.8c2.3,2.6,4.2,5.6,6,8.6c4.8,8.1,9.7,16.1,14.4,24.3
		c-3.9-2.3-9.2,0.2-11.6,4s-2.5,8.6-2.6,13.3c-0.1,3.2-0.2,6.4-0.2,9.7c-0.1,3.2-1.3,7.5-4.4,7.1c2.8,2,2.5,6.5,0.7,9.3
		c-1.8,2.9-4.8,5-6.8,7.7c-2.1,2.8-3.1,6.9-0.9,9.5c3,3.5,9.3,1.7,12.8,4.8c-2.9,1.8-5.8,3.7-8.7,5.5l-1.3,0.2l-8.3-2.9l-10.9-3.4
		c-2.8-0.8-9.1-4.8-9.2-0.6c0,0.9-0.4,6.5-0.8,6.9c-0.8,0.8-2,0.4-3.1,0.3c-1.9-0.4-3.9-0.3-5.7,0.4c-0.8,0.3-1.5,0.7-2.3,0.8
		s-1.8-0.3-2.1-1c-0.2-0.4-0.1-0.8-0.2-1.3c-0.1-1.1-1.4-1.9-2.7-2.3l-1.1-0.2c-8.2-7.4-16.4-14.9-24.6-22.3c-1-5-5.5-9.2-10.6-9.9
		s-10.5,2.1-12.8,6.7c-4.2-2.2-3.4-8.1-4-12.8c-1.2-8.6-9-14.6-14-21.7c-2.7-3.8-4.4-9.6-1.1-12.8c1.3-1.2,3.1-1.8,4.3-3.2
		c1.7-2,1.5-4.5,0.6-7L536.8,1176z"
      />
    </a>
    <a (click)="SelectCode('SW16')">
      <path
        [class.selected]="IsSelected('SW16')"
        id="SW16"
        d="
		M774.2,1281.2c0.3,0.2,0.6,0.3,0.8,0.4c-1.3-0.8-1.7-2.7-1.1-4c0.6-1.3,2.3-2.2,3.7-1.8c-6-6.1-8.1-15.8-5.2-23.8
		c-1.6-0.2-3.2-0.4-4.7-0.6c-0.6-3.1-1.2-6.2-1.7-9.3c2.9,1.5,6.8,0.6,8.8-2c-3.3-0.9-5.2-4.2-7.6-6.5c-2.4-2.3-7-3.6-8.9-0.8
		c-3.3-3.3-6-6.9-8.4-10.8c2.8-1.2,4.4-4.2,4.5-7.1s-0.8-5.9-2-8.6c-2.3-5.2-5.6-10.7-3.9-16.2c1.2-3.8,4.5-6.5,8.1-7.9
		c3.7-1.4,7.6-1.6,11.6-1.8c0.6-2.3-0.8-4.7-2.7-6s-4.4-1.8-6.6-1.8c-7.1-0.4-14.2,1.4-21.1,3.2c-3,0.8-6.4,1.6-9.3,0.3
		c-2.4-1.1-4-3.4-6-5.1c-3.9-3.2-9.1-4-14-4.3c-5-0.3-10.1-0.2-14.8-1.9c-5.4-2-6.5-5.8-8.8-10.6l-0.7-0.9c-2.4,1.6-4.5,3.4-6,5.9
		c-3,5-2.5,11.2-2.8,17s-2.1,12.4-7.5,14.7h0.4c-3.9-2.3-9.2,0.2-11.6,4s-2.5,8.6-2.6,13.3c-0.1,3.2-0.2,6.4-0.2,9.7
		c-0.1,3.2-1.3,7.5-4.4,7.1c2.8,2,2.5,6.5,0.7,9.3c-1.8,2.9-4.8,5-6.8,7.7c-2.1,2.8-3.1,6.9-0.9,9.5c3,3.5,9.3,1.7,12.8,4.8
		c-2.9,1.8-5.8,3.7-8.7,5.5l0.6,0.8c2.1,0.7,4.2,1.3,6.2,2c3.4,1.2,6.5,0.6,9.5,1.5c4.7,1.4,0,8.8-1.1,11.5c-1,2.6-1.5,5.8-0.8,8.6
		c0.5,1.9,3.2,4.1,0.8,5.9c-0.3,0.3-0.7,0.4-0.9,0.8c-0.6,0.8-0.2,2,0.6,2.6s1.8,0.7,2.9,0.7c18,0.5-3.2,12.6-2.9,13.1l5.5,9.7h7.6
		l5.5,1.5l6.4,6.5l10.7,5l11,1.8c2.8,4.5,8.6,9,8.7,14.6c0,1.5,0.1,3.4,1.5,3.9c1.3,0.3,2.3-0.9,2.9-2c3.3-5.3,7.9-7.1,12.2-11.5
		c0.7-0.7,1.5-1.4,2.4-1.3c0.8,0,1.3,0.6,2.1,0.7s1.5-0.5,2.2-0.9c2.3-1.4,3.7,0,6-0.2c3.2-0.2,3.6-0.9,6.2-2.5
		c4.3-2.5,4.4-5.1,6.9-9.2c0.6-0.9,4.1-4.1,4-4.8c-0.2-1.4-4.1-3.2-5.5-2.9c-4.2,1.2-2.9-1.4-4-4.3c-1.3-3.3-4.8-3-7.6-3
		c0.2-3,1.1-6.1,1.8-9.1l-3.9-10.7l15,0.1l13.4-2.9l2.9-5.3L774.2,1281.2z"
      />
    </a>
    <a (click)="SelectCode('SW9')">
      <path
        [class.selected]="IsSelected('SW9')"
        id="SW9"
        d="
		M750.8,963.8c3.3,1.8,7.5,1.8,10.8,0.2c1,6.5,7.8,10.3,13.7,13.3s12.4,7.7,12.2,14.4c-4.6,2.1-9.8,2.8-14.9,2
		c-1.6,4.4-3,9.9,0.3,13.1c1.3,1.3,3.4,2.3,3.4,4.1c0.1,1.9-2.1,3.8-1,5.4c0.7,0.9,2.1,0.9,3.1,1.3c2.6,1,2.9,4.6,2.5,7.5
		s-0.8,6.2,1.3,8c2.5-0.5,5.3,1.8,5.1,4.4c-0.1,2.6-3,4.7-5.5,3.9c0.7,4.8-0.6,9.8-3.4,13.7c-1.8,2.1-2,5.1-1.8,7.9
		c0.3,2.8,0.8,5.5,0.1,8.2c-0.8,2.7-3.4,5-6.1,4.4c-2-5.2-5.9-9.7-10.6-12.5l0.4,0.3c-3.9,1.4-8.6-1.4-9.4-5.5
		c-4.4,1.8-9.1,2.8-13.8,2.9c-1.3,0.2-2.6,0.3-4,0.3v-0.6c-1.6-5.7-4.5-12.4-10.4-12.9c-2.8-0.3-5.4,1.1-8.1,1.7
		c-2.7,0.6-6.1,0-7.1-2.5c-0.3-5.8-0.5-11.5-0.8-17.3c-0.1-1.7-0.1-3.5,0.9-4.9c1.1-1.4,2.4-0.7,3.9-0.2c0.1-2.2,0.2-3.6,1.6-5.3
		c1.3-1.4,3.1-2.4,4.7-3.6c5.3-3.8,8.9-9.7,10-15.9l-0.7,0.3c7.3-3.7,11.5-11.4,15.2-18.7c2.3-4.7,4.8-9.3,7.1-14
		c0.8-1.4,1.4-3.3,0.4-4.5L750.8,963.8z"
      />
    </a>
    <a (click)="SelectCode('SW4')">
      <path
        [class.selected]="IsSelected('SW4')"
        id="SW4"
        d="
		M645.4,1038c10.5-2.3,20.3-7.7,28-15.2c1.8-1.8,3.9-3.8,6.5-3.4c1.8,0.3,3,1.8,4.6,2.6c3.4,1.8,7.8,0.4,10.7-2.1
		c7.1-6,8.7-17.4,16.9-21.9c5-2.8,11.5-2.1,15.8,1.6c-1.1,6.3-4.7,12.2-10,15.9c-1.6,1.2-3.4,2.2-4.7,3.6c-1.4,1.7-1.5,3.1-1.6,5.3
		c-1.4-0.5-2.8-1.3-3.9,0.2c-1,1.3-1,3.2-0.9,4.9c0.3,5.8,0.5,11.5,0.8,17.3c1,2.5,4.4,3.1,7.1,2.5c2.7-0.6,5.3-1.9,8.1-1.7
		c5.9,0.5,8.8,7.2,10.4,12.9v0.1c-5.4-0.5-10.6-2.1-15.6-4.2c-1.3,4.1-5.3,7.3-9.6,7.6c2.9,19.8,0.5,40.2-6.7,58.8l-0.3-0.6
		c-1.9-2.2-5.3-2.3-8.1-2.3c-5,0.1-10,0.2-14.9,0.2c-1.9,0-4.2-0.1-5.3-1.7c-1.6-2.3,1.3-2.3,1.7-3c0.8-1.4-0.6-1.4-1.3-2.3
		c-0.7-0.8-1.1-2-1.4-3c-0.8-2-1.1-4.2-1.6-6.3c-1-4.2-3.4-8.9-7.7-9.2c-3.4-0.3-6.2,2.3-8.8,4.5c-2.6,2.3-6,4.4-9.1,3.1
		c0.8-2.3,1.7-4.4,2.5-6.7c-3.1-1.9-7-2.5-10.6-1.7v0.1c-2.3-6.5-4.6-13.1-7-19.6c-0.7-2-1.7-4.2-3.6-4.9c-1.4-0.5-3.1,0-4.6-0.2
		c-2.5-0.3-4.5-2.3-5.5-4.6s-1.1-4.9-1.2-7.4c6.2-0.3,12.5-0.8,18.7-0.9c2.8-0.1,9.2,2,11-0.4c1-1.4-1.1-8.2-0.6-10.7
		c0.5-2.4,1.2-4.8,1.6-7.2L645.4,1038z"
      />
    </a>
    <a (click)="SelectCode('SW2')">
      <path
        [class.selected]="IsSelected('SW2')"
        id="SW2"
        d="
		M701.3,1122.8c7.2-18.6,9.6-39,6.7-58.8c4.3-0.3,8.3-3.4,9.6-7.6c6.2,2.7,12.9,4.4,19.6,4.4c4.7-0.1,9.5-1,13.8-2.9
		c0.8,4,5.5,6.9,9.4,5.5c-0.6,4.3,1.4,8.9,5,11.3c-0.2,3-0.4,6.1-0.6,9.1c-4.2,2.5-5.8,8.7-3.2,12.9c2.8,4.5,9.1,6.7,10.2,11.9
		c0.8,4.4-2.6,8.1-5.5,11.5s-5.5,8.2-3.1,11.9c1.6-1.4,3.4-3,5.6-3.3s4.7,1.4,4.4,3.6c-0.3,2-2.6,3-4.2,4.3c-3,2.3-4.1,6.9-2.3,10.3
		c2.3-0.5,4.2,2.2,4.3,4.5c0,2.3-1,4.6-1.3,7s0.6,5.3,2.9,5.8c-2.6,2.9-5.1,5.9-7.7,8.8l-0.5,0.2c-1.7-0.8-3.6-1.1-5.4-1.1
		c-7.1-0.4-14.2,1.4-21.1,3.2c-3,0.8-6.4,1.6-9.3,0.3c-2.4-1.1-4-3.4-6-5.1c-3.9-3.2-9.1-4-14-4.3c-5-0.3-10.1-0.2-14.8-1.9
		c-5.4-2-6.5-5.8-8.8-10.6l-0.6-1c3.2-2.2,6.9-3.9,9.9-6.4c5.5-4.5,8.6-11.6,8.5-18.7c-0.1-2-0.8-3.9-1.7-5.5L701.3,1122.8z"
      />
    </a>
  </g>

  <g id="Thames">
    <g id="The_Thames">
      <path
        id="The_Thames_1_"
        fill="#FFFFFF"
        d="M256.5,939.5c-1.4-0.6-1.6-5.7-0.5-6.3c14.5,5.6,28.3,13.8,35.4,28.5
			c5.1,10.5,6.9,27.6,17.8,34.3c44.8,26.9,51.8-19.6,63.4-48.3c8-12.5,18-25.3,34.7-21.2c14.4,3.6,25.5,9.7,26.8,26.5
			c0.9,11.8-2.3,28.8,1.5,39.9c5.3,15.2,24.4,27.2,36.7,36.3c24.1,17.6,66.7,25,81.4-7c7-15.1,7.5-37.8,19.2-50
			c16.1-16.8,31.2-10.4,50.6-8.6c14.2,1.3,14.4-18.8,31-15.3c13.4,2.9,20.3,6.2,34.7,1.6c35.6-11.3,34.5-56.4,37.4-86.6
			c4.3-43.6,55.8-40.9,86.4-31.5c16.4,5,37.5,15.3,53.5,22c16.2,6.7,28.4,18.8,47,8c11.7-6.8,18.4-23.1,31.1-27.2
			c16.1-5.1,33.3,1.8,44.1,14.3c22.2,25.5-8.6,72.4,30,90.5c13.5,6.3,33.8,4.8,44.7-6.1c10.5-10.5-0.8-30.5-3.2-42.1
			c-3-15.1-5.5-29.2,9.8-37.8c16.9-9.6,31.7-6.6,44.6,7.7c10.9,12.3,17.3,22.2,34.8,25c18.1,2.8,36.1-2.7,54.1-3.6
			c30.9-1.6,74.4,8.8,94-24.1c9.9-16.6,11-30.4,32.2-37c26.1-8.1,42.7-24.1,66.8-35.6c24.8-11.8,48.6-9.9,73.1,1.3
			c5.2,2.3,15.9,4,16,11.5c0.1,11.8,1.3,25.8-2.7,37.2c-31.8-15.5-50.9-50.9-84.3-19.8c-29.9,27.9-68.5,11.6-89.8,50.7
			c-20.5,37.5-54.7,34.2-92.6,32.5c-30.4-1.3-86.4,14.2-104.6-20.2c-15.9-30.4-49.9-19.1-41,15.8c3.6,13.9,12.2,23.9,5.9,38.8
			c-7.1,17-31.7,24.6-48.5,22.7c-34.4-3.8-46.4-39.8-46-70.2c0.3-15.8,5-35.1-13.8-42.2c-21.1-8-27.3,7.2-40.9,19
			c-26.3,22.5-56,1.5-81.9-11.7c-23.2-11.8-75.2-26.8-98.3-11.7c-18.5,12.2-11.5,60-22.1,81.7c-4.7,30.8-46.7,44.8-72,34
			c-12.1-5.2-15.9,16-29.9,14.4c-15.5-1.8-33-8.3-45.1,6.5c-20.6,25.3-10.6,70.9-54.9,75c-33.9,3.4-65.2-17.6-84.1-40.1
			c-15.4-14.2-12.1-27.6-10.4-46.8c2.1-20.1-12.3-36.8-33.9-30.4c-34.7,14.2-11,83.3-73.2,75.7c-16.5-3.9-24-15.5-29.8-30.4
			C285.3,960.2,274.8,947.8,256.5,939.5C256,939.3,257.4,939.9,256.5,939.5z"
      />
    </g>
  </g>
</svg>
